export const cn = {
  app: {
    home: '主页',
    playerScout: '球员报告',
    playerComparison: '球员对比',
    playerRecruitment: '雷达',
    collections: '收藏',
    favoritePlayers: '最爱的球员',
    teamAnalytics: '球队分析',
    gameAnalysis: '比赛分析',
    seasonStats: '赛季数据',
    leagueTable: '联赛积分榜',
    scoresAndFixtures: '比分和赛程',
    notifications: '通知',
    administration: '管理',
    inbox: '收件箱',
    teamStats: '球队数据',
    blog: '博客',
    leagues: '联赛',
    squadBuilder: '阵容建造器',
    playerAlerts: '搜索提醒',
    searchAlerts: '搜索提醒',
    videoUploadTool: '视频上传工具',
    videoPlaylists: 'Playlists',
    uploadedGames: 'Uploaded games',
    favoriteTeams: 'Favorite Teams',
    arrigo: 'Arrigo',
    validateEvents: '验证事件'
  },
  playerRecruitment: {
    title: '球员表',
    subtitle: '深入了解球员的特点和统计数据',
    league: '联赛',
    selectedSeason: '选择的赛季',
    year: '年份',
    radar: '雷达',
    positions: '位置',
    numberOfPlayers: '球员数量',
    template: '模板',
    compareWith: '比较',
    previousPerformance: '过去的表现',
    xGames: '{0} 场比赛',
    average: '平均',
    leagueAverage: '联赛平均',
    selectSeason: '选择一个赛季',
    positionsPlayed: '出场位置',
    minMax: '最小值和最大值',
    top5Leagues: '五大联赛',
    infoMessage: '勾选一个赛季以应用赛季最小值和最大值',
    infoMessage2: '为所有球员选择相同的赛季',
    dataPer90MinText: '每90分钟数据',
    adjustToPossessionText: '* 根据控球率调整',
    text: '文本',
    lollipop: '棒棒糖图',
    polar: '极坐标图',
    noGamesBetweenDates: '在所选日期之间未找到比赛',
    radarTemplates: {
      Goalkeeper: '守门员',
      GoalkeeperCustom: '守门员定制',
      GoalkeeperCustom1: '守门员自定义1',
      GoalkeeperCustom2: '守门员自定义2',
      GoalkeeperCustom3: '守门员自定义3',
      GoalkeeperCustom4: '守门员自定义4',
      GoalkeeperCustom5: '守门员自定义5',
      GoalkeeperCustom6: '守门员自定义6',
      Defender: '后卫',
      DefenderCustom: '卫士定制',
      DefenderCustom1: '后卫自定义1',
      DefenderCustom2: '后卫自定义2',
      DefenderCustom3: '后卫自定义3',
      DefenderCustom4: '后卫自定义4',
      DefenderCustom5: '后卫自定义5',
      DefenderCustom6: '后卫自定义6',
      FullBack: '边后卫',
      FullBackCustom: '后卫定制',
      FullBackCustom1: '边后卫自定义1',
      FullBackCustom2: '边后卫自定义2',
      FullBackCustom3: '边后卫自定义3',
      FullBackCustom4: '边后卫自定义4',
      FullBackCustom5: '边后卫自定义5',
      FullBackCustom6: '边后卫自定义6',
      FullBackPredictive: '边后卫',
      Midfielder: '中场',
      MidfielderCustom: '中场定制',
      MidfielderCustom1: '中场自定义1',
      MidfielderCustom2: '中场自定义2',
      MidfielderCustom3: '中场自定义3',
      MidfielderCustom4: '中场自定义4',
      MidfielderCustom5: '中场自定义5',
      MidfielderCustom6: '中场自定义6',
      MidfielderPredictive: '中场',
      MidfielderDefensive: '后腰',
      MidfielderOffensive: '前腰',
      AttackingMidfielder: '攻击型中场',
      MidfielderWing: '边中场',
      Winger: '边锋',
      WingerCustom: '边锋定制',
      WingerCustom1: '边锋自定义1',
      WingerCustom2: '边锋自定义2',
      WingerCustom3: '边锋自定义3',
      WingerCustom4: '边锋自定义4',
      WingerCustom5: '边锋自定义5',
      WingerCustom6: '边锋自定义6',
      WingerOffensive: '攻击型边锋',
      Forward: '前锋',
      ForwardCustom: '转发自定义',
      ForwardCustom1: '前锋自定义1',
      ForwardCustom2: '前锋自定义2',
      ForwardCustom3: '前锋自定义3',
      ForwardCustom4: '前锋自定义4',
      ForwardCustom5: '前锋自定义5',
      ForwardCustom6: '前锋自定义6',
      ForwardPredictive: '前锋',
      WingBack: '边翼卫',
      WingBackCustom: '边后卫定制',
      WingBackCustom1: '边翼卫自定义1',
      WingBackCustom2: '边翼卫自定义2',
      WingBackCustom3: '边翼卫自定义3',
      WingBackCustom4: '边翼卫自定义4',
      WingBackCustom5: '边翼卫自定义5',
      WingBackCustom6: '边翼卫自定义6',
      WingBackMedia: '边翼卫社交媒体',
      FullBackMedia: '边后卫社交媒体',
      MidfielderMedia: '中场社交媒体',
      WingerMedia: '边锋社交媒体',
      ForwardMedia: '前锋社交媒体',
      PhysicalWingBack: '身体强壮的边翼卫',
      PhysicalForward: '身体强壮的前锋',
      PhysicalWinger: '身体强壮的边锋',
      PhysicalMidfielder: '身体强壮的中场',
      PhysicalFullBack: '身体强壮的边后卫',
      PhysicalDefender: '身体强壮的后卫',
      PhysicalWingBackLMO: '身体强壮的边翼卫',
      PhysicalForwardLMO: '身体强壮的前锋',
      PhysicalWingerLMO: '身体强壮的边锋',
      PhysicalMidfielderLMO: '身体强壮的中场',
      PhysicalFullBackLMO: '身体强壮的边后卫',
      PhysicalDefenderLMO: '身体强壮的后卫'
    },
    radarTemplatesWomen: {
      Goalkeeper: '守门员',
      Defender: '后卫',
      FullBack: '边后卫',
      FullBackPredictive: '边后卫',
      Midfielder: '中场',
      MidfielderPredictive: '中场',
      MidfielderDefensive: '后腰',
      MidfielderOffensive: '前腰',
      AttackingMidfielder: '攻击型中场',
      MidfielderWing: '边中场',
      Winger: '边锋',
      WingerOffensive: '攻击型边锋',
      Forward: '前锋',
      ForwardPredictive: '前锋',
      WingBack: '边翼卫',
      WingBackMedia: '边翼卫社交媒体',
      FullBackMedia: '边后卫社交媒体',
      MidfielderMedia: '中场社交媒体',
      WingerMedia: '边锋社交媒体',
      ForwardMedia: '前锋社交媒体',
      PhysicalWingBack: '身体强壮的边翼卫',
      PhysicalForward: '身体强壮的前锋',
      PhysicalWinger: '身体强壮的边锋',
      PhysicalMidfielder: '身体强壮的中场',
      PhysicalFullBack: '身体强壮的边后卫',
      PhysicalDefender: '身体强壮的后卫',
      PhysicalWingBackLMO: '身体强壮的边翼卫',
      PhysicalForwardLMO: '身体强壮的前锋',
      PhysicalWingerLMO: '身体强壮的边锋',
      PhysicalMidfielderLMO: '身体强壮的中场',
      PhysicalFullBackLMO: '身体强壮的边后卫',
      PhysicalDefenderLMO: '身体强壮的后卫'
    },
    radarDescription: {
      basicStatistics: {
        title: '基础统计',
        minutes: '分钟',
        goals: '进球',
        assists: '助攻',
        redCards: '红牌',
        yellowCards: '黄牌',
        games: '比赛',
        goalsReceived: '非点球失分',
        xGFaced: '对应的预期进球指数'
      },
      profiles: {
        3: {
          1: '脚下技术出色的守门员，无论是短传还是长传都很擅长。',
          2: '能够用脚踢球，在比赛开始时发挥重要作用，无论是短传还是长传都有良好的命中率。',
          3: '由于其传球指标，良好的步法使该配置文件成为一个有趣的选择。',
          4: '无论是在自己的场上还是在对手的场上，他的传球都很引人注目。',
          5: '球在他脚下的安全感很强，传球技巧也很高。',
          6: '良好的脚法，在发球时提供安全保障，并完成高比例的短传和长传。',
          7: '无论是短传还是长传，完成率都很高，保证了循环质量。'
        },
        5: {
          1: '擅长一对一防守并能完成大量抢断和拦截的后卫。',
          2: '在个人对抗中非常有效的中后卫，无论是在上方还是铲球中，都有很好的阅读能力。',
          3: '中卫在个人防守对抗中表现出色，这转化为大量的回收量。',
          4: '防守水平高，能够通过铲球和拦截夺回大量球。',
          5: '在铲断和拦截方面防守非常有效，在个人对抗中表现出色。',
          6: '场均抢断次数多的中后卫，善于阅读对手比赛并切入，铲断精度高、频率高。',
          7: '由于铲断的有效性和频率以及良好的预测阅读能力，防守能力具有大量的恢复能力。'
        },
        6: {
          1: '对机会的创造有巨大贡献并具有良好的比赛视野的后卫。'
        },
        7: {
          1: '在进攻（在xG Buildup中有巨大贡献）和防守（反抢次数高）方面表现平衡的球员。'
        },
        8: {
          1: '在防守一对一中表现稳固，反抢次数很高，无论是抢断还是拦截都是如此。'
        },
        9: {
          1: '在进攻端制造威胁和创造机会方面有巨大贡献的球员。'
        },
        10: {
          1: '能够覆盖大量空间，能够在反抢中做出贡献，并且在xG Buildup方面占据球队总创造机会的相当大比例的全面球员。'
        },
        11: {
          1: '尽管对进攻影响较小，但防守表现出色且传球成功率高的中场。'
        },
        12: {
          1: '在创造机会和空中表现贡献高，并且拦截和抢断次数很多的全面中场。'
        },
        15: {
          1: '擅长一对一并且传中完成率高的边锋，产生的预期助攻会比射门多。'
        },
        16: {
          1: '直塞球和推进传球次数多的球员，也能创造机会，在中路控球中比边锋更有影响力。'
        },
        17: {
          1: '盘带技术好的球员，他们的动作旨在内切以产生比关键传球（xA）更多的射门次数（xG）。'
        },
        18: {
          1: '无球时表现出色的前锋，知道何时选择射门终结或何时传球。'
        },
        22: {
          1: '具有很大的活动范围以接应直塞球，回撤到边路并创造大量机会的前锋。与每场比赛总触球数相比，在禁区外触球的占比很高。'
        }
      },
      description: '描述',
      conjuction: ' 和 ',
      conjuction2: ' 和 ',
      over: '超过',
      under: '低于',
      respectively: '分别',
      Defending1: {
        1: '他的防守表现在顶级五大联赛中属于最差的'
      },
      Defending2: {
        1: '防守表现不佳，因为整体表现低于平均水平'
      },
      Defending3: {
        1: '整体表现中等，水平略高于平均水平'
      },
      Defending4: {
        1: '在防守方面表现出色，表现高于平均水平'
      },
      Defending5: {
        1: '在防守任务方面表现出色，其表现与顶级五大联赛中player_positions最佳球员相似'
      },
      Saving1: {
        1: '门将表现非常糟糕，封堵射门很困难'
      },
      Saving2: {
        1: '由于他的水平低于平均水平，因此他作为门将的表现不佳'
      },
      Saving3: {
        1: '门将表现还可以，在顶级五大联赛的平均水平上，需要改进metric_name'
      },
      Saving4: {
        1: '门将水平良好，高于顶级五大联赛的平均水平，特别突出的是metric_name '
      },
      Saving5: {
        1: '是一名非常全面的球员，他所有的表现数据都将他置于与欧洲顶级五大联赛中的门将相比的Top 20%之内。'
      },
      Passing1: {
        1: '拿球时他的水平属于最差的球员之一'
      },
      Passing2: {
        1: '就传球而言，他们的表现低于平均水平'
      },
      Passing3: {
        1: '传球水平可接受，略高于over_under_average '
      },
      Passing4: {
        1: '传球水平非常好，远高于平均水平'
      },
      Passing5: {
        1: '传球效率极高，表现优于大多数球员'
      },
      Aerial1: {
        1: '在空中对抗中非常弱的球员，在这方面属于他同位置球员中最差的'
      },
      Aerial2: {
        1: '就赢得空中对抗而言，球员表现不佳，低于平均水平'
      },
      Aerial3: {
        1: '在空中争顶中表现可接受，略高于over_under_average '
      },
      Aerial4: {
        1: '在空中争顶中表现出色，具有很高的成功率'
      },
      Aerial5: {
        1: '他在空中争顶方面的数据将他置于最佳之列'
      },
      Shooting1: {
        1: '在进球方面统计数据非常差，是最差球员之一'
      },
      Shooting2: {
        1: '射门水平有待提高，低于平均水平'
      },
      Shooting3: {
        1: '在进攻表现中还可以，略over_under_average于平均水平 '
      },
      Shooting4: {
        1: '在禁区内表现非常好，表现优于60%的球员'
      },
      Shooting5: {
        1: '在进攻任务方面具有出色的技术，表现出色，将其置于最佳之列'
      },
      Association1: {
        1: '他人球结合的表现非常低，属于顶级五大联赛中最差的'
      },
      Association2: {
        1: '由于其在这方面的表现低于平均水平，因此需要在脚下控球方面有很大的提高'
      },
      Association3: {
        1: '人球结合良好，略over_under_average于平均水平'
      },
      Association4: {
        1: '人球结合水平非常好，呈现出非常出众的水平'
      },
      Association5: {
        1: '脚下控球的能力非凡，在最佳球员之列'
      },
      BallHandling1: {
        1: '控球表现极差，与顶级五大联赛相比属于最差的'
      },
      BallHandling2: {
        1: '就控球而言，他的水平低于平均水平'
      },
      BallHandling3: {
        1: '控球水平尚可接受，略over_under_average于平均水平'
      },
      BallHandling4: {
        1: '在控球方面水平很高，数据接近最佳'
      },
      BallHandling5: {
        1: '控球能力出色，在顶级五大联赛中属于最佳之列'
      },
      Crosses1: {
        1: '将球传入禁区的表现较差。在传中指标方面属于最差球员之一'
      },
      Crosses2: {
        1: '传中创造威胁的表现低于平均水平'
      },
      Crosses3: {
        1: '将球传入禁区的水平尚可接受，略over_under_average'
      },
      Crosses4: {
        1: '传中数据良好，较高于平均水平'
      },
      Crosses5: {
        1: '将球传入禁区的表现非常出色，具体而言，在这一类型球员中最出色的前20%之列'
      },
      Carries1: {
        1: '他在运球方面表现属于最差的20%的球员水平'
      },
      Carries2: {
        1: '他的运球表现远低于他同位置的球员的平均水平'
      },
      Carries3: {
        1: '在运球方面，表现接近平均水平，略over_under_average '
      },
      Carries4: {
        1: '出色的球员，具有非常好的运球突破数据'
      },
      Carries5: {
        1: '运球非常有天赋，运球带球的相关指标表现数据很好'
      },
      Turnovers1: {
        1: '他的表现非常糟糕，丢球非常多，使对手更容易制造威胁。在这一指标中属于最差的球员之一'
      },
      Turnovers2: {
        1: '众多危险的丢球使对手受益，需要大幅改进并减少这些失误'
      },
      Turnovers3: {
        1: '这位球员在失误丢球方面略over_under_average，因此他的表现仍有改进空间'
      },
      Turnovers4: {
        1: '在丢球数据方面表现很不错，比60%的球员失误丢球次数都要更少'
      },
      Turnovers5: {
        1: '值得注意的是他很少失误丢球，这使他成为球队控球方面最佳球员之一'
      },
      SequenceInvolvement1: {
        1: '就控球而言，数据表现不佳，进攻很少以射门结束'
      },
      SequenceInvolvement2: {
        1: '控球后的处理还有待提高，控球几乎不以射门结束，这使整体表现远低于平均水平'
      },
      SequenceInvolvement3: {
        1: '在面对球门完成射门结束控球这一方面水平尚可接受，略over_under_average于平均水平，有很大的改进空间'
      },
      SequenceInvolvement4: {
        1: '以射门结束控球的能力良好，其中一些能够以进球结束，因此在这一项数据中表现出色'
      },
      SequenceInvolvement5: {
        1: '在终结进攻方面表现出色，能够以射门结束进攻并制造威胁'
      },
      OutPlay1: {
        1: '我们可以看出，该球员在扰乱防守结构方面影响很小'
      },
      OutPlay2: {
        1: '他在推进和打破防线方面的贡献低于该位置的标准'
      },
      OutPlay3: {
        1: '偶尔能够创造优势，表现接近该位置的平均水平'
      },
      OutPlay4: {
        1: '经常打破防线并制造防守失衡'
      },
      OutPlay5: {
        1: '在消除对手和推进进攻方面，是该位置表现最出色的球员之一'
      },
      LineBreakingPasses1: {
        1: '很少尝试或完成打破防线的传球，在这类动作中的贡献极其有限'
      },
      LineBreakingPasses2: {
        1: '很难稳定地找到防线之间或压迫身后的队友，贡献低于该位置标准'
      },
      LineBreakingPasses3: {
        1: '偶尔会送出打破防线的传球，在这方面接近该位置的平均水平'
      },
      LineBreakingPasses4: {
        1: '我们可以看出，该球员经常用传球打破防线并帮助撕开对手的防守阵型'
      },
      LineBreakingPasses5: {
        1: '在联赛中，他凭借打破防线和化解压迫的传球能力名列前茅，这是其主要优势之一'
      },
      PassUnderPressure1: {
        1: '当对手逼近时，在保持冷静或有效性方面存在困难'
      },
      PassUnderPressure2: {
        1: '在高压情况下很难保持传球准确率'
      },
      PassUnderPressure3: {
        1: '在压力下传球方面接近平均水平，能合理应对压力，但执行并非总是干净利落'
      },
      PassUnderPressure4: {
        1: '在压力下仍能经常找到队友，在这类传球中表现高于平均水平'
      },
      PassUnderPressure5: {
        1: '在强压下传球表现出极佳的沉着与准确度，在这方面属于位置上的顶尖球员'
      },
      BallReceived1: {
        1: '在前场接球次数很少；不是经常在防线之间活动的球员'
      },
      BallReceived2: {
        1: '在对方半场有一些无防守接球，但缺乏稳定性'
      },
      BallReceived3: {
        1: '在进攻区域无干扰接球的次数属中等水平'
      },
      BallReceived4: {
        1: '经常在防线之间或无压迫区域接球'
      },
      BallReceived5: {
        1: '在防线之间接到很多球，处于无防守压力的关键区域'
      },
      OnBallPressure1: {
        1: '很少施压，几乎不在持球队员附近逼抢。不是一个强度高的球员'
      },
      OnBallPressure2: {
        1: '偶尔有强力逼抢，但频率不高，总体强度较低'
      },
      OnBallPressure3: {
        1: '在持球对手附近的逼抢次数中等'
      },
      OnBallPressure4: {
        1: '是个纪律性强的逼抢者，经常接近持球队员'
      },
      OnBallPressure5: {
        1: '无球时强度很高，非常自律，并努力逼抢对手'
      },
      SpatialCoverage1: {
        1: '在占据和控制空间方面贡献非常有限，对球队阵型和战术结构的参与度极低。无论在进攻还是防守阶段，空间覆盖都很差，对团队组织的影响很小'
      },
      SpatialCoverage2: {
        1: '空间覆盖低于平均水平，在占据场地方面有一定参与，但在位置连续性和与球队的协同性上存在不足。对战术结构的影响不稳定'
      },
      SpatialCoverage3: {
        1: '空间覆盖中等，能稳定地参与空间占据和控制。站位通常正确且功能性强，在攻防阶段都有中等影响'
      },
      SpatialCoverage4: {
        1: '空间覆盖高于平均水平，积极参与场地占据和球队的阵型结构。能够保持阵型并适应攻守转换，对紧凑性和关键区域控制有显著贡献'
      },
      SpatialCoverage5: {
        1: '空间覆盖极佳，通过优化站位来决定性地影响球队阵型和战术结构。理解比赛并与整体配合良好，最大化占据战略空间'
      },
      OffBallPressure1: {
        1: '无球时施加的防守压力非常有限，很少干扰对手或迫使其失误。对逼抢和防守结构的贡献极小'
      },
      OffBallPressure2: {
        1: '无球时的防守压力低于平均水平，偶尔干扰对手但时间点或站位不稳定，对抢回球权的影响有限'
      },
      OffBallPressure3: {
        1: '无球时防守压力中等，能稳定地参与防守。站位和时机通常有效，能限制对手选择'
      },
      OffBallPressure4: {
        1: '无球时的防守压力高于平均，经常打乱对手行动并减少其时间和空间，防守配合良好'
      },
      OffBallPressure5: {
        1: '无球时防守压力极强，不断骚扰对手、迫使失误并限制传球路线，强度、站位和预判能力显著提升球队防守效果'
      },
      Distance1: {
        1: '覆盖的跑动距离明显少于平均水平（场上活动范围很小）'
      },
      Distance2: {
        1: '场均跑动距离低于顶级足球常见水平（活动性低于平均）'
      },
      Distance3: {
        1: '跑动距离合理，接近联赛平均（身体参与度平衡）'
      },
      Distance4: {
        1: '稳定覆盖较高跑动距离，体现出良好的耐力（身体输出强）'
      },
      Distance5: {
        1: '身体输出极佳，在五大联赛中跑动距离名列前茅'
      },
      Sprint1: {
        1: '与平均相比高速冲刺次数很少（比赛中冲刺努力最少）'
      },
      Sprint2: {
        1: '冲刺频率低于该位置平均水平（高速动作爆发力有限）'
      },
      Sprint3: {
        1: '场均冲刺次数中等，接近联赛平均'
      },
      Sprint4: {
        1: '冲刺频率远高于平均，爆发力稳定，整场比赛都有高速跑动'
      },
      Sprint5: {
        1: '90分钟冲刺次数位列前20%的球员，重复高速冲刺能力顶尖'
      },
      Acceleration1: {
        1: '变速能力明显低于平均，比赛中几乎没有爆发性加速'
      },
      Acceleration2: {
        1: '与类似球员相比，加速次数少于平均，短距离爆发频率低'
      },
      Acceleration3: {
        1: '加速次数接近联赛平均，变速不突出，但数据正常'
      },
      Acceleration4: {
        1: '快速且频繁加速的能力很强，加速频率明显高于平均'
      },
      Acceleration5: {
        1: '重复加速能力位列前20%，在启动和变速数据上远高于平均'
      },
      Speed1: {
        1: '可能速度较慢，或在比赛中保留高强度的努力'
      },
      Speed2: {
        1: '最高速度略低于竞争平均水平'
      },
      Speed3: {
        1: '比赛中保持平均的最高速度'
      },
      Speed4: {
        1: '经常达到高速，说明他速度快且力量强'
      },
      Speed5: {
        1: '最高速度极高，在速度方面可能是决定性因素'
      },
      LineBreakingCarries1: {
        1: '很少通过带球突破防线，在推进方面缺乏主动性'
      },
      LineBreakingCarries2: {
        1: '偶尔有带球突破防线，但不稳定'
      },
      LineBreakingCarries3: {
        1: '成功带球突破防线的次数中等'
      },
      LineBreakingCarries4: {
        1: '经常带球越过防线，支持进攻推进'
      },
      LineBreakingCarries5: {
        1: '带球突破专家，持续且大量地打破防线'
      },
      LineBreakingActions1: {
        1: '打破防线的动作（传球和带球）很少，很少冒险'
      },
      LineBreakingActions2: {
        1: '偶尔有推进动作（传球和带球），但不频繁，更多横向传球'
      },
      LineBreakingActions3: {
        1: '经常结合传球和带球突破防线，推动进攻'
      },
      LineBreakingActions4: {
        1: '技术和智慧兼备，能频繁制造打破防线的动作'
      },
      LineBreakingActions5: {
        1: '推进专家，经常通过传球和带球打破防线，对球队有巨大影响'
      },
      OffBallRuns1: {
        1: '无球时很少有主动跑动，对进攻支持有限，很少创造空间或扰乱防线'
      },
      OffBallRuns2: {
        1: '无球时的跑动低于平均，偶尔支持进攻但缺乏一致性'
      },
      OffBallRuns3: {
        1: '无球时的有意跑动属平均水平，能适时创造空间并支持团队进攻'
      },
      OffBallRuns4: {
        1: '无球时活动量高于平均，经常进行扰乱防线并创造传球选择的跑动'
      },
      OffBallRuns5: {
        1: '无球跑动的高手，常能预判比赛并做出聪明的跑位以最大化进攻机会'
      },
      OverMaxValue: {
        1: '他在over_max_metric_name方面具有极其出色的能力，表现高于最大值， 这使得这位球员在这方面处于顶级五大联赛的前10%'
      },
      OverAverageSeason: {
        1: '关于他在over_average_metric_name方面的表现，他高于league_name联赛的平均水平（over_average_metric_value vs average_metric_value）',
        2: '如果将他的数据与league_name联赛的数据进行比较，在over_average_metric_name方面，可以说他的表现高于平均水平（over_average_metric_value vs average_metric_value）'
      },
      UnderMinValue: {
        1: '就under_min_metric_name而言，他应该大大提高其表现，因为他目前属于顶级五大联赛中最低的percent_metric_name之内'
      },
      Over70Percent: {
        1: ', 特别是在over_70_metric_name方面表现出色，每90分钟分别为over_70_metric_value',
        2: ', 在over_70_metric_name方面超过70%的球员，每90分钟分别为over_70_metric_value',
        3: ', 在over_70_metric_name方面表现出色，每90分钟分别为over_70_metric_value'
      },
      Under30Percent: {
        1: ', 在under_30_metric_name方面需要更加努力，因为每90分钟分别为under_30_metric_value，他的表现较差',
        2: ', 需要在under_30_metric_name方面显著改进，因为每90分钟分别为under_30_metric_value，其表现低于预期',
        3: ', 就under_30_metric_name而言，每90分钟分别为under_30_metric_value，他必须更加努力才能获得更好的表现数据'
      },
      OverAverageSeasonMoreThanOne: {
        1: '值得强调的是，他们的表现超过了league_name联赛的平均水平在'
      },
      OverAverageStats: {
        1: 'over_average_metric_name（平均over_average_metric_value vs average_metric_value）'
      },
      Over70PercentIndividualPressure: {
        1: ', 为夺回球权而进行非常出色的个人压迫',
        2: ', 对对手施加高压以夺回球权'
      },
      Under30PercentIndividualPressure: {
        1: ', 必须加强施压压力以更多地夺回球权',
        2: ', 在施压对手方面必须付出更多努力'
      }
    },
    himSelf: '他自己',
    ownSeason: '本赛季',
    minMaxTooltip: '拟合雷达图的最小值和最大值',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: '登录',
    latestBlogPosts: '最新博客文章',
    signIn: '登录',
    username: '用户名',
    password: '密码',
    passwordForgotten: '忘记密码',
    signUp: '注册',
    enter: '进入',
    forceTitle: '账户正在使用',
    forceMessage: '该账户已在其他设备上连接。您是否要将其踢出并在此设备上连接?',
    forgotMyPassword: '忘记了我的密码',
    firstLogin: '首次登录',
    firstLoginMessage: '出于安全原因，您必须在首次登录时设置新密码。此外，还要选择一种首选语言来查看应用程序',
    firstLoginOverview: '以下是您的账户、联赛和产品概览',
    passwordConfirmation: '密码确认',
    forgotPasswordMessage: '输入您的电子邮件，如果有与电子邮件关联的有效帐户，则将在收件箱中收到重置密码的下一步操作',
    resetPassword: '重置密码',
    resetPasswordLinkInvalid: '此链接无效或已过期。请在登录页面重新请求重置密码。',
    skipSettings: '跳过设置',
    contact: '联系',
    cookiesText: '本网站使用 Google 的 Cookie 来提供服务并分析您的流量，以确保服务质量、生成使用统计信息以及检测和处理滥用行为。',
    contactUs: '联系我们',
    newsTitle: '全新：身体能力评分！',
    newsText: '在原有事件数据评分的基础上，我们新增了两项身体表现评分：耐力评分和速度与力量评分。耐力突出那些能够持续覆盖场地并维持高工作负荷的球员，而速度与力量则关注最高速度、冲刺和爆发式加速。两项评分均为0到100，并包含按联赛和位置划分的百分位，便于与同类球员直接比较。'
  },
  settings: {
    pageSubtitle: '配置您在应用程序中的体验',
    language: '语言',
    availableLeagues: '可用联赛',
    availableSeasons: '可用赛季',
    availableProducts: '可用产品',
    organization: '公司',
    changePassword: '更改密码',
    seasonTemplates: '赛季模板',
    seasonTemplatesSubtitle: '创建您自己的赛季模板以便稍后在球员排名和球员报告中选择',
    templateName: '模板名称',
    selectTemplate: '选择要编辑的模板',
    radarDefault: '默认雷达',
    default: '默认值',
    tabs: {
      options: '选项',
      templates: '模板',
      availableLeagues: '可用联赛',
      contactData: '联系数据'
    },
    contactData: {
      userDetails: '用户详细信息',
      firstName: '名字',
      lastName: '姓氏',
      contactDetails: '联系信息',
      name: '名称',
      phone: '电话',
      mobile: '手机',
      email: '电子邮件',
      representativeDetails: '的代表详细信息'
    },
    currency: '货币',
    fieldPreferences: '区域偏好',
    visualizationsPreferences: '可视化偏好',
    fieldColor: '区域颜色',
    fieldColors: {
      green: '绿色',
      blue: '蓝色',
      white: '白色',
      black: '黑色',
      grey: 'Grey'
    },
    defaultPlayerVisualization: '默认球员可视化',
    appPreferences: '应用程序偏好',
    darkMode: '深色模式',
    showTour: '显示导游',
    customStats: '自定义统计数据',
    radarTemplates: '雷达模板',
    radarTemplatesSubtitle: '创建您自己的指标模板，以便稍后在球员表现和球员排名中选择',
    radarCategories: {
      Custom1: '自定义1',
      Custom2: '自定义2',
      Custom3: '自定义3',
      Custom4: '自定义4',
      Custom5: '自定义5',
      Custom6: '自定义6',
      Physical: '身体素质',
      CustomPhysical1: '自定义 身体素质 1',
      CustomPhysical2: '自定义 身体素质 2',
      CustomPhysical3: '自定义 身体素质 3',
      CustomPhysical4: '自定义 身体素质 4',
      CustomPhysical5: '自定义 身体素质 5',
      CustomPhysical6: '自定义 身体素质 6'
    },
    templateRemoveTitle: '删除雷达',
    templateRemoveMsg: '您要删除此雷达吗',
    templateEditTitle: '保存模板',
    templateEditMsg: '有一个未保存的模板，您是否想在加载另一个模板进行编辑之前保存它？',
    category: '类别',
    playerRadar: '球员雷达',
    teamRadar: '球队雷达',
    statsAlert: '插入至少一个统计数据以保存',
    recommended: '推荐',
    warning: '有些位置的雷达数量已达到允许的上限。请删除或编辑任何模板',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: '西班牙语',
      numeric: '数字的'
    },
    showMediaMode: '显示媒体模式',
    statTemplates: '游戏统计模板',
    statTemplatesSubtitle: '从多种指标中进行选择，创建自己的模板',
    ratingFormat: {
      ratingFormat: '评级格式',
      numbers: '数字',
      letters: '字母 A-F'
    }
  },
  playerDetail: {
    passport: '护照',
    secondPassport: '第二本护照',
    age: '年龄',
    dateOfBirth: '出生日期',
    height: '身高 (厘米)',
    weight: '体重 (公斤)',
    wage: '工资',
    history: '历史',
    positions: '位置',
    injuries: '受伤',
    transfers: '转会',
    nationalTeam: '国家队',
    addFavorite: '添加到收藏夹',
    removeFavorite: '从收藏夹中删除',
    contractEnd: '合同结束',
    yearsOld: '岁',
    playerAvailability: '可用',
    playerUsage: '出场时间',
    usage: '使用情况',
    addToCollection: '添加到收藏夹',
    performance: '表现',
    info: '信息',
    career: '职业生涯',
    playerStyle: '球员风格',
    radar: '雷达',
    finishingMap: '进攻终结位置图',
    threatMap: '制造威胁位置图',
    keyPassMap: '关键传球位置图',
    beeswarm: '排名',
    allGames: '所有比赛',
    eventsMap: '事件位置图',
    lbpMap: '突破线传球',
    obpMap: '对球压力',
    pupMap: '在压力下通过',
    obrMap: '球收据',
    fullName: '全名',
    academy: '学院',
    name: '名字',
    lastName: '姓氏',
    playerAvailabilityLong: '的赛季没有受伤或停赛',
    playerUsageLong: '出场时间',
    playerAvailability1: '没有受伤或停赛的比赛',
    playerAvailability2: '本赛季比赛数',
    playerUsage1: '出场时间',
    playerUsage2: '全队总出场时间',
    notMinutesThisSeason: '本赛季未上场',
    seasonPlaceholder: '没有活跃的赛季',
    inactivePlayer: '非活跃球员',
    inactivePlayerMessage: '如果您需要更多信息，可以要求报告',
    goRequest: '前往请求',
    warningMinutes: ': 注意：出场时间少于450分钟，分析可能不具代表性',
    scoreWarningMinutes: '出场时间至少450分钟的球员',
    pdScoreWarningMinutes: '出场时间至少450分钟的球员（每场至少60分钟）',
    warningSeasonGames: '赛季比赛少于5场，因此最小值和最大值为前5名联赛',
    warningStatsRemoved: '部分统计数据未显示，因为它们在所选赛季不可用',
    warningBeeswarm: '未显示球员，因为所选赛季没有可用数据',
    warningPlayersZeroValue: '未显示{x}个为0的球员 ',
    onlyPlayersThatFit: '仅适合雷达模板的球员',
    gamesPlayedNotEnough: '由于比赛数量不足，选项已被禁用',
    gbe: '劳工证分值',
    analysis: '分析',
    documents: '文件',
    rankDefensive: '防守',
    rankBallHandling: '控球',
    rankGoal: '进球贡献',
    rankXt: '威胁',
    rankIndex: '指数',
    visitHistory: '访问历史',
    placer: '球场',
    touchesMap: '触球位置图',
    heatMap: '热力图',
    ageProfile: '年龄概况',
    strongFoot: '利足',
    player: '球员',
    outOf: '超出',
    in: '在',
    radius: '半径',
    blur: '模糊',
    careerTable: {
      nationalTeamCareer: '国家队生涯',
      nationalTeamCompetitions: '国家队比赛'
    },
    physicalProgression: 'Physical Progression',
    gpi: '全球球员指数',
    warningGPI: '仅对过去30天内活跃于ELO联赛的球员开放',
    diffGPI: '与上一场比赛的变化',
    rankingInTheWorld: '世界排名第#{0}',
    rankingInTheLeague: '{1}中排名第#{0}',
    max: '最高',
    gpiChart: '基于最近{0}场比赛的全球球员指数值的图表',
    percentileRange: '百分位数 {0} 到 {1}',
    months: '月',
    month: '月',
    contractExpOver4Years: '合同到期于',
    contractExpSoon: '合同即将到期',
    contractFinalYear: '合同最后一年',
    freeAgent: '自由球员',
    gpiDescription: '全球球员指数（GPI）是一个标准化的球员评级系统，根据球队实力、对手实力、比赛表现和可用性来评估足球运动员。受 Elo 评级系统的启发，它确保玩家评级反映实际的竞争环境而不是任意基线。',
    turnoversMap: '营业额和回收率地图',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    }
  },
  finishingMap: {
    typesOfShot: '射门类型',
    shotStrategy: '',
    strategiesCount: '{count} 策略',
    areas: '区域',
    bodyPart: '身体部位',
    more: '更多',
    selectAll: '全选',
    minutes: '分钟',
    circles: '圆圈',
    boxes: '禁区热图',
    lines: '线',
    games: '比赛',
    perShot: '每次射门',
    goal: '进球',
    missedShot: '射失',
    savedShot: '扑救的射门',
    shotOnPost: '击中门柱的射门',
    missedChance: '错失机会',
    openPlay: '运动战',
    regularPlay: '常规进攻',
    fastBreak: '快速进攻',
    individualPlay: '个人能力进攻',
    setPiece: '定位球',
    fromCorner: '角球',
    freeKick: '任意球',
    indirectFreeKick: '间接任意球',
    throwInSetPiece: '界外球定位球',
    inBox: '禁区内',
    goalArea: '小禁区',
    boxLeft: '禁区左侧',
    boxCenter: '禁区中央',
    boxRight: '禁区右侧',
    outOfBox: '禁区外',
    outBoxDeepLeft: '禁区外左侧靠后位置',
    outBoxDeepRight: '禁区外右侧靠后位置',
    outBoxLeft: '禁区外左侧',
    outBoxCentreLeft: '禁区外中路左侧',
    outBoxCentre: '禁区外中路',
    outBoxCentreRight: '禁区外中路右侧',
    outBoxRight: '禁区外右侧',
    left35: '距球门米左侧',
    centreLeft35: '距球门米中路左侧',
    centre35: '距球门米中路',
    centreRight35: '距球门米中路右侧',
    right35: '距球门米右侧',
    head: '头球',
    rightFooted: '右脚',
    leftFooted: '左脚',
    otherBodyPart: '其他身体部位',
    chart: {
      shots: '射门',
      xGPerShot: '每次射门的期望进球值',
      exceptionTextPenaltyGoals: '* 点球 = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* 点球 = 0.765 xGOT',
      exceptionTextOwnGoals: '不考虑乌龙球',
      og: '乌龙球',
      penaltiesExcluded: '不包括点球进球',
      ownGoalsExcluded: '不包括自失球',
      sumOfxG: '期望进球数之和',
      exceptionShotsOutOfRange: '* 不显示超出范围的射门'
    },
    inGoal: '进球',
    outOfGoal: '未进球',
    highLeft: '左上',
    highCenter: '中路上侧',
    highRight: '右上',
    lowLeft: '左下',
    lowCenter: '中路下侧',
    lowRight: '右下',
    outHighLeft: '偏出左上侧',
    high: '飞出中路上侧',
    outHighRight: '偏出右上侧',
    closeHighLeft: '左上侧近距离偏出',
    closeHigh: '上侧近距离偏出',
    closeHighRight: '右上侧近距离偏出',
    closeLeft: '左下侧近距离偏出',
    closeRight: '右下侧近距离偏出',
    finishingTable: '射门数据表',
    onGoal: '进球',
    distributionFilters: '分配过滤器',
    penalty: '点球',
    penaltyShootout: '点球大战',
    onlyPercentage: '显示百分比',
    showAll: '显示全部',
    chanceMissed: '错过的机会'
  },
  keyPassMap: {
    chart: {
      keyPasses: '关键传球',
      xAPerPass: '每次传球的期望助攻数',
      xAOpenPlay: '运动战期望助攻数',
      xASetPiece: '定位球期望助攻数'
    }
  },
  beeswarm: {
    template: '模板',
    templates: {
      Goalkeeper: '守门员',
      Defender: '后卫',
      'Full-Back': '边后卫',
      FullBack: '边后卫',
      'Wing-Back': '边翼卫',
      WingBack: '边翼卫',
      Midfielder: '中场',
      AttackingMidfielder: '攻击型中场',
      Winger: '边锋',
      Forward: '前锋',
      Physical: '体能'
    },
    compareWith: '与比较',
    highlightPlayersOf: '突出显示',
    highlightPlayers: '突出球员来自',
    per90: '每分钟数据',
    highlightTeams: '突出团队',
    filterTeams: '筛选队伍',
    warningZeros: '仅适用于非反向统计'
  },
  collections: {
    newCollection: '新收藏夹',
    editCollection: '编辑收藏夹',
    name: '名称',
    visibility: '可见性',
    privacity: {
      publicTitle: '公开',
      publicDescription: '对您和您的俱乐部可见',
      privateTitle: '私人',
      privateDescription: '仅对您可见',
      supervisedTitle: '受监管的',
      supervisedDescription: '仅对您和您的监管者可见'
    },
    addSuccess: '添加成功',
    createAddSuccess: '创建并添加成功',
    editSuccess: '更新成功',
    deleteSuccess: '删除成功',
    title: '球员收藏夹',
    publics: '公开',
    privates: '私人',
    supervised: '受监管的',
    totalMarketValue: '总市场价值',
    avgMarketValue: '平均市场价值',
    avgAge: '平均年龄',
    searchBarPlaceholder: '要添加到收藏夹，请搜索并选择球员',
    deleteCollection: '删除收藏夹',
    deleteCollectionMessage: '收藏夹将被删除，您确定吗？',
    removePlayer: '移除球员',
    removePlayerMessage: '球员将从收藏夹中移除，您确定吗？',
    subtitle: '组织您的球探工作',
    notExitingTemplate: '仍然没有模板'
  },
  searchbar: {
    placeholder: '输入搜索 (例如 `david arsenal´)',
    players: '球员',
    teams: '球队',
    games: '比赛',
    leagues: '联赛',
    explore: '探索更多结果',
    placeholderNoResults: '模板无结果',
    teamPlaceholder: '要比较一支球队，请搜索并选择它'
  },
  favorites: {
    showOnly: '仅显示',
    selfFavorites: '我的收藏',
    clubFavorites: '俱乐部收藏',
    contractExpiration: '合同到期',
    groupBy: '分组',
    noGrouped: '无',
    maxSelection: '仅能选择',
    selectAtleastOne: '至少选择一个',
    comparePlayers: '比较球员',
    selectedPlayers: '选定的球员',
    subtitle: '管理您的收藏',
    generateXlsx: '生成文件',
    generating: '正在生成',
    subscribed: 'Subscribed',
    subscribedTooltip: 'Subscribe to recieve a mail when a game have been played',
    deleteSelected: '删除所选内容'
  },
  expiration: {
    summer: '夏季',
    winter: '冬季'
  },
  positions: {
    noposition: '无位置',
    goalkeeper: '守门员',
    goalkeepers: '守门员',
    defender: '后卫',
    defenders: '后卫',
    defenses: '后卫',
    fullback: '边后卫',
    fullbacks: '边后卫',
    midfielder: '中场',
    midfielders: '中场',
    winger: '边锋',
    wingers: '边锋',
    forward: '前锋',
    forwards: '前锋',
    wingback: '边翼卫',
    wingbacks: '边翼卫'
  },
  dPos: {
    1: {
      name: '守门员',
      alias: ''
    },
    2: {
      name: '右后卫',
      alias: '射频波束'
    },
    3: {
      name: '右中后卫',
      alias: 'RCB'
    },
    4: {
      name: '左中后',
      alias: 'LCB'
    },
    5: {
      name: '左后卫',
      alias: '低频反馈'
    },
    6: {
      name: '防守型中场',
      alias: 'DM'
    },
    7: {
      name: '右翼锋',
      alias: 'RW'
    },
    8: {
      name: '中场',
      alias: '厘米'
    },
    9: {
      name: '前锋',
      alias: '英石'
    },
    10: {
      name: '攻击型中场',
      alias: '是'
    },
    11: {
      name: '左边锋',
      alias: '长波'
    }
  },
  charts: {
    seasonsCompareSelectLabel: '比较',
    lastSeasonSelectText: '上个赛季',
    lastAndCurrentSeasonSelectText: '上个赛季本赛季',
    currentSeasonSelectText: '本赛季',
    lastNgamesSelectText: '最近{x}场比赛',
    npgVsXGTitle: '非点球进球 VS 期望进球数',
    totalXGLabel: '总期望进球数',
    xGLabel: '期望进球数',
    totalNPGLabel: '总非点球进球数',
    xGAgainstvsNPGAgainstTitle: '对手期望进球数 VS 非点球失球数',
    totalXGAgainstLabel: '对手总期望进球数',
    xGAgainstLabel: '对手期望进球数',
    totalNPGAgainstLabel: '总非点球失球数',
    xGvsxGAgainstTitle: '期望进球数 VS 对手期望进球数',
    pointsVsXPointsTitle: '积分 VS 期望积分',
    xTTitle: '比赛流程',
    totalXPoints: '总期望积分',
    totalPoints: '总积分',
    requestedReports: '请求的报告',
    playersScouted: '球探调查过的球员',
    performanceVSAverageChart: '表现 VS 平均值',
    perPositions: '按位置',
    perLeagues: '按联赛',
    perMonths: '按月份',
    perClients: '按客户',
    ofPreposition: '的',
    idJChartTitle: '比赛主动性',
    idJChartLabel: '主动性指数',
    vJOChartTitle: '进攻比赛数',
    vJOChartLabel: '进攻比赛量指数',
    preJOChartTitle: '进攻比赛精度',
    preJOChartLabel: '进攻比赛精度指数',
    proJOChartTitle: '进攻比赛进展',
    proJOChartLabel: '进攻比赛进展指数',
    chart: '图表',
    table: '表格',
    showLeaguesWithAtLeast: '显示至少',
    playersScoutedSuffix: '球探调查过的球员'
  },
  table: {
    history: {
      season: '赛季',
      team: '球队',
      position: '位置',
      side: '边',
      games: '比赛',
      minutes: '分钟',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: '缺席比赛',
      goalsReceived: '气相色谱 (GC)'
    },
    injury: {
      season: '赛季',
      team: '球队',
      injury: '受伤',
      dateFrom: '开始日期',
      dateTo: '结束日期',
      daysLost: '缺席天数',
      gamesLost: '缺席比赛数',
      allInjuries: '所有伤病'
    },
    transfers: {
      season: '赛季',
      date: '日期',
      teamFrom: '来自球队',
      teamTo: '去往球队',
      marketValue: '市场身价',
      fee: '转会费',
      type: '类型'
    },
    caps: {
      team: '球队',
      debut: '首秀',
      games: '比赛',
      goals: '进球',
      coachDuringDebut: '首秀时的主教练',
      debutAge: '首秀年龄'
    },
    roster: {
      country: '国家',
      player: '球员',
      positions: '位置',
      minutes: '分钟',
      games: '比赛',
      goals: '进球',
      assists: '助攻',
      cards: '得牌',
      gamesExplicit: '比赛场数'
    },
    league: {
      title: '联赛表',
      subtitle: '深入了解联赛排名和统计数据',
      team: '球队',
      games: '比赛场数',
      gamesExplicit: '比赛场数',
      gamesRanking: '比赛场数',
      gamesRankingExplicit: '比赛场数',
      points: '积分',
      pointsExplicit: '积分',
      expectedPoints: '期望积分',
      expectedPointsExplicit: '期望积分',
      goalsScored: '非点球进球',
      goalsScoredExplicit: '非点球进球',
      xG: '期望进球数',
      xGExplicit: '期望进球数',
      goalsAgainst: '非点球失球数',
      goalsAgainstExplicit: '非点球失球数',
      xGAgainst: '对手期望进球数',
      xGAgainstExplicit: '对手期望进球数',
      xGAgainstDiff: '对手期望进球数差值',
      xGAgainstDiffExplicit: '对手期望进球数差值',
      form: '状态',
      sos: '赛程强度',
      sosExplicit: '赛程强度',
      sosHfa: '主场优势',
      sosHfaExplicit: '主场优势',
      difficultyAboveAvg: '难度高于平均值',
      differentGames: '比赛场数不同',
      berth: '排名'
    },
    usersOfClient: {
      userName: '姓名',
      userRole: '用户',
      devRole: '开发',
      adminRole: '管理员',
      servicesRole: '服务',
      xgRole: '期望进球数',
      radarRole: '雷达',
      beeswarmRole: '排名',
      elevenRole: '十一人制',
      similarityRole: '相似性',
      gameAnalysisRole: '比赛分析',
      clientStatsRole: '客户统计数据',
      created: '创建时间',
      type: '类型',
      logins: '登录',
      lastLogin: '最后登录时间',
      trialDate: '试用日期'
    },
    clientLeagues: {
      league: '联赛',
      area: '地区',
      tier: '级别',
      seasons: '赛季',
      currentMatchDay: '比赛日',
      regular: '常规',
      youthLeague: '青年队',
      clientActive: '活跃',
      visibleLeagues: '可见联赛',
      male: 'Men\'s league',
      female: '女子联赛'
    },
    connections: {
      title: '常见组合',
      playerFrom: '来自球员',
      playerTo: '去往球员',
      passes: '传球',
      passesTooltip: '成功传球总数',
      passesFinalThird: '前场三区传球',
      passesFinalThirdTooltip: '前场三区传球'
    },
    playerPassMapData: {
      title: '传球数据',
      player: '球员',
      passes: '传球',
      passesPct: '传球成功率',
      xA: '预期助攻',
      xG: '预期进球',
      xT: '预期威胁',
      playerTooltip: '球员名',
      passesTooltip: '总传球次数',
      passesPctTooltip: '成功传球占比',
      xATooltip: '预期助攻数',
      xGTooltip: '预期进球数',
      xTTooltip: '预期威胁进攻数'
    },
    playerAllGames: {
      gameDate: '日期',
      game: '比赛',
      team: '球队',
      positionsPlayed: '位置',
      minsPlayed: '分钟',
      gameActions: '动作',
      gameDateTooltip: '比赛日期',
      gameTooltip: '比赛',
      positionsPlayedTooltip: '比赛位置',
      minsPlayedTooltip: '比赛分钟数',
      gameActionsTooltip: ',,进球助攻红黄牌',
      from: '开始',
      to: '结束',
      goalText: '进球时间',
      assistText: '助攻时间',
      penaltyText: '点球时间',
      ownGoalText: '乌龙球时间',
      yellowCardText: '黄牌时间',
      secondYellowCardText: '第二张黄牌时间',
      redCardText: '红牌时间',
      substitutionIN: '换入时间',
      substitutionOUT: '换出时间',
      suspendedText: '停赛',
      Team: '设备'
    },
    gameFlow: {
      phase: '阶段',
      mins: '分钟',
      team: '球队',
      period: '时期',
      possession: '控球率',
      possessionTooltip: '控球率',
      xT: '预期威胁',
      xTTooltip: '预期威胁',
      pft: '前场三区传球',
      pftTooltip: '前场三区传球',
      xG: '预期进球数',
      xGTooltip: '预期进球数'
    }
  },
  game: {
    title: '游戏表',
    subtitle: '深入了解游戏的特点和统计数据',
    header: {
      gameDetails: '详情',
      gameStats: '统计',
      gameFinishingMap: '终结进攻位置图',
      gameKeyPassMap: '关键传球位置图',
      gamePassMap: '传球位置图',
      gameThreat: '比赛威胁',
      gameFlow: '比赛进程',
      gameAnalysis: '比赛分析',
      gamePhysicalStats: '身体统计数据',
      possessions: '控球',
      bench: '替补席',
      video: '视频亮点',
      preGame: '赛前',
      postGame: '赛后',
      areaCoverage: '区域覆盖'
    },
    passMap: {
      typeOfPlay: '比赛类型:',
      passes: '传球:',
      team: '球队',
      minutes: '分钟:',
      select: '选择',
      all: '所有',
      attacking: '进攻',
      defending: '防守',
      forwards: '向前',
      backwards: '向后',
      sideways: '横向',
      longBall: '长传',
      successfullPasses: '成功传球',
      homeTeam: '主队',
      awayTeam: '客队',
      passingMatrix: '传递矩阵',
      passer: '传球者',
      receiver: '接球者',
      passOutcome: '传球结果',
      passDirection: '传球方向',
      half: '半场',
      offensive: '进攻',
      defensive: '防守',
      passingConnections: '传球连接',
      pitchView: '球场',
      passSingular: '传球',
      passPlural: '传球',
      playerLocation: '玩家位置',
      passLegend: '平均触摸位置',
      minuteRange: '分钟范围'
    },
    stats: {
      summary: 'Summary',
      attacking: 'Attacking',
      defending: 'Defending',
      contribution: 'Contribution',
      possession: '控球',
      expectedPoints: '预期分数',
      directness: '',
      ppda: '每次防守对手传球数',
      xg: '预期进球数',
      xG: '预期进球数',
      xGSetPiece: '定位球预期进球数',
      xA: '预期助攻数',
      xASetPiece: '预期助攻数',
      xT: '预期制造威胁数',
      xTSetPiece: '定位球预期制造威胁数',
      touchesInOppBox: '对手禁区内触球数',
      passesFinalThird: '前场三区传球数',
      interceptions: '拦截数',
      recoveries: '反抢数',
      recoveriesOppHalf: '对方半场反抢数',
      tackles: '抢断数',
      tacklesWasDribbled: '防守一对一成功',
      fouls: '犯规数',
      yellowCards: '黄牌数',
      redCards: '红牌数',
      passes: '传球数',
      passing: '传球成功率',
      crosses: '传中数',
      crossing: '传中成功率',
      shots: '射门数',
      shotsOnTarget: '射正数',
      ppdaExplicit: '每次防守让对手完成的传球数',
      xgExplicit: '预期进球数',
      xp: '预期传球数',
      ExpectedPassing: 'xP%',
      seasonAvg: '比赛平均值',
      winChanceTooltip: '基于本方和对方的预期进球值计算得出的获胜概率',
      drawChance: '平局概率',
      xgAgainst: '对手预期进球数',
      averagePossession: '控球率',
      averageShots: '射门次数',
      averagexG: '预期进球数',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: '回收率',
      turnoversRate: '周转率'
    },
    detail: {
      halfTime: '半场时间',
      overTime: '加时赛',
      showStats: '显示统计',
      hideStats: '隐藏统计',
      bench: '替补席',
      showShotOptions: '显示射门选项',
      hideShotOptions: '隐藏射门选项',
      showPassOptions: '显示传球选项',
      hidePassOptions: '隐藏传球选项',
      endGame: '全场结束',
      penalties: '点球大战'
    },
    timeline: {
      events: {
        goal: '进球',
        goal_ownGoal: '乌龙球',
        goal_penalty: '点球进球',
        card: '得牌',
        card_yellowCard: '黄牌',
        card_secondYellowCard: '第二张黄牌',
        card_redCard: '红牌',
        formationChange: '阵型变化',
        substitution: '换人',
        saveShot: '扑救射门',
        saveShot_penalty: '扑救点球',
        missedShot: '射失',
        missedShot_penalty: '点球射失',
        shotOnPost: '击中门柱',
        shotOnPost_penalty: '点球击中门柱',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: '游戏时间轴'
    },
    gameFlow: {
      goalOf: '进球来自于',
      redCardTo: '红牌来自于',
      missedPenalty: '错失点球'
    },
    gameThreat: {
      typeOfPlay: '动作类型',
      regularPlay: '常规进攻',
      setPiece: '定位球',
      setPiecePlay: '定位球',
      throwInSetPiecePlay: '界外球定位球',
      throwInPlay: '界外球进攻',
      gkThrow: '守門員踢球',
      gkKick: '踢球門',
      kickOff: '開球',
      actionEnding: '动作结束',
      pass: '传球',
      shot: '射门',
      foul: '犯规',
      other: '其他',
      threat: '威胁',
      legendSumOfXT: '预期威胁总数',
      legendPass: '传球',
      legendShot: '射门',
      legendCarryAndAction: '带球和动作',
      legendCarryAndPass: '带球和传球',
      legendOnlyShowing: '仅显示预期威胁 > 的个人动作 ',
      legendOnlyShowingPart1: '仅显示个人',
      legendOnlyShowingPart2: '预期威胁>的动作',
      legendOnlyShowingSetPiece: '仅显示预期威胁 > 的定位球动作',
      legendOnlyShowingOpenPlay: '仅显示预期威胁 > 的常规比赛动作',
      legendPlays: '动作',
      legendPerPlay: '每个动作',
      legendCarry: '带球',
      penaltyPlay: '点球',
      freeKickTakenPlay: '任意球进攻',
      cornerTakenPlay: '角球进攻',
      fromCornerPlay: '角球进攻',
      keeperThrowPlay: '门将手抛球进攻',
      fastBreakPlay: '快速进攻',
      indirectPlay: '间接进攻',
      minutes: '分钟',
      games: '比赛',
      xT: '预期威胁',
      xTPer90: '每分钟预期威胁\''
    },
    gameAnalysis: {
      next: '下一个',
      previous: '上一个',
      phaseLabel: '阶段',
      phasesLabel: '阶段',
      dot: '.',
      comma: ',',
      from: '来自',
      to: '到',
      and: '和',
      steps: {
        finishingMapFullGame: '进攻终结位置图',
        keyPassMapFullGame: '关键传球位置图',
        gameFlow: '比赛流程',
        finishingMapPerPhases: '每阶段进攻终结位置图',
        keyPassMapPerPhases: '每阶段关键传球位置图',
        passMapPerPhases: '每阶段传球位置图'
      },
      step1: {
        table: {
          draw: '平局',
          win: '胜利',
          lose: '失败',
          possession: '控球率',
          xP: '预期积分',
          directness: '直接性',
          ppda: '每次防守让对手完成的传球数',
          xG: '预期进球',
          xGOpenPlay: '运动战预期进球',
          xGSetPiece: '定位球预期进球',
          xA: '预期助攻值',
          xAOpenPlay: '运动战预期助攻值'
        },
        text: {
          firstParagraph: {
            1: '右侧的位置图显示了home_team_name和away_team_name产生的预期进球。填充的圆圈是射门得分的位置。圆圈的大小取决于每个射门的预期进球值。 '
          },
          lastParagraph: {
            1: '结果的概率百分比和预期得分是通过射门模拟计算的（进行100,000次射门模拟，并以预测方式评估结果和获得得分的可能性). '
          },
          targetHighTeamXG: {
            1: 'target_team_name和rival_team_name都成功创造了大量的预期进球'
          },
          targetHighTeamOpenPlayXG: {
            1: '在这场比赛中，大多数target_team_name机会来自运动战'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: '在这场比赛中，大多数target_team_name机会来自运动战（与rival_team_name不同）'
          },
          targetHighTeamSetPieceXG: {
            1: '在这场比赛中，大多数target_team_name机会来自定位球'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: '在这场比赛中，大多数target_team_name机会来自定位球（与rival_team_name不同）'
          },
          targetHighTeamCornerXG: {
            1: '在这场比赛中，大多数target_team_name机会来自角球'
          },
          targetLowTeamGoalConversion: {
            1: ' 但进球转化率较低'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name在运动战和定位球中都创造了大量的预期进球'
          },
          targetHighTeamGoalConversion: {
            1: ' 也拥有很高的进球转化率'
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', 未能将创造的机会转化为得分'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' 但创造了更多威胁来制造进球'
          },
          targetHighTeamXGvsGameRival: {
            1: '在这场比赛中，target_team_name比rival_team_name产生了更多的威胁'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' 并且本可以进更多的球。'
          },
          targetHighTeamXGZeroGoals: {
            1: ' 但未能将创造的机会转化为得分。'
          },
          targetHighTeamXGGoalDiff: {
            1: ' 根据我们的赛后模拟，符合team_winning_chance的获胜机会。. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' 大多数target_team_name的机会来自运动战'
          },
          startTargetHighTeamSetPieceXG: {
            1: ' 大多数target_team_name机会来自定位球进攻'
          },
          startTargetHighTeamCornerXG: {
            1: ' 大多数机会来自角球。'
          },
          targetSimilarTeamXG: {
            1: '在这场比赛中，两支球队在预期进球方面都对对手产生了接近数量的威胁 '
          },
          targetSimilarTeamXGGoalDiff: {
            1: '但target_team_name在完成机会方面表现更好。'
          },
          targetLowTeamXGGoalDiff: {
            1: '尽管如此，target_team_name在预期进球方面并未对对手产生太多威胁。'
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name在预期进球方面并未对对手产生足够的威胁以赢得比赛'
          },
          rivalHighTeamXG: {
            1: '并让rival_team_name制造了太多威胁。'
          },
          rivalHighTeamXGGoalDiff: {
            1: ' 根据我们的赛后模拟，凭借这种制造机会的能力，这是一场target_team_name只能获胜team_winning_chance次的比赛。'
          },
          targetHighTeamGoalConversion2: {
            1: ' 拥有很高的进球转化率'
          },
          winningChance: {
            1: '根据两队的射门次数和预期进球，target_team_name应该赢得这场比赛team_winning_chance次。'
          },
          highPlayerXGManyShots: {
            1: '值得注意的是，player_name在shots_value次射门中产生了xg_value 预期进球值'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' 需要xg_value 预期进球值才能进球。'
          },
          highPlayerXGOneGoal: {
            1: ' 进球。'
          },
          highPlayerXGAnyGoal: {
            1: ', 尽管他未能进任何一球。'
          },
          highPlayerXGNotManyShots: {
            1: '值得一提的是，player_name在少量射门中就产生了xg_value预期进球'
          },
          highManyPlayerXG: {
            1: '值得注意的是，player_name和player_name2分别产生了xg_value和xg_value2<b>预期进球</b>。'
          },
          highTeamXGPerShot: {
            1: '关于target_team_name所选择的射门，它们在转化为进球的概率方面非常高，每次射门的平均预期进球为xg_per_shot_value。'
          },
          highTeamXGPerShotVSGameRival: {
            1: '的射门选择比rival_team_name好得多，每次射门的平均预期进球为xg_per_shot_value。'
          },
          xGTimesNotAfter70xG: {
            1: '尽管产生了很高的预期进球，但target_team_name在比赛结束时仍然难以制造出威胁。'
          },
          xGTimesBefore25xG: {
            1: 'target_team_name创造了很多威胁，尤其是在两个半场开始时。'
          },
          xGTimesAfter25xG: {
            1: 'target_team_name创造了很多威胁，尤其是在两个半场结束时。'
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name创造了大部分威胁都在上半场开始时。'
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name创造了大部分威胁都在上半场结束时。'
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name创造了大部分威胁都在下半场结束时。'
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name在下半场结束时创造了大部分威胁。'
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name以创造了xg_value预期进球的机会使得比赛的开局非常稳健。 '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name在上半场结束时创造了xg_value预期进球的机会。 '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name在中场休息后创造了xg_value预期进球的机会。'
          },
          xGTimesAfter70xG: {
            1: 'target_team_name在下半场结束时创造了xg_value预期进球的机会。'
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name在下半场结束时创造了很多威胁。'
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name在下半场开始时创造了很多威胁'
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name在上半场结束时创造了很多威胁。'
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name在上半场开始时创造了很多威胁 '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name在上半场创造了大部分威胁，而rival_team_name则在下半场做到了这一点。'
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name在下半场创造了大部分威胁，而rival_team_name则在上半场做到了这一点。 '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: '这是一场大部分预期进球的威胁都在上半场产生的比赛。 '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: '这是一场大部分预期进球的威胁都在下半场产生的比赛。'
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name在上半场创造了大部分威胁。'
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name在下半场创造了大部分威胁。'
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name在上半场让对手制造了大部分预期进球的威胁'
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name在下半场让对手制造了大部分预期进球的威胁。 '
          },
          highInBoxXG: {
            1: '射门位置图显示，大部分威胁来自禁区内的射门。'
          },
          highOutOfBoxXG: {
            1: '从射门位置图中可以看出，在这场比赛中，target_team_name从禁区外制造了很多威胁。 '
          },
          highInBoxXGRival: {
            1: '我们想指出，target_team_name让对手制造的大部分威胁来自禁区内的射门。'
          },
          highInBoxXGRival2: {
            1: ' 同样值得注意的是，target_team_name让对手制造的大部分威胁来自禁区内的射门。'
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name在化解禁区内的威胁方面表现出色。 '
          },
          highTeamChancesHighPPDARival: {
            1: '缺乏施压压力，每次防守允许ppda_value次传球，这是rival_team_name创造大量机会的关键之一。'
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name在防守中只允许对手ppda_value次传球，这是获胜的关键之一。'
          },
          lowPPDA: {
            1: 'target_team_name在中断rival_team_name的进攻方面做得很好，每次防守只允许对手平均ppda_value次传球。'
          },
          highPossession: {
            1: 'target_team_name控制了球权，拥有possession_value的控球率'
          },
          highPPDARival: {
            1: ' 以及流畅的分球和处理'
          },
          chancesCreated: {
            1: ', 这使他们拥有大量的运动战机会（chances_value） '
          },
          chancesCreatedRival: {
            1: ', 尽管rival_team_name也能创造大量的运动战机会（chances_value）。 '
          },
          xGPerShotRival: {
            1: ', 尽管rival_team_name能够创造更具威胁的机会，每次射门的预期进球值为xg_per_shot_value。 '
          },
          winGame: {
            1: ' 这是赢得比赛的关键之一。'
          },
          notEnoughWinGame: {
            1: ' 但这还不足以赢得比赛。'
          },
          goalsFromErrorsFirstGoal: {
            1: '第一个进球来自player_error_name的失误，被player_name抓住'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: '唯一的进球来自player_error_name的失误，被player_name抓住'
          },
          lastPhaseOfGame: {
            1: ' 在比赛的最后阶段。'
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: '最终获胜的进球来自player_error_name的失误，导致player_name进球。'
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: '最终扳平比分的进球来自player_error_name的失误，导致player_name进球。'
          },
          goalsFromErrorsGoalToTie: {
            1: '的失误导致target_team_name有机会扳平比分。'
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name利用player_error_name的失误取得领先'
          },
          xGChance: {
            1: ' 机会的预期进球为xg_value。'
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: '最终获胜的进球来自player_error_name的失误，导致player_name进球'
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: '的失误导致rival_team_name有机会扳平比分。'
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name利用player_error_name的失误取得领先'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name在比赛中创造的唯一一个绝佳机会得分了，那就是我们在预期进球位置图上看到的player_name的进球，预期进球值为xg_value。'
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name在比赛中创造的所有绝佳机会都得分了'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name拥有target_team_name唯一一个进球的绝佳机会，预期进球为xg_value。'
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name未能将chances_value个超过40%可能性成为进球的机会转化为得分。'
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name拥有xg_value 预期进球值的绝佳机会取得领先。'
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name拥有chances_value个超过40% 预期进球值的机会取得领先。'
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name拥有chances_value个高预期进球值的机会取得领先。 '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name拥有xg_value 预期进球值的机会取得领先，但击中门柱。'
          },
          beforeEndOfGame: {
            1: '在比赛结束前'
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name拥有xg_value 预期进球的机会赢得比赛。'
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name拥有chances_value个超过40% 预期进球值的机会赢得比赛'
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name拥有chances_value个高预期进球值的机会赢得比赛。'
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name拥有xg_value 预期进球值的绝佳机会取得领先。'
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name拥有chances_value个超过40% 预期进球值的机会取得领先。'
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name拥有chances_value个高预期进球值的机会取得领先。'
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name拥有xg_value 预期进球值的机会取得领先，但击中门柱。'
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'layer_name拥有xg_value 预期进球值的机会扳平比分，但未能成功。 '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name拥有chances_value个超过30%可能性得分的机会扳平比分。'
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name拥有xg_value 预期进球值的机会扳平比分，但最终击中门柱。'
          }
        }
      },
      step2: {
        table: {
          draw: '平局',
          win: '胜利',
          possession: '控球率',
          xP: '预期积分',
          directness: '直接性',
          ppda: '每次防守让对手完成的传球数',
          xA: '预期助攻值',
          xAOpenPlay: '运动战预期助攻值',
          xASetPiece: '定位球预期助攻值',
          chancesCreated: '创造机会数',
          shotsOnTarget: '射正数'
        },
        text: {
          firstParagraph: {
            1: '这张图片显示了<b style=\'color:home_color’>home_team_name</b>和<b>away_team_name</b>的预期助攻值。'
          },
          xAPerKeyPass: {
            1: ' 每次关键传球的预期助攻值。'
          },
          keyPassesGeneratedFrom: {
            1: ', 特别是关键传球来自于'
          },
          highTeamXAvsXG: {
            1: '正如xA地图所示，target_team_name创造的大部分危险来自于团队配合，而不是个人能力'
          },
          openPlay: {
            1: '运动战'
          },
          setPiece: {
            1: '定位球'
          },
          cornerKicks: {
            1: '角球'
          },
          combinationPlays: {
            1: '团队配合'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: '在这场比赛中，target_team_name制造了威胁来自于团队配合'
          },
          individualActions: {
            1: ' 以及个人能力'
          },
          dangerFromIndividualActions: {
            1: '在这场比赛中，target_team_name创造的大部分威胁来自个人能力。'
          },
          highTeamXAvsXGRival: {
            1: ' 在比赛中让对手制造的机会来自于团队配合，正如预期助攻位置图所示。.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' 在关键传球这一点很出色，来自于 '
          },
          manyPlayerKeyPasses: {
            1: '值得注意的是，player_name在key_passes次关键传球中创造了xa_value预期助攻值'
          },
          playerAssists: {
            1: ' 每次助攻需要xa_per_assist预期助攻值。'
          },
          giveAssist: {
            1: ' 送出助攻。'
          },
          noAssists: {
            1: ', 尽管他的传球都没有最终成为助攻。.'
          },
          highXANotManyShots: {
            1: '值得注意的是，player_name在少量传球中创造了xa_value预期助攻值'
          },
          manyPlayersHighXA: {
            1: '值得注意的是，player_name和player_name2分别产生了xa_value和xa_value2预期助攻值。'
          },
          xATimes: {
            1: 'target_team_name在上半场创造了大部分威胁，而rival_team_name则在'
          },
          firstHalf: {
            1: ' 上半场做到了这一点。 '
          },
          secondHalf: {
            1: ' 下半场做到了这一点。'
          },
          left: {
            1: '左侧'
          },
          center: {
            1: '中间'
          },
          right: {
            1: '右侧'
          },
          xAFirstHalfFirstHalfRival: {
            1: '这是一场大部分预期进球较高的威胁都在 '
          },
          xAFirstHalf: {
            1: 'target_team_name大部分威胁都在 '
          },
          xATimesXARival: {
            1: 'target_team_name被对手制造了大量的预期进球值较高的威胁在'
          },
          xASides: {
            1: ' target_team_name的大部分威胁来自side_name（xa_value<b>xA</b>）'
          },
          xASidesRival: {
            1: '而rival_team_name的大部分威胁来自side_name(xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'rival_team_name的威胁创造，尤其来自于side_name(xa_value <b>xA</b>) '
          },
          speciallyEffective: {
            1: 'target_team_name的效率尤其突出在 '
          },
          xAPerChanceCreated: {
            1: ' 平均为xa_value'
          },
          speciallyEffectiveRival: {
            1: '的效率尤其突出在  '
          }
        }
      },
      step3: {
        text: {
          chance: '机会',
          chances: '机会',
          goal: '进球',
          goals: '进球',
          home: '主场',
          away: '客场',
          last: '最后',
          first: '第一',
          goalScorer: '进球者',
          goalScorers: '进球者',
          lastPhase: '比赛的最后阶段 ',
          phase: {
            1: '在比赛的这个phase_position阶段，'
          },
          moreXT: {
            1: '<b style=\'color:more_color’>more_xt_team_name</b> 产生了更多的预期威胁（<b style=\'color:more_color’>more_xt_team_value xT</b>）比<b style=\'color:less_color’>less_xt_team_name</b>（<b style=\'color:less_color’>less_xt_team_value xT</b>）'
          },
          sameTeamMoreMinutes: {
            1: '并且在这段时间内持续了更多分钟相较于（<b style=\'color:more_color’>more_time_xt_minutes分钟.</b> vs <b style=\'color:less_color’>less_time_xt_minutes分钟.</b> 的对手）'
          },
          rivalTeamMoreMinutes: {
            1: '然而，对手在这段时间内制造了更长时间的威胁（<b style=\'color:more_color’>more_time_xt_minutes 分钟.</b> vs <b style=\'color:less_color’>less_time_xt_minutes 分钟.</b> 的对手）'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color’>max_xt_team_name</b> 是创造最多威胁的球队（<b style=\'color:max_color’>max_xt_team_value xT</b>）在 <b style=\'color:max_color’>max_xt_team_minute’</b>'
          },
          maxXTValueRival: {
            1: ', 创造了最多的威胁（<b style=\'color:max_rival_color’>max_xt_rival_team_value xT</b>）在 <b style=\'color:max_rival_color’>max_xt_rival_team_minute’</b>'
          },
          bothTeamsScoreButDraw: {
            1: '在这段比赛时间中，两支球队都设法击败了对方的守门员，在<b>number_of_goals_each_team</b>。主队通过<b style=\'color:#3366FF’>home_player_name_goals</b>，客队通过 <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: '在进球方面，<b style=\'color:replace_color’>goal_scored_team_name</b> 以 <b style=\'color:replace_color’>difference_number_of_goals</b> 的优势超过了对手，因为他们成功破门，<b style=\'color:replace_color’>home_player_name_goals</b> 作为 goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: '球队',
          period: '阶段',
          possession: '控球率',
          ppda: '每次防守让对手完成的传球数',
          xGOpenPlay: '运动战预期进球',
          tooltip: {
            team: '球队',
            period: '阶段',
            possession: '控球率',
            ppda: '每次防守让对手完成的传球数',
            xGOpenPlay: '运动战预期进球'
          }
        },
        text: {
          clearly: '清楚地',
          very: '非常',
          haveGotText1: '只得到了',
          haveGotText2: '应该得到更多的',
          gaveUpPoss: '放弃控球',
          lostPoss: '失去了控球权',
          too: '也是',
          possession: {
            1: '在这个比赛阶段，<b style=\'color:team_color’>team_name</b> 明显地控制了球权'
          },
          equalPossession: {
            1: '在这个比赛阶段，没有人统治比赛，因为球的控制权相当平衡，尽管从数据上，<b style=\'color:team_color’>team_name</b> 稍微超过了他们的对手，拥有 <b style=\'color:team_color’>possession_value%</b> 的控球率'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color’>target_team_name</b> 由于施压力度不足，让 <b style=\'color:rival_team_color’>rival_team_name</b> 每次防守让 <b style=\'color:target_team_color’>ppda_value对手完成的传球数</b>'
          },
          lowPossessionLowPPDA: {
            1: ', 但是当 rival_team_name 拥有控球权时，<b style=\'color:target_team_color’>target_team_name</b> 在压迫方面做得很好，<b>PPDA</b> 为 <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' 并且由于 rival_team_name 的压迫强度非常低而能够顺利进攻'
          },
          highPossessionHighPPDA: {
            1: ' 尽管 rival_team_name 的压迫强度非常高'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color’>target_team_name</b> 占据了较高的控球率，在<b>Passes in the Final Third</b>制造了 <b>pft_value</b>'
          },
          highPossessionMidLowPFT: {
            1: '尽管控球率很高，<b style=\'color:target_team_color’>target_team_name</b> 只有 <b>pft_value</b><b>Passes in the Final Third</b>.'
          },
          lowPossessionHighPFT: {
            1: '尽管 <b style=\'color:target_team_color’>target_team_name</b> 在这个阶段的控球率很低，但能够在<b>Passes in the Final Third</b>.制造 <b>pft_value</b> <b>传球</b>'
          },
          midPossessionHighPFT: {
            1: '在这个阶段，双方相当平均的控球率并不能阻止 <b style=\'color:target_team_color’>target_team_name</b> 制造在<b>pft_value</b> <b>Passes in the Final Third</b>.'
          },
          highPFTHighTouchesIOB: {
            1: ' 除了在前场三区控制比赛，<b style=\'color:target_team_color’>target_team_name</b> 也在对手的禁区内制造了不少机会'
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color’>target_team_name</b> 确实控制了前场三区的球权，但不能频繁地将球送入对手的禁区'
          },
          highPFTMidTouchesIOB: {
            1: '鉴于在前场三区完成的传球数量，<b style=\'color:target_team_color’>target_team_name</b> 应该在对手的禁区内创造更多的威胁'
          },
          lowPFTHighTouchesIOB: {
            1: '尽管 <b style=\'color:target_team_color’>target_team_name</b> 在前场三区没有完成太多传球，但能够多次将球推进到对手的禁区'
          },
          midPFTHighTouchesIOB: {
            1: '鉴于在前场三区完成的传球数量，<b style=\'color:target_team_color’>target_team_name</b> 成功地多次将球推进到对手的禁区'
          },
          maxDirectness: {
            1: '值得指出的是，这是比赛中 <b style=\'color:max_dir_color’>target_team_name</b> 更具攻击性的阶段，<b> Directness</b>为 <b>directness_value</b>'
          },
          maxXG: {
            1: '<b style=\'color:target_team_name’>target_team_name</b> 能够比其他比赛阶段产生更多的预期进球 '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_name’>target_team_name</b> 制造了大量预期进球'
          },
          highXG: {
            1: '制造了大量预期进球'
          },
          highXGLowPossession: {
            1: ' 尽管没有控制球权'
          },
          highXGLowShots: {
            1: ' 只有几次射门，每次射门的 <b>xG</b> 为 <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' 尽管每次射门的预期进球值too_textlow '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color’>target_team_name</b> 无法对对手产生任何威胁'
          },
          lowXGMinXG: {
            1: '在预期进球方面，这对 <b style=\'color:target_team_color’>target_team_name</b> 来说是一个糟糕的阶段'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color’>target_team_name</b> 制造了非常低的预期进球'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color’>target_team_name</b> 无法制造出大量预期进球'
          },
          lowXGHighPossession: {
            1: '即使他们控制了球权'
          },
          lowXGHighShots: {
            1: '尽管射门次数很多'
          },
          lowXGHighPFT: {
            1: '尽管完成了球场的<b>Passes in the Final Third</b> <b>pft_value</b> '
          },
          midXGQuintileMinXG: {
            1: '尽管制造了不少预期进球，但这对 <b style=\'color:target_team_name’>target_team_name</b> 来说是比赛中最糟糕的阶段'
          },
          midXGQuintileMaxXG: {
            1: '这是 <b style=\'color:target_team_name’>target_team_name</b> 能够产生最高 <b>xG (xg_value)</b> 的阶段'
          }
        }
      },
      step5: {
        table: {
          team: '球队',
          period: '阶段',
          possession: '控球率',
          directness: '直接性',
          passesFinalThird: '⅓前场三区传球',
          tooltip: {
            team: '球队',
            period: '阶段',
            possession: '控球率',
            directness: '直接性',
            passesFinalThird: '前场三区传球'
          }
        },
        text: {
          last: '最后',
          goal: '进球',
          goals: '进球',
          chance: '机会',
          chances: '机会',
          first: '第一',
          homeTeam: '主队',
          awayTeam: '客队',
          home: '主场',
          away: '客场',
          clearly: '明显地',
          slightly: '稍微地',
          firstOrLastPhase: {
            1: '在比赛的 phase_position 阶段',
            2: '在比赛的 phase_position 阶段，'
          },
          phase: {
            1: '在这个比赛阶段'
          },
          bothZeroGoalsScored: {
            1: '没有任何一支球队能够改变比分'
          },
          equalGoalsScored: {
            1: '打入<b>number_goals</b> '
          },
          differentGoalsScored: {
            1: '打入<b>number_goals</b>'
          },
          equalPossesion: {
            1: '两支球队都拥有了 <b>poss_value%</b> 的控球时间'
          },
          morePossesion: {
            1: '<b style=\'color:more_color’>more_poss_team_name</b> 拥有球权的时间更长（<b style=\'color:more_color’>more_poss_team_value%</b> 的时间）比对手 <b style=\'color:less_color’>less_poss_team_name</b>（<b style=\'color:less_color’>less_poss_team_value%</b> 的时间）更多'
          },
          equalDirectness: {
            1: '两支球队都以相同的直接性（每个人都是 <b>directness_value</b>）'
          },
          moreDirectnessSameTeam: {
            1: '他们也比对手打法更直接，以 <b style=\'color:more_color’>more_dir_team_value</b> 的直接性进行进攻，而对手为 <b style=\'color:less_color’>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: '然而，是home_away队以更高的直接性（<b style=\'color:more_color’>more_dir_team_value</b>）进行进攻，而对手（<b style=\'color:less_color’>less_dir_team_value</b>）'
          },
          equalChancesCreated: {
            1: '两支球队创造了相同数量的机会，恰好为 <b>chances_created_value</b> 次机会'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color’>less_cc_team_name</b> 只创造了 <b style=\'color:less_color’>less_cc_team_value less_chance_text</b>，被对手（<b style=\'color:more_color\'>more_cc_team_value more_chance_text created</b>）明显超越 '
          },
          equalXA: {
            1: '两支球队拥有相等的机会，如预期助攻的 <b>xa_value</b> 所反映的那样 '
          },
          moreXA: {
            1: '制造了比对手多 <b>diff_xa_team_value 预期助攻</b>（<b style=\'color:more_color’>more_xa_team_value</b> 比 <b style=\'color:less_color’>less_xa_team_value</b>）'
          },
          xAOpenPlay: {
            1: '分别创造了 <b style=\'color:more_color’>more_xa_op_value</b> 和  <b style=\'color:less_color\'>less_xa_op_value xA Open Play</b>'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' 每个',
          respectively: ', 分别',
          with: ' 与 <b style=\'color:replace_color’>other_player_name</b>）',
          playerWas: '球员',
          playerWere: '球员们',
          firstPhase: {
            1: '在这场比赛的第一部分，最重要的球员是player_text ',
            2: '在比赛的第一部分，突出的是'
          },
          otherPhase: {
            1: '在 <b style=\'color:replace_color’>min_from’</b> 和 <b style=\'color:replace_color’>min_to’</b> 之间应该提到'
          },
          lastPhase: {
            1: '在比赛的最后一部分，提到',
            2: '至于比赛的最后阶段，'
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color’>player_name</b> 因为他完成了球队中最多的成功传球，恰好为 <b style=\'color:replace_color’>successfull_passes_value 次传球</b>'
          },
          playerMaxTotalPasses: {
            1: '当数据同时显示这一点时，这一点变得更有价值'
          },
          playerMaxTotalPasses2: {
            1: 'with_text 尝试传球最多的球员（<b style=\'color:replace_color’>total_passes_value passes </b>）。'
          },
          playerNotMaxTotalPasses: {
            1: '尽管他的传球不是最多的(<b style=\'color:replace_color\'>player_name</b> 送出<b style=\'color:replace_color\'>total_passes_value 传球</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: '在这个阶段分别尝试了<b style=\'color:replace_color\'>total_passes_value 传球</b> '
          },
          playerMaxPctPasses: {
            1: '在 <b style=\'color:replace_color’>% 完成传球</b> 方面，<b style=\'color:replace_color’>player_name</b> 拥有高达 <b style=\'color:replace_color’>max_pct_passes_value%</b> ',
            2: '关于传球成功率，值得一提的是 <b style=\'color:replace_color’>player_name</b>，其传球成功率为 <b style=\'color:replace_color’>max_pct_passes_value%</b>'
          },
          playerSumTotalXG: {
            1: '在这个时间窗口内，球队总共产生了 <b style=\'color:replace_color’>sum_xg_value 预期进球</b>',
            2: '在这段时间内，<b style=\'color:replace_color’>team_name</b> 创造了 <b style=\'color:replace_color’>预期进球</b> 值为 <b style=\'color:replace_color’>sum_xg_value</b>'
          },
          ZeroSumXG: {
            1: '尽管整个球队总共完成了 <b style=\'color:replace_color’>all_team_total_passes</b> 次传球，但这是徒劳的，因为他们未能创造出任何机会. ',
            2: '在这段时间内完成的 <b style=\'color:replace_color’>all_team_total_passes</b> 次传球没有产生任何得分机会'
          },
          playerMaxXGMaxXADiffPlayer: {
            1: '以 <b style=\'color:replace_color’>player_xg_name</b> 的 <b style=\'color:replace_color’>xg_value 预期进球</b> 和 <b style=\'color:replace_color’>player_xa_name</b> 的 <b style=\'color:replace_color’>xa_value 预期助攻</b> 为最具威胁的球员，在创造机会方面 '
          },
          playerMaxXGMaxXASamePlayer: {
            1: '的 <b style=\'color:replace_color’>xg_value 预期进球</b> 和 <b style=\'color:replace_color’>xa_value 预期助攻</b> 使得他成为球队中大多数机会的发起者 '
          },
          playersMaxXGMaxXA: {
            1: '多亏了与其他人的配合，如 <b style=\'color:replace_color’>players_name</b>，他们通过关键传球触发了每个人的 <b style=\'color:replace_color’>xa_value 预期助攻</b> '
          },
          playerMaxXGZeroXA: {
            1: '的 <b style=\'color:replace_color’>xg_value xG</b> 承担了制造所有机会的重任，因为他没有接到任何关键传球，不得不靠自己创造机会'
          },
          playersMaxXGZeroXA: {
            1: '的 <b style=\'color:replace_color’>xg_value 预期进球</b> 承担了所有机会的重任，因为他们没有接到任何关键传球，不得不靠自己创造机会'
          },
          oneMaxConnections: {
            1: '在这场比赛的这一阶段，互相之间传球最多的一对组合是 <b style=\'color:replace_color’>couple_name</b>，总共有 <b style=\'color:replace_color’>connections_value 次传球</b> ',
            2: '组成的组合互相传递了 <b style=\'color:replace_color’>connections_value</b> 次球',
            3: '组合在这场比赛的这一阶段传球最多，甚至有 <b style=\'color:replace_color’>connections_value</b> 次机会 '
          },
          twoMaxConnections: {
            1: '由 <b style=\'color:replace_color’>couple_name</b> 和 <b style=\'color:replace_color’>couple_name2</b> 组成的两对组合在这个阶段是最常进行配合的，互相传球 <b style=\'color:replace_color’>connections_value</b> 次'
          },
          moreThanTwoMaxConnections: {
            1: '球员组合，如 <b style=\'color:replace_color’>couple_name</b>，彼此之间传了 <b style=\'color:replace_color’>connections_value 次球</b>'
          },
          oneMinConnections: {
            1: '另一方面，<b style=\'color:replace_color’>couple_name</b> 之间传球最少，只有 <b style=\'color:replace_color’>connections_value 次传球</b>',
            2: '在另一个极端，由 <b style=\'color:replace_color’>couple_name</b> 组成的组合仅互相传递了 <b style=\'color:replace_color’>connections_value</b> 次'
          },
          twoMinConnections: {
            1: '另一方面，<b style=\'color:replace_color’>couple_name</b> 和 <b style=\'color:replace_color’>couple_name2</b> 几乎没有互相传球（<b style=\'color:replace_color’>connections_value 次传球</b>） '
          },
          moreThanTwoMinConnections: {
            1: '几个组合没有足够的传递配合，例如 <b style=\'color:replace_color’>couple_name</b> 组合，他们以 <b style=\'color:replace_color’>connections_value 次传球</b> 成为最不常配合的组合之一'
          }
        }
      },
      step7: {
        ballPossession: '控球权',
        gamePossessionDist: '控球权分布'
      }
    },
    gamePossessionMap: {
      of: '的',
      to: '到',
      and: '和',
      endsWith: '结束于',
      time: '时间',
      touches: '触球',
      passes: '传球',
      threat: '威胁',
      xG: '预期进球',
      xT: '预期威胁',
      minutes: '分钟',
      duration: '持续时间',
      endsGoal: '以进球结束',
      endsInBox: '在禁区内结束',
      withShot: '射门',
      withCross: '传中',
      possession: '控球',
      events: '事件',
      filters: '过滤器',
      filtersWarning: '威胁仅适用于没有射门的控球',
      sumWarning: '该筛选器适用于序列中所有射门的xG总和，因此可能大于1',
      show: '显示',
      sequenceNumbers: '序列号码',
      jerseyNumbers: '球衣',
      pass: '传球',
      carryAndPass: '运球和传球',
      carryAndAction: '运球和动作',
      carryAndShot: '运球和射门',
      shotFailed: '射门失败',
      goal: '进球',
      savedShot: '扑救射门',
      missedShot: '射偏射门',
      shotOnPost: '射中门柱射门',
      headerGoal: '头球进球',
      headerFailed: '头球失败',
      failed: '失败',
      with: '和'
    },
    report: {
      title: '比赛报告',
      maps: '位置图',
      xGRace: 'xG走势图',
      lineups: '首发阵容',
      button: '生成完整的 PDF 游戏报告',
      mobileButton: 'PDF 报告',
      most: '大多数',
      topXPlayers: '排名前 {x} 名的玩家',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: '游戏物理数据报告'
    },
    avgScoreTooltip: '每分钟平均得分',
    status: {
      scheduled: 'Scheduled',
      postponed: '推迟',
      cancelled: '取消',
      inPlay: '居住',
      finished: '完成的',
      awarded: '荣获',
      dataAvailable: '数据将在接下来的几个小时内提供'
    },
    preGameAnalysis: {
      showExpectations: '表现出期望',
      hideExpectations: '隐藏期望',
      goalsPeriods: '目标时期',
      synergyIndex: '协同指数',
      synergyIndexSubtitle: '传球者与终结者连接的整体强度'
    }
  },
  general: {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    8: '左边',
    9: '都',
    10: '右边',
    create: '创建',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    reset: '重置',
    go: '前往',
    formErrors: {
      required: '字段必填',
      passwordMatch: '密码不匹配',
      minLength: '最小长度',
      maxLength: '最大长度',
      emailValid: '电子邮件必须有效',
      youthAge: '年龄必须在10到23岁之间',
      seasonYear: '年份必须在2016到2050年之间',
      integer: '不允许使用小数'
    },
    confirmationTitle: '你确定吗',
    confirmationMessage: '请确认是否要执行操作',
    yes: ',是的确定',
    no: '不',
    search: '搜索',
    clearFilters: '清除过滤器',
    minimum: '最小值',
    maximum: '最大值',
    minimumPercent: '最小百分比',
    period: '阶段',
    exclude: '排除',
    team: '球队',
    clear: '清除',
    all: '全部',
    ground1: '全部',
    ground2: '主场',
    ground3: '客场',
    filter: '过滤器',
    noData: '未找到结果',
    noDataGivenFilters: '根据给定的过滤器未找到结果',
    similarityMinutesWarning: '由于少于450分钟的比赛时间,没有数据',
    templateOnlyEditable: '模板仅可由以下用户编辑 ',
    close: '关闭',
    load: '加载',
    filters: '过滤器',
    players: '球员',
    teams: '球队',
    compare: '比较',
    seeMore: '查看更多',
    seeLess: '查看更少',
    request: '请求',
    notes: '笔记',
    closeSession: '退出',
    settings: '设置',
    player: '球员',
    state: '状态',
    updated: '已更新',
    file: '文件',
    uploadFile: '上传文件',
    reports: '报告',
    download: '下载',
    new: '新的',
    comparison: '比较',
    scout: '球探',
    favorites: '收藏夹',
    moreOptions: '更多选项',
    lessOptions: '更少选项',
    today: '今天',
    home: '主场',
    away: '客场',
    until: '直到',
    firstHalf: '上半场',
    secondHalf: '下半场',
    firstPeriodOT: '加时赛上半场',
    secondPeriodOT: '加时赛下半场',
    postponed: '推迟的',
    stats: '统计数据',
    yesterday: '昨天',
    last: '最后',
    startDate: '开始日期',
    active: '活跃的',
    playerLimit: '球员限制',
    type: '类型',
    successMessage: '操作成功',
    failMessage: '操作失败',
    by: '由',
    checkYourInbox: '检查您的收件箱',
    faq: '词汇表',
    globalSearch: '全局搜索',
    gamesLost: '输掉的比赛',
    outOf: '总共',
    avgSeason: '赛季平均值',
    leftDays: '剩余天数',
    notifyError: '通知错误',
    notify: '通知',
    comments: '评论',
    searches: '搜索',
    now: '现在',
    twoHoursAgo: '两小时前',
    incomings: '新加盟',
    departures: '离队',
    transferLoans: '租借',
    transfers: '转会',
    movements: '移动',
    incomes: '收入',
    expenditures: '支出',
    action: '行动',
    target: '目标',
    uses: '用途',
    users: '用户',
    since: '自从',
    mediaMode: '媒体模式',
    white: '白色',
    enabled: '启用',
    disabled: '禁用',
    left: '左边',
    right: '右边',
    both: '都',
    'left-both': '左边都',
    'right-both': '右边都',
    'left foot': '左边',
    'right foot': '右边',
    files: '文件',
    confirm: '确认',
    currentStep: '当前步骤',
    phases: '阶段',
    entries: '条目',
    none: '无',
    times: '次数',
    darkMode: '深色模式',
    client: '客户',
    visits: '访问',
    lastVisit: '最后一次访问',
    strong: '强',
    medium: '中等',
    weak: '弱',
    goal: '目标',
    list: '列表',
    map: '地图',
    copiedToClipboard: '已复制到剪贴板',
    division: '分区',
    many: '多',
    few: '少',
    median: '中位数',
    topRight: '右上角',
    topLeft: '左上角',
    bottomRight: '右下角',
    bottomLeft: '左下角',
    library: '图书馆',
    mediaLibrary: '媒体库',
    for: '为了',
    stat: '统计数据',
    position: '位置',
    order: '顺序',
    add: '添加',
    visualization: '可视化',
    basic: '基础',
    selectAll: '全选',
    unselectAll: '取消全选',
    distribution: '分布',
    end: '结束',
    accuracy: '精度',
    opponent: '对手',
    ownTeam: '本方球队',
    center: '中心',
    line: '线',
    live: '直播',
    unavailable: '不可用',
    calendar: '日程表',
    activeLeague: '正在进行的联赛',
    similarity: '相似性',
    emptyForSelectAll: '空白全选',
    size: '大小',
    selectPlayersRestriction: '选择 1 到 {x} 名球员之间',
    group: '组',
    alerts: '提醒',
    shortcuts: '捷径',
    share: '分享',
    dataAvailable: '数据即将发布',
    someStatsAvailableSoon: '一些统计数据即将可用',
    monthGamesWarning: '本月精选游戏即将推出',
    metrics: '衡量标准',
    competition: 'Competition',
    code: 'Code',
    alias: 'Alias',
    never: '从不',
    unlimited: '无限',
    user: '用户',
    warning: '警告',
    requests: '请求',
    contactSales: '联系销售',
    comingSoon: '即将推出',
    firstPost: '第 1 篇文章',
    secondPost: '第二篇文章',
    dZone: 'D区',
    penaltySpot: '罚球点',
    secondPlay: '第二场比赛',
    otherZone: '其他区',
    baseline: '基线',
    youth: 'Youth',
    male: 'Male',
    direct: '直接的',
    indirect: '间接',
    processing: 'Processing',
    addNew: '添加新的',
    createdBy: '创建者',
    downloading: 'Downloading',
    displayType: '展示类型',
    alreadyExists: '已存在',
    aggregation: 'Aggregation',
    unavailableLeagues: '您无法访问该球员参加过的任何联赛',
    meters: 'Meters',
    quantity: '数量',
    allTime: 'All Times',
    games: 'Games',
    unit: '单位',
    categories: '类别',
    maintenanceWarning: '维护进行中',
    maintenanceMessage: '我们正在进行更新。您现在所做的更改将不会被保存。感谢您的耐心等待！',
    seeAll: '查看全部',
    from: '从',
    to: '到',
    showFilters: '显示筛选器',
    hideFilters: '隐藏筛选器',
    horizontal: '水平的',
    vertical: '垂直的',
    drop: '降低',
    orientation: '方向',
    goalProbability: '进球概率',
    assistProbability: '助攻概率',
    attackingDirection: '攻击方向',
    currentTeam: '现任团队',
    expectations: '期望',
    sideBySide: '并排',
    teamValue: '团队价值',
    fieldLayout: '场地布局',
    searchPlaceholder: '至少输入 {x} 个字母进行搜索'
  },
  playerScout: {
    dlabDatabase: '数据库',
    league: '联赛',
    top5: '前五',
    topCountries: '国家',
    tier: '级别',
    division1: '甲级',
    division2: '乙级',
    division3: '丙级',
    division4: '第四级',
    division5: '第五级',
    division6: '第六师',
    summary: '汇总',
    offensive: '进攻',
    defensive: '防守',
    gk: '守门员',
    all: '全部',
    physical: '体格',
    arrigo: '阿里戈',
    yearTooltip: '只允许一年',
    expectedThreat: '期望威胁值',
    expectedThreatTooltip: '所有持球时间内期望威胁贡献值',
    expectedThreatOP: '运动战传球期望威胁值',
    expectedThreatOPTooltip: '运动战期望威胁贡献值',
    expectedThreatInTeam: '期望威胁贡献值占比',
    expectedThreatInTeamTooltip: '球员期望威胁贡献值占比',
    ballProgression: '推进',
    ballProgressionTooltip: '大于10m的推进',
    deepProgression: '深度推进',
    deepProgressionTooltip: '到进攻五区的推进',
    ballRetention: '恢复球权比',
    ballRetentionTooltip: '成功恢复球权占比',
    ballRetentionOppHalf: '在对方半场恢复球权比',
    ballRetentionOppHalfExplicit: '\'持球且成功在对方半场保持球权的时间占比',
    finishing: '终结',
    finishingTooltip: '完成进球的射门占比',
    scoringContribution: '进球贡献值',
    scoringContributionTooltip: '助攻 + 进球',
    xgPerShot: '平均期望进球值/射门',
    xgPerGoal: '平均期望进球值/进球',
    headerPerCross: '平均传中到位值头球',
    completedCrosses: '传中到位数',
    crossingPct: '传中占比',
    crossingEfficiency: '传中效率',
    crossingEfficiencyTooltip: '传中效率（考量质量和数量）',
    longBalls: '长传球次数',
    longPassing: '长传球占比',
    dribblingPct: '盘带占比',
    throughBalls: '直传球次数',
    oppBoxTouches: '在对方禁区内的触球次数',
    oppBoxTouchesTooltip: '在对方禁区内的触球次数',
    openPlayKeyPasses: '运动战中关键传球数',
    openPlayKeyPassesTooltip: '运动战中成功完成射门进攻的传球次数',
    xGBuildup: '组织进攻的期望进球值',
    xGBuildupTooltip: '球员参与的成功完成射门进攻的期望进球贡献值（不包含射门和关键传球的期望进球值）',
    Assists: '助攻数',
    passPercentage: '传球占比',
    passPerLongBall: '长传球次数',
    passPerLongBallExplicit: '长传球次数',
    nonPenaltyGoals: '进球数（无点球）',
    xG: '期望进球值',
    xGExplicit: '期望进球值',
    shots: '射门数',
    xGShot: '平均射门期望进球值',
    xGChain: '期望进球贡献值',
    xGChainTooltip: '球员参与的成功完成射门进攻的期望进球贡献值',
    chancesCreated: '形成射门的传球数',
    chances: '进球机会数',
    dribbles: '盘带数',
    dribblesSuccessfull: '成功盘带次数',
    touches: '在对方禁区内的触球次数',
    xA: '期望助攻值',
    xAExplicit: '期望助攻值',
    xAOpenPlay: '运动战期望助攻值',
    xAOpenPlayExplicit: '运动战期望助攻值',
    passesOpponentBox: '在对方禁区内的传球次数',
    passesOB: '在对方禁区内的传球次数',
    passesFinalThirdTooltip: '在进攻三区的传球次数',
    passesSuccessful: '成功传球次数',
    passesSuccessfulTooltip: '成功传球次数',
    ballProgressionPassing: '推进传球数',
    ballProgressionPassingTooltip: '推进传球数',
    ballProgressionDribbling: '持球推进次数',
    ballProgressionDribblingTooltip: '持球推进次数',
    passesTotal: '传球数',
    passesTotalTooltip: '总尝试传球次数',
    shortPassesSuccessful: '成功短传次数',
    shortPassesSuccessfulTooltip: '成功短传次数',
    shortPassesTotal: '总短传数',
    shortPassesTotalTooltip: '总尝试短传次数',
    tackles: '抢断数',
    adjustedTackles: '形成球权交换的抢断数',
    interceptions: '拦截数',
    adjustedInterceptions: '形成球权交换的拦截数',
    aerials: '争顶数',
    aerialsPercent: '争顶占比',
    aerialEfficiency: '争顶效率',
    aerialEfficiencyTooltip: '争顶效率（考量质量和数量）',
    twd: '被过尝试抢断数',
    tacklesWasDribbled: '防守一对一成功',
    fouls: '犯规数',
    indPressure: '个人逼抢次数',
    pressure: '逼抢次数',
    dispossessed: '丢失球权数',
    recoveries: '恢复球权数',
    primary: '主要',
    secondary: '次要',
    position: '位置',
    nationality: '国籍',
    height: '身高',
    minHeight: '身高最低值',
    maxHeight: '身高最高值',
    age: '年龄',
    minAge: '年龄最小值',
    maxAge: '年龄最大值',
    games: '出场次数',
    minGames: '出场次数最小值',
    maxGames: '出场次数最大值',
    minutes: '出场时间（分钟）',
    minMinutes: '出场时间（分钟）最小值',
    maxMinutes: '出场时间（分钟）最大值',
    minPercentMinutes: '出场时间占比最小值',
    dates: '日期',
    marketValue: '市场身价',
    teams: '球队',
    contractEnd: '合同到期时间',
    minValue: '最小值',
    maxValue: '最大值',
    excludeTeams: '不包括球队',
    recentSearches: '最近搜索记录',
    saveSearch: '已保存搜索记录',
    loadSearch: '加载搜索记录',
    loadCollection: '加载合集',
    collection: '合集',
    search: '搜索',
    searchesList: '搜索清单',
    mySearches: '我的搜索',
    mySearchesDescription: '先前已保存的搜索记录',
    recentSearchesDescription: '最新条历史搜索记录',
    searchToLoad: '待加载搜索',
    recentSearch: '最近搜索记录',
    saveSearchSuccess: '成功保存的搜索记录',
    removeSearch: '删除搜索记录',
    removeSearchMessage: '确定删除该搜索记录',
    updateSearch: '更新搜索',
    updateSearchMessage: '您确定要更新搜索吗？',
    deleteSearchSuccess: '搜索记录已删除',
    playersFound: '已获取球员信息',
    addToCollection: '加入集合',
    npg: '进球数（非点球）',
    goals: '进球数',
    value: '值',
    nationalTeams: '国家队',
    gbeScore: '劳工证分值',
    dlIndex: '分值',
    minGbe: '最小劳工证分值',
    goalsConceded: '被进球数',
    npgConceded: '被进球数（非点球）',
    npgConcededTooltip: '被进球数（非点球）',
    xGOTConceded: '被射正值',
    xGOTConcededTooltip: '射正被救下值',
    goalsPrevented: '扑救次数',
    xGFacedPerShotOnTarget: '平均被射正值',
    xGFacedPerShotOnTargetTooltip: '平均被射正值',
    xGSavedPerxGFacedOnTarget: '平均扑救期望进球值',
    xGSavedPerxGFacedOnTargetTooltip: '计入值的扑救占比',
    savesPct: '扑救占比',
    savesOutOfBoxPct: '禁区外扑救占比',
    savesInBoxPct: '禁区内扑救占比',
    xGFacedPerGoal: '平均被进球值',
    xGFacedPerGoalTooltip: '进球所需值',
    catchingPct: '摘球占比',
    catchingTooltip: '摘球占比',
    passingOwnHalfPct: '本方半场传球占比',
    passingOwnHalfPctTooltip: '本方半场成功传球占比',
    passingOppHalfPct: '对方半场传球占比',
    passingOppHalfPctTooltip: '对方半场成功传球占比',
    passingContribution: '传球贡献占比',
    passingContributionTooltip: '传球贡献威胁值（高于平均值）',
    shotsPerGoal: '平均进球所需射门数',
    passesFinalThird: '进攻三区内传球数',
    passingFinalThird: '进攻三区内传球占比',
    claimAccuracy: '出击摘球准确率',
    claimAccuracyTooltip: '出击摘球数（高于平均值）',
    highTurnovers: '高位丢失球权次数',
    highTurnoversTooltip: '高位丢失球权数（近于40米）',
    shotEndingHighTurnovers: '高位丢失球权导致被射门数',
    shotEndingHighTurnoversTooltip: '高位丢失球权导致被射门数',
    goalEndingHighTurnovers: '高位丢失球权导致丢球数',
    goalEndingHighTurnoversTooltip: '高位丢失球权导致丢球数',
    avgCarriesProgress: '平均推进次数',
    avgCarriesProgressTooltip: '平均纵向传球距离',
    carriesChance: '带球创造机会数',
    carriesChanceTooltip: '形成关键传球的带球数',
    carriesAssist: '带球后形成助攻数',
    carriesAssistTooltip: '形成助攻的带球数',
    carriesShot: '带球后形成射门数',
    carriesShotTooltip: '形成射门的带球数',
    carriesGoal: '带球后形成进球数',
    carriesGoalTooltip: '形成进球的带球数',
    shotEndingSequence: '以射门终结的进攻',
    shotEndingSequenceTooltip: '球员参与的以射门终结的进攻次数',
    goalEndingSequence: '以进球终结的进攻',
    goalEndingSequenceTooltip: '球员参与的以进球终结的进攻次数',
    gbeScoreTooltip: '\'英足总管理机构认可',
    goalsPreventedTooltip: '非点球扑救数',
    freePlayers: '自由球员',
    index: '索引',
    playerName: '姓名',
    teamName: '球队名',
    secondPos: '第二位置',
    side: '侧',
    onlyOnLoan: '仅租借',
    dob: '出生日期',
    countryName: '国籍',
    secondCountryName: '第二国籍',
    seasonYear: '赛季',
    assists: '助攻数',
    placeholder: '您可以添加联赛筛选器',
    placeholder2: '点击搜索按钮显示结果',
    passesPct: '传球占比',
    passingPct: '传球占比',
    oppBoxPasses: '对方半场传球次数',
    adjustedClearances: '有目的的解围次数',
    aerialsPct: '争顶占比',
    leagueCountryCode: '联赛国家编号',
    shooting: '射正占比',
    xtPassing: '传球值',
    xtPassingTooltip: '传球期望威胁值',
    xtDribbling: '带球值',
    xtDribblingTooltip: '带球期望威胁值',
    foot: '主力脚',
    aggressiveActions: '侵略性进攻',
    aggressiveActionsTooltip: '失去球权两秒内的尝试抢断次数',
    tacklesAttempted: '尝试抢断次数',
    highDefensiveActionPct: '高位防守占比',
    highDefensiveActionPctTooltip: '离对方底线米内的防守占比',
    individualPressureOppHalf: '对方半场逼抢次数',
    individualPressureOppHalfTooltip: '衡量球员在对方半场进行逼抢时成功抢下球权次数的指标',
    xGBuildUp5Pass: '进攻组织最后五次传球值',
    xGBuildUp5PassTooltip: '球员参与的进攻组织最后五次传球（不包含射门和关键传球）xG值',
    chancesCreatedOpenPlay: '运动战创造机会数',
    chancesCreatedOpenPlayTooltip: '运动战形成射门前的总传球数',
    fmf: {
      Defender: '后卫',
      aerial: '争顶',
      goodDefender: '优秀后卫',
      goodPresence: '优秀球员',
      playmaking: '组织进攻',
      Fullback: '边后卫',
      defensiveness: '防守能力',
      offensiveness: '进攻能力',
      fast: '速度快',
      Forward: '前锋',
      goalChances: '进球机会',
      goodDecissions: '优秀的决策',
      individualTechnique: '个人技术',
      Goalkeeper: '守门员',
      footWork: '脚下技术',
      leadership: '领导力',
      Midfielder: '后腰',
      balance: '平衡度',
      ballRetention: '夺回球权占比',
      offensivePasses: '向前传球数',
      recoveries: '恢复球权次数',
      shotToGoal: '形成进球的射门',
      'Attacking-Midfielder': '前腰',
      defensiveGame: '防守阶段',
      offensiveGame: '进攻阶段',
      Winger: '边锋',
      crossing: '传中',
      deepProgressions: '深度推进',
      defendingEffort: '防守成功次数',
      facing: '面向'
    },
    yellowCards: '黄牌数',
    redCards: '红牌数',
    alert: '提示',
    yearOfBirth: '出生年份',
    minYearOfBirth: '最低出生年份',
    maxYearOfBirth: '最高出生年份',
    women: '女子',
    continental: '洲际',
    countryCup: '国内杯赛',
    statsName: '统计名称',
    abbreviation: '缩写',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: '仅显示上一场常规赛比赛',
    gamesWith60PlusMinsTooltip: '最少比赛时间超过 60 分钟的场次',
    starts: '开始',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: '至多选择名球员比较',
    requestReport: '请求报告',
    searchBarPlaceholder: '搜索球员或球队',
    allStats: '全部数据',
    placeholder: '您可以添加球员'
  },
  reports: {
    detailedInsights: '获取详细分析',
    features: '报告特性',
    performance: '表现',
    evolution: '进化',
    compareWithMyTeam: '与我的球队进行比较',
    similarPlayers: '相似球员',
    potentialTeams: '潜在球队',
    requestSuccess: '请求发送成功',
    requestAt: '已请求',
    reportConversation: '报告对话',
    writeYourMessage: '输入信息...',
    you: '您'
  },
  state: {
    requested: '已请求',
    inProgress: '进行中',
    delivered: '已交付'
  },
  langs: {
    es: '西班牙语',
    en: '英语',
    fr: '法语',
    de: '德语',
    it: '意大利语',
    pt: '葡萄牙语',
    tr: '土耳其语',
    jp: '日语',
    cn: '中文',
    sa: '阿拉伯',
    nl: '荷兰语',
    pl: '波兰语',
    sv: '瑞典语',
    cs: '捷克语',
    ko: '韩语',
    hu: '匈牙利语',
    ru: '俄语'
  },
  langsArea: {
    europe: '欧洲',
    asia: '亚洲',
    arabic: '阿拉伯语'
  },
  inbox: {
    subtitle: '保持更新',
    new_injury_alert: '新伤病提醒',
    new_contract_alert: '新合同提醒',
    new_team_alert: '新签名提醒',
    new_marketValue_alert: '新身价提醒',
    new_game_alert: '新游戏播放警报',
    receive_mail: '接收邮件',
    receive_mail_subtitle: '接收符合筛选条件的玩家的每日邮件',
    receive_notifications: '通知',
    receive_notifications_subtitle: '在应用程序中接收通过筛选的球员的通知',
    changedTo: '换到',
    alerts: '提醒',
    includedIn: '已包括',
    noContract: '无合同',
    newMessages: '新消息',
    reply: {
      reply: 'Reply',
      replyTitle: 'Give feedback to the client:',
      replyPlaceholder: 'The user will receive the reply along with the status update'
    }
  },
  gameAnalysis: {
    subtitle: '获取近期比赛的分析',
    subtitle2: '展示未来七天的比赛',
    subtitle3: '从最近的比赛中获得启示，并探索下一场比赛',
    seeDetail: '查看详情'
  },
  statsNaming: {
    Possession: '控球率',
    TimePossession: '控球时间',
    PassesPerShots: '形成射门的平均传球数',
    PPDA: '防守动作中平均被传球数',
    ExpectedPoints: '期望得分值',
    Points: '得分',
    Directness: '直接度',
    PassesPerLongBall: '长传球平均传球数',
    CrossingPerXG: '每传中数',
    PenaltySavedPenaltyFaced: '救下点球数/守点球数比',
    Goals: '进球数',
    PenaltyShots: '点球数',
    PenaltyGoals: '点球进球',
    NonPenaltyGoals: '进球数（非点球）',
    NPGOpenPlay: '运动战进球数（非点球）',
    NPGSetPiece: '定位球进球数（非点球）',
    Shooting: '射门',
    Finishing: '终结',
    xGEfficiency: '效率',
    HeaderPerShot: '每次射门的平均头球数',
    HeaderPerCross: '每次传中的平均头球数',
    HeadedGoals: '头球破门',
    GoalsConceded: '失球数',
    SavesInBox: '保存在盒子里',
    SavesOutBox: '开箱即用保存',
    Assists: '助攻数',
    ThroughBalls: '直传球次数',
    CrossEfficiency: '传中效率',
    ScoringContribution: '进球分部',
    xAssistsOpenPlay: '运动战期望助攻值',
    xAssistsSetPiece: '定位球期望助攻值',
    xAssistsOpenPlayInTeam: 'x 协助团队公开比赛',
    xAssistsSetPieceInTeam: '队内助攻',
    xGBuildupFinalThird: '进攻三区进攻组织值',
    xGChainFinalThird: '进攻三区链值',
    BallProgressionPassing: '传球推进次数',
    BallProgressionDribbling: '带球推进次数',
    TacklesWasDribbled: '防守一对一成功',
    TacklesSuccessful: '成功铲断',
    Interceptions: '拦截数',
    Clearances: '解围数',
    Fouls: '犯规次数',
    Recoveries: '恢复球权次数',
    Shots: '射门数',
    ShotsPerGoal: '进球平均射门数',
    ShortPassesSuccessful: '成功短传数',
    PassingSuccessForwardPct: '成功向前传球率',
    PassingSuccessBackwardPct: '成功向后传球率',
    PassingForwardBackwardPct: '向前传球占比',
    LongBallPerPassesPct: '长传球占比',
    LongBallReceived: '被长传球次数',
    LongBallReceivedOppHalf: '对方半场接长传球数',
    OffensiveActions: '进攻次数',
    DribblesAttempted: '尝试盘带次数',
    SuccessfulDribblesPct: '成功盘带占比',
    OffensiveTouchesOutBoxPct: '禁区外威胁触球占比',
    BallRetention: '恢复球权占比',
    PassingPct: '传球占比',
    PassingOwnHalfPct: '本方半场传球占比',
    PassingOppHalfPct: '对方半场传球占比',
    PassingFinalThird: '进入进攻三区的传球次数',
    PassesFinalThirdTotal: '总通过决赛⅓',
    PassingFinalThirdPct: '进入进攻三区的传球占比',
    LongBallSuccessful: '成功到位长传数',
    LongBallPct: '长传球占比',
    LongBallTotal: '长传总数',
    SavesPct: '扑救占比',
    SavesInBoxPct: '禁区内扑救占比',
    SavesOutOfBoxPct: '禁区外扑救占比',
    xGSavedPerXGFacedOnTarget: '成功扑救xG值/被射正xG值比',
    xGFacedOnTargetPerGoalReceived: '丢球值',
    xGFacedOnTargetEfficiency: '扑救数',
    xGFacedOnTarget: '被射正值',
    IndividualPressure: '个人逼抢',
    AerialEfficiency: '争顶效率',
    AerialWins: '争顶成功次数',
    AerialWinsPct: '争顶成功占比',
    xG: '期望进球值',
    xGDiff: '期望进球差值',
    xGOpenPlay: '运动战期望进球值',
    xGSetPiece: '定位球期望进球值',
    xGPerShot: '射门平均期望进球值',
    ChancesCreated: '创造机会数',
    CompletedCrosses: '传中到位数',
    Crossing: '传中占比',
    OpenPlayKeyPasses: '运动战关键传球数',
    OpenPlayKeyPassesInTeam: '队内关键传球',
    OpenPlayPassesIntoOpponentBox: '运动战传球到对方禁区内次数',
    OpenPlayPassesIntoOpponentBoxSuccessful: '运动战传球到对方禁区内次数',
    xAssists: '期望助攻值',
    xGChain: '期望进球贡献值',
    xGBuildup: '进攻组织值',
    xGBuildupInTeam: '进攻组织值 in Team',
    BallProgression: '推进',
    SuccessfulDribbles: '成功过人次数',
    Dispossessed: '丢失球权',
    TouchesInOpponentBox: '在对方禁区内触球次数',
    xGSavedPerShot: '平均扑救值',
    BallRetentionOppHalf: '在对方半场恢复球权占比',
    DeepProgression: '深度推进次数',
    DeepProgressionFinalThird: '深度推进到进攻三区次数',
    FoulsTaken: '犯规次数',
    PenaltiesTaken: '罚点球次数',
    BlockedCrosses: '阻挡传中次数',
    BlockedShots: '阻挡射门次数',
    Blocks: '阻挡次数',
    NonPenaltyGoalsAgainst: '非点球进球数',
    Headers: '头球次数',
    AveragePassDistance: '平均传球距离',
    ProgressiveRuns: '向前跑动',
    xT: '期望威胁值',
    xTOpenPlay: '运动战期望威胁值',
    xTSetPiece: '定位球期望威胁值',
    xGOT: '射正期望进球值',
    BadActions: '不良行为',
    BadActionsOwnHalf: '本方半场的糟糕处理',
    AerialsWonOwnBox: '本方禁区内争顶成功',
    AerialsWonOppBox: '对方禁区内争顶成功',
    AerialsTotalOppBox: '对方禁区内总争顶次数',
    AerialsTotalOwnBox: '本方禁区内总争顶次数',
    FoulsOwnHalfPct: '本方半场犯规占比',
    RecoveriesOppHalf: '对方半场恢复球权次数',
    DuelsPct: '成功争球次数百分比',
    TacklesUnsuccessful: '不成功的铲球',
    TacklesWasDribbledFirstThird: '防守一对一成功 ⅓',
    TacklesWasDribbledSecondThird: '防守一对一成功 ⅔',
    TacklesWasDribbledFinalThird: '防守一对一成功 决赛 ⅓',
    BallProgressionFinalThird: '推进到进攻三区次数',
    DuelsTotal: '争球',
    QuickRecoveries: '快速恢复球权次数',
    ShotsPerNPG: '平均非点球进球所需射门数',
    ShotsOutBox: '禁区外射门数',
    GoalsOutBox: '禁区外进球数',
    ShootingOutBox: '禁区外射门占比',
    HandPassing: '手抛球传球占比',
    Catching: '摘球占比',
    Caught: '扑救',
    ClaimAccuracy: '出击成功率',
    HighTurnovers: '高位丢失球权次数',
    ShotEndingHighTurnovers: '高位丢失球权导致被射门数',
    GoalEndingHighTurnovers: '高位丢失球权导致被进球数',
    AverageCarriesProgress: '平均带球推进次数',
    ChanceEndingCarries: '带球形成机会次数',
    AssistEndingCarries: '带球形成助攻次数',
    ShotEndingCarries: '带球形成射门次数',
    GoalEndingCarries: '带球形成进球次数',
    ShotEndingSequence: '形成射门的进攻次数',
    GoalEndingSequence: '形成进球的进攻次数',
    xGPerNPG: '平均非点球进球值',
    AerialWonOffensive: '进攻赢得争顶次数',
    AerialWonDefensive: '防守赢得争顶次数',
    xGAgainst: '被进球期望值',
    xGDiffAgainst: '被进球期望差值',
    xGPerNPGAgainst: '被非点球进球期望值',
    xGSetPieceAgainst: '被定位球进球期望值',
    xGOpenPlayAgainst: '运动战被进球期望值',
    xGPerShotAgainst: '平均射门被进球期望值',
    ShotsAgainst: '被射门数',
    ShotsOnTargetAgainst: '被射正数',
    ShotsOnTargetInBoxAgainst: '禁区内射门失球',
    ShotsOnTargetOutBoxAgainst: '禁区外射门失球',
    RivalPossession: '对手推进',
    AerialDefensivePct: '防守头球对抗成功率',
    HighRecoveries: '高位恢复球权',
    HighDefensiveActions: '高位防守动作占比',
    HighDefensiveActionPct: '高位防守动作占比',
    HighDefensiveDistance: '高位防守距离',
    PassesPerPossession: '平均控球率传球数',
    LengthPerPossession: '平均控球率距离',
    xTNet: '净期望威胁值',
    AvgCarriesDistance: '平均带球距离',
    PassesForwardPct: '向前传球占比',
    PassesForwardSuccessful: '成功的前传',
    PassesForwardTotal: '前传球总数',
    TacklesAttempted: '尝试抢断次数',
    DuelsLost: '争球失败次数',
    Carries: '带球次数',
    CarriesPct: '带球占比',
    Aerials: '争顶次数',
    ProgressivePassesReceivedIntoBox: '被对手推进传球进入禁区次数',
    PassesOppHalf: '对方半场传球次数',
    ShotsOnTarget: '射正数',
    AggressiveActions: '侵略性动作次数',
    Crosses: '传中次数',
    xGBuildup5pass: '进攻最后次传球值',
    SpeedSequence: '\'进攻速度',
    Touches: '触球次数',
    AerialsTotalOppHalf: '对方半场总争顶次数',
    AerialsWonOppHalf: '空中技巧赢得了对手。一半',
    AerialsWonOppHalfPct: '对方半场赢得争顶占比',
    AerialsPctOppBox: '对方禁区内赢得争顶占比',
    AerialsPctOwnBox: '本方禁区内赢得争顶占比',
    AerialDefensive: '空中防御',
    AerialOffensive: '空中进攻',
    AerialOffensivePct: '空中进攻%',
    IndividualPressureOppHalf: '对方半场个人逼抢次数',
    ChancesCreatedOP: '运动战创造机会数',
    TouchesPerShot: '平均射门前触球数',
    PassesFinalThirdTotalPct: '传球进入进攻三区占比',
    xACrosses: '传中期望助攻值',
    Passes: '传球数',
    PassesSuccessful: '成功传球数',
    TacklesWasDribbledFouls: '地面争球占比',
    OffsidesCaught: '越位次数',
    ProgressivePassesReceivedFinalThird: '被对手传球到进攻三区次数',
    ProgressivePassesReceived: '被对手推进传球次数',
    Breadth: '宽度',
    DuelsDefTotal: '防守争球次数',
    DefensiveActions: '防守动作次数',
    ProgressivePassesReceivedOppHalf: '被对手对方半场推进传球次数',
    CompletedCrossesOP: '运动战成功传球数',
    CrossingOP: '运动战传中占比',
    CrossesOP: '公开比赛总传中',
    PassingContribution: '传球贡献占比',
    BallProgressionOppHalfInTeam: '球队对方半场推进球占比',
    PassesOPIntoBoxInTeam: '球队运动战传入对方禁区传球占比',
    TouchesOppBoxInTeam: '球队在对方禁区内触球占比',
    xGOPInTeam: '球队运动战占比',
    DeepPasses: '深入传球',
    DeepPassesTotal: '深山口',
    DefensiveDuelsPct: '防守争球占比',
    DefensiveDistance: '防守距离',
    QuickRecoveriesPct: '快速恢复球权占比',
    DiffDefensiveDistanceTeam: '球队防守距离差值',
    xTPassing: '传球期望威胁值',
    xTPassing100Passes: '次传球的平均值',
    ProgressivePassesAccurate: '推进传球',
    PassAbility: '传球能力',
    OPPassesIntoOppBoxPct: '运动战传球进入对方禁区内占比',
    EntriesOppBox: '进入对方禁区次数',
    Crosses6yardBox: '传中进入小禁区次数',
    Cutbacks: '拦截路线次数',
    xTDribbling: '盘带期望威胁值',
    AvgShotDistance: '平均射门距离',
    xGOnTarget: '射正值',
    FinishingxGOT: '终结射正值',
    DribblesWonOwnHalf: '本方半场成功过人次数',
    DribblesOwnHalf: '本方半场尝试过人次数',
    DribblesOwnHalfPct: '本方半场尝试过人占比',
    DribblesWonOppHalf: '对方半场成功过人次数',
    DribblesOppHalf: '对方半场尝试过人次数',
    DribblesOppHalfPct: '对方半场尝试过人占比',
    DribblesWonFinalThird: '进攻三区成功过人次数',
    DribblesFinalThird: '进攻三区尝试过人次数',
    DribblesFinalThirdPct: '进攻三区尝试过人占比',
    ShotEndingHighRecoveries: '高位抢断后射门',
    PassingFinalThirdAgainst: '被传入进攻三区次数',
    OpenPlayPassesIntoOpponentBoxAgainst: '被传入禁区的运动战传球总数',
    EntriesOppBoxAgainst: '被对手进入禁区的次数',
    DeepProgressionAgainst: '被推进至深区次数',
    TouchesInOpponentBoxAgainst: '禁区内被控球次数',
    Score: '评分',
    PDScore: '物理分数',
    OrlegiScore: '评分',
    SirScore: '评分',
    ExcScore: '评分',
    xTOPInTeam: '球队运动战期望威胁值',
    YellowCards: '黄牌数',
    RedCards: '红牌数',
    xTOpenPlayAgainst: '运动战对手期望威胁值',
    xTSetPieceAgainst: '定位球对手期望威胁值',
    NPGOpenPlayAgainst: '运动战非点球丢球数',
    NPGSetPieceAgainst: '定位球非点球丢球数',
    PassesOppHalfPerPossession: '对方半场平均控球率传球数',
    AverageTimeRecovery: '平均恢复球权时间',
    ExpectedPassing: '预期通过率',
    NumPossession10Passes: '传球 10 次',
    PassesReceived: '收到的传球数',
    PassesReceivedFinalThird: '最终通过 ⅓',
    ProgressivePassesTotalPct: '递进传球百分比',
    ShortPassesPct: '%短传',
    TouchesOppBoxOppTeam: '他在场时对手在己方禁区的触球次数',
    ShotsOnTargetOppTeam: '他在场时对手射正次数',
    NPGOppTeam: '他在场时对手非点球xG',
    ShotsOpenPlay: '运动战射门',
    xGSetPiecePerxG: '定位球xG占xG比例',
    ShotsOpenPlayAgainst: '运动战被射门',
    ShotsFromDribble: '过人后射门',
    GoalsFromDribble: '过人后进球',
    PassesIntoFinalThird: '传球进入最后三分之一',
    PassesIntoFinalThirdTotal: '进入最后三区的传球总数',
    PassesInsideFinalThird: '最后三分之一内的传球',
    PassesInsideFinalThirdTotal: '决赛 ⅓ 内的总传球数',
    PassesFinalThirdNoArea: '通过最后三分之一（不带盒子）',
    PassesIntoOppBox: '传入对方禁区的传球',
    CarriesFinalThird: '带球进入最后三分之一',
    CarriesInsideFinalThird: '最后三分之一内的带球',
    CarriesFinalThirdNoBox: '进行最后三分之一（不带盒子）',
    CarriesIntoOppBox: '带球进入对方禁区',
    TimePossessionAgainst: '对方控球时间',
    TimePossessionTotal: '双方总控球时间',
    PassesInBox: '己方禁区内传球',
    LongThrowInSuccessful: '成功的长距离界外球',
    LongThrowInTotal: '总长距离界外球次数',
    LongThrowInPct: '长距离界外球成功率',
    Games: '玩过的游戏',
    PointsPerGame: '每场比赛得分',
    ExpectedPointsDiff: '预期积分差',
    PassesTotalOwnHalf: '己方半场传球总数',
    PassesOwnHalf: '传球给本方半场',
    PassesTotalOppHalf: '传球总数为对手一半',
    ProgressivePassesTotal: '渐进传球总数',
    DuelsWon: '决斗获胜',
    NonPenaltySaves: '非罚球扑救',
    BadActionsOppHalf: '不良行为对手一半',
    CarriesSuccessful: '进行成功',
    ShotsOnTargetOutBox: '开箱即用的射门',
    TotalDistance: '总距离',
    DistanceTIP: '持球球队距离',
    DistanceOTIP: '非持球球队距离',
    SprintsNumber: '冲刺数量',
    SprintsDistance: '短跑 距离',
    WalkingDistance: '步行距离',
    JoggingDistance: '慢跑距离',
    RunningDistance: '跑步距离',
    ExtremeAccelerations: '极端加速',
    NumberOfRuns: '跑步次数',
    HsrNumber: 'HSR 数量',
    HsrDistance: 'HSR 距离',
    SprintNumberDeclinePct: '冲刺次数枯竭占比',
    SprintDistanceDeclinePct: '冲刺距离枯竭占比',
    SprintNumberDecline: '冲刺次数枯竭占比',
    SprintDistanceDecline: '冲刺距离枯竭占比',
    HsrDistancePct: '高速冲刺距离占比',
    SprintDistancePct: '冲刺距离占比',
    Accelerations: '加速次数',
    ExplosiveDistance: '爆发冲刺距离',
    MaxSpeed: '最高速度',
    AvgMaxSpeed: '平均最高速度',
    MaxAccelerations: '最大加速',
    BypassedPlayersByPasses: '被绕过的球员',
    BypassedDefendersByPasses: '被绕过的防守球员',
    PassesBypassingPlayers: '绕过球员的传球',
    PassesBypassingDefenders: '绕过防守球员的传球',
    BypassedPlayersPerPass: '每次传球绕过的球员',
    BypassedDefendersPerPass: '每次传球绕过的防守球员',
    LineBreakingPasses: '打破防线的传球',
    LineBreakingPassesMD: '打破防线的传球 MD',
    LineBreakingPassesM: '',
    LineBreakingThroughBalls: '打破防线的直塞球',
    LineBreakingPassesPerPass: '每次传球中的穿越防线传球占比',
    TotalPassesUnderStrongPressure: '在高压下的传球总数',
    TotalPassesUnderLightPressure: '在低压下的传球总数',
    SuccessfulPassesUnderStrongPressure: '在高压下的传球',
    SuccessfulPassesUnderLightPressure: '在低压下的传球',
    PassingUnderStrongPressure: '在高压下的传球表现',
    PassingUnderLightPressure: '在低压下的传球表现',
    PassReceiptsInSpaceCompleted: '在空位完成的接球',
    PassReceiptsInSpace: '在空间中接收的传球',
    PassReceiptsInSpaceCompletedFirstThird: '第一三分之一空间接球完成',
    PassReceiptsInSpaceCompletedSecondThird: '第二三分之一空间接球完成',
    PassReceiptsInSpaceCompletedFinalThird: '最后三分之一空间接球完成',
    PassReceiptsInSpaceCompletedOppHalfRight: '对方半场右侧空间接球完成',
    PassReceiptsInSpaceCompletedOppHalfCenter: '对方半场中路空间接球完成',
    PassReceiptsInSpaceCompletedOppHalfLeft: '对方半场左侧空间接球完成',
    PassReceiptsInSpaceFirstThird: '第一三分之一空间接球',
    PassReceiptsInSpaceSecondThird: '第二三分之一空间接球',
    PassReceiptsInSpaceFinalThird: '最后三分之一空间接球',
    PassReceiptsInSpaceOppHalfRight: '对方半场右侧空间接球',
    PassReceiptsInSpaceOppHalfCenter: '对方半场中路空间接球',
    PassReceiptsInSpaceOppHalfLeft: '对方半场左侧空间接球',
    TotalStrongOnBallPressures: '对球的强压力总数',
    TotalLightOnBallPressures: '对球的轻压力总数',
    SuccessfulStrongOnBallPressures: '对球的强压力',
    SuccessfulLightOnBallPressures: '对球的轻压力',
    StrongOnBallPressuresPct: '强压力的百分比',
    LightOnBallPressuresPct: '轻压力的百分比',
    TimesBypassedByPasses: '被传球突破',
    TimesBypassedByCarries: '被带球突破',
    TimesBypassedByActions: '被行动突破',
    BypassedPlayersByCarries: '被带球突破的球员',
    BypassedDefendersByCarries: '被带球突破的后卫',
    BypassedPlayersByActions: '被行动突破的球员',
    BypassedDefendersByActions: '被行动突破的后卫',
    CarriesBypassingPlayers: '带球突破球员',
    CarriesBypassingDefenders: '带球突破后卫',
    BypassedPlayersPerCarry: '每次带球突破球员数',
    BypassedDefendersPerCarry: '每次带球突破后卫数',
    LineBreakingCarries: '穿越防线的带球',
    LineBreakingCarriesMD: '穿越后卫和中场线的带球',
    LineBreakingCarriesM: '穿越中场线的带球',
    LineBreakingCarriesD: '穿越后卫线的带球',
    LineBreakingCarriesPerCarry: '每次带球穿越防线比率',
    LineBreakingActions: '穿越防线的行动',
    LineBreakingActionsMD: '穿越后卫和中场线的行动',
    LineBreakingActionsM: '穿越中场线的行动',
    LineBreakingActionsD: '穿越后卫线的行动',
    PassesPerLineBreakingPass: '每次穿越传球对应的传球数',
    CarriesPerLineBreakingCarry: '每次穿越带球对应的带球数',
    LinesBrokenByPasses: '通过传球打破的防线数',
    LinesBrokenByCarries: '通过带球打破的防线数',
    LinesBrokenByActions: '通过行动打破的防线数',
    LinesBrokenPerPass: '每次传球打破的防线数',
    LinesBrokenPerCarry: '每次带球打破的防线数',
    AvgLastDefenderDistanceIP: '最后防守球员距离 IP',
    AvgLastDefenderDistanceOOP: '最后防守球员距离 OOP',
    AvgDefensiveLineDistanceIP: '防线距离 IP',
    AvgDefensiveLineDistanceOOP: '防线距离 OOP',
    AvgRBDistanceIP: '右后卫距离 IP',
    AvgRBDistanceOOP: '右后卫距离 OOP',
    AvgLBDistanceIP: '左后卫距离 IP',
    AvgLBDistanceOOP: '左后卫距离 OOP',
    AvgBlockDistanceIP: '防守区块距离 IP',
    AvgBlockDistanceOOP: '防守区块距离 OOP',
    AvgBlockAreaIP: '防守区块面积 IP',
    AvgBlockAreaOOP: '防守区块面积 OOP',
    AvgDefensiveLineWidthOOP: '防线宽度 OOP',
    AvgOffensiveLineLastThirdWidthIP: '进攻线最后三分之一宽度 IP',
    AvgLByIP: '左后卫位置 IP',
    AvgRByIP: '右后卫位置 IP',
    AvgOffensiveLineDistanceIP: '进攻线距离 IP',
    AvgOffensiveLineLastThirdDistanceIP: '进攻线最后三分之一距离 IP',
    AvgOffensiveLineWidthIP: '进攻线宽度 IP',
    OffBallRuns: '无球跑动总数',
    OffBallRunsOverlap: '外插跑动',
    OffBallRunsUnderlap: '内切跑动',
    OffBallRunsRunAhead: '向前跑动',
    OffBallRunsRunBehind: '身后跑动',
    OffBallRunsCrossReceiver: '接应传中跑动',
    OffBallRunsSupport: '支援跑动',
    OffBallRunsComingShort: '短距离支援跑动',
    description: {
      Possession: '球队控球率',
      TimePossession: '球队控球时间',
      PassesPerShots: '每次射门的平均传球次数',
      PPDA: '每个防守动作的失球次数。PPDA衡量的是球队在控球时对对方球员施加的压力。该值对应于对手在被打断之前能够完成的一行的平均传球数。该值越高，对手被允许完成的传球就越多',
      Directness: '衡量一个团队有多直接。直接度高低与否与向前传球的次数/侧面传球次数比有关',
      ExpectedPoints: '球队期望得分，根据预期进球和失球计算。这个指标可以更好地评估团队在一场比赛(或一组比赛)中的表现，并将其与实际得分进行比较',
      PassesPerLongBall: '成功长传占完成传球总数的百分比',
      CrossingPerXG: '传中球制造的预期进球占比',
      PenaltySavedPenaltyFaced: '扑出的点球占扑出的所有点球的百分比',
      Goals: '每分钟比赛的进球数',
      PenaltyShots: '点球总射门数',
      PenaltyGoals: '点球总进球数',
      NonPenaltyGoals: '每分钟比赛的进球数不包括点球',
      NPGOpenPlay: '在不包括点球的情况下，比赛中运动战取得的进球数',
      NPGSetPiece: '比赛中通过定位球打入的进球数，不包括点球',
      Shooting: '射正百分比',
      Finishing: '射门得分的百分比',
      xGEfficiency: '一名球员进球所需的预期进球值',
      HeaderPerShot: '的头球次数',
      HeaderPerCross: '球员头球传中的次数占全队完成传中次数的百分比',
      Assists: '每分钟助攻数',
      ThroughBalls: '比赛中，球员通过进攻跑动创造进球变化的球数',
      CrossEfficiency: '将成功传中的百分比与成功传中数量结合起来的度量',
      ScoringContribution: '比赛的助攻数和进球数',
      xAssistsOpenPlay: '在的公开比赛中预期助攻数',
      xAssistsSetPiece: '定位赛中预期助攻数',
      xAssistsOpenPlayInTeam: '在每团队分钟的公开比赛中预期助攻数',
      xAssistsSetPieceInTeam: '每团队分钟定位赛中预期助攻数',
      xGChainFinalThird: '球员参与进攻三区进攻的值',
      xGBuildupFinalThird: '球员参与进攻三区进攻的xG值（不包括造成射门的射门和传球）',
      BallProgressionPassing: '球员通过传球将球推进米或以上的次数',
      BallProgressionDribbling: '球员带球前进米或米以上的次数',
      TacklesWasDribbled: '该指标考虑了球员通过抢断收复球权的次数与传球/跑动的次数的百分比，指标越高越好',
      TacklesSuccessful: '球员成功铲断次数',
      Interceptions: '比赛中，球员拦截传球以阻止球到达目标的次数',
      Clearances: '球员将球击出防守区域的次数',
      Fouls: '球员的犯规次数',
      Recoveries: '比赛中球员回复球权的次数',
      Shots: '比赛的总射门次数',
      ShotsPerGoal: '给守门员打进一个非点球进球需要的射正数',
      ShortPassesSuccessful: '完成的短传(12米以下)',
      PassingSuccessForwardPct: '向前成功传球的百分比',
      PassingSuccessBackwardPct: '向后成功传球的百分比',
      PassingForwardBackwardPct: '向前传球与向后传球的比率',
      LongBallPerPassesPct: '长传(>32米)占球员传球总数的百分比',
      LongBallReceived: '接长传(>32米)次数',
      LongBallReceivedOppHalf: '在对方半场接到长传(>32米)次数',
      OffensiveActions: '进攻行动',
      DribblesAttempted: '的运球次数',
      SuccessfulDribblesPct: '运球成功/运球次数',
      OffensiveTouchesOutBoxPct: '开箱即用的进攻触球百分比',
      BallRetention: '\'拥有球权并且最终没有丢球的时间百分比',
      PassingPct: '完成的传球占球员所有传球的百分比',
      PassingOwnHalfPct: '完成的传球占球员传球总数的百分比(只在本方半场)',
      PassingOppHalfPct: '完成的传球占球员传球总数的百分比(只在对方半场)',
      PassingFinalThird: '完成传球至进攻三区的次数',
      PassesFinalThirdTotal: '最后三分之一的传球尝试总数，不包括传中、定位球、角球和界外球',
      PassingFinalThirdPct: '完成的传球占球员所有传球的百分比(仅传球到进攻三区)',
      LongBallSuccessful: '完成传球超过32米的次数',
      LongBallPct: '完成传球超过32米/累计传球超过32次',
      LongBallTotal: '32米以上总传球次数',
      SavesPct: '扑救占总射门数的百分比',
      SavesInBoxPct: '禁区内的射门被扑出的百分比',
      SavesOutOfBoxPct: '禁区外的射门被扑出的百分比',
      xGSavedPerXGFacedOnTarget: '表示守门员扑出的预期xG的百分比的系数。该指标的值为1意味着守门员扑出了球队所有的预期进球，而值为0则意味着对手产生的所有预期进球最终都进了球',
      xGFacedOnTargetPerGoalReceived: '表示需要多少个预期进球才能使某个守门员进球的指标。在这个指标中得分高意味着要面对该门将进球就必须创造大量的xG',
      xGFacedOnTargetEfficiency: '守门员挡出非点球进球的次数。这是守门员收到的预期进球数减去(非点球)失球数。表示由于守门员的原因，对手没有进球的次数',
      xGFacedOnTarget: '被守门员扑救和得分的总xG',
      IndividualPressure: '衡量一名球员在压迫对手时成功次数的指标',
      AerialEfficiency: '将空中争顶的成功率与赢得空中争顶的数量结合起来的指标',
      AerialWins: '玩家赢得的争顶次数',
      AerialWinsPct: '在球员参与的空中争顶中，玩家赢得的空中争顶次数',
      xG: '产生的预期进球。这个指标是基于不同的变量(距离、角度、打法、身体部位等)来衡量射门的概率。',
      xGDiff: '与进球数差',
      xGOpenPlay: '运动战期望进球值',
      xGSetPiece: '定位球期望进球值',
      xGPerShot: '球员的平均射门xG。这个指标衡量的是射门的平均危险性。它越高，你的射门就越有可能进球。每次高射的xG意味着球员选择了正确的射门。',
      ChancesCreated: '射门前的传球次数',
      CompletedCrosses: '完成的传中次数',
      Crossing: '成功传中次数占尝试传中次数的百分比',
      OpenPlayKeyPasses: '球员在的运动战中完成的传球次数',
      OpenPlayKeyPassesInTeam: '球员在队内公开比赛中完成传球的百分比',
      OpenPlayPassesIntoOpponentBox: '在的比赛中，球员在对方禁区内完成的传球次数',
      OpenPlayPassesIntoOpponentBoxSuccessful: '在的比赛中，球员在对方禁区内完成的传球次数',
      xAssists: '分析比赛中创造机会质量的指标。每个助攻都有一个基于射门得分概率的值。这个值是根据传球的位置、类型(传中球定位球等)、比赛状态等来分配的。与xG不同的是，xA是一个理想的指标，因为创造者只能控制他的高质量传球(xA)，而他的助攻数取决于终结者',
      xGChain: '球员参与的数量',
      xGBuildup: '类似于xG Chain，但不考虑序列的最后2名球员(不包括射门和导致射门的传球)',
      xGBuildupInTeam: '进攻组织值 in Team',
      BallProgression: '球员通过传球、带球或两种方式前进10米以上的次数()',
      SuccessfulDribbles: '比赛成功盘带',
      Dispossessed: '比赛中球员被铲断并失去控球权的次数',
      TouchesInOpponentBox: '比赛中一名球员在对方禁区内控球的次数',
      xGSavedPerShot: '被射正的平均进球概率',
      BallRetentionOppHalf: '\'控球并且没有在对手半场丢球的时间百分比',
      DeepProgression: '一名球员持球到达场地五区的次数，加上该球员在五区控球的次数',
      DeepProgressionFinalThird: '球员持球到达球场最后三区的次数，加上该球员在最后三区控球的次数',
      FoulsTaken: '球员比赛中被犯规的次数',
      PenaltiesTaken: '比赛中球员在对方禁区内被犯规的次数',
      BlockedCrosses: '被球员拦截的传中次数',
      BlockedShots: '比赛中被球员阻挡的射门次数',
      NonPenaltyGoalsAgainst: '非点球失球数',
      GoalsConceded: '赛失球数',
      Headers: '头球射门次数',
      HeadedGoals: '赛中头球进球数',
      Points: '球队获得的积分数',
      SavesInBox: '赛中禁区内射门扑救次数',
      SavesOutBox: '赛中禁区外射门扑救次数',
      ShotsOnTargetInBoxAgainst: '赛从禁区内射正的次数',
      ShotsOnTargetOutBoxAgainst: '赛中禁区外射门失球数',
      AveragePassDistance: '平均传球距离，以米为单位',
      ProgressiveRuns: '成功的带球使控球距离对手球门更近20%',
      xT: '预期威胁(xT)是一个衡量球员携带或传球到更有可能进球的区域对对手造成威胁的指标。',
      xTOpenPlay: '在运动战中产生的预期威胁',
      xTSetPiece: '由定位球产生的预期威胁',
      xGOT: '预期目标达到目标。门将面临的预期进球数。这个指标只考虑了射正(不包括射偏和在门柱上的射门)',
      BadActions: '所有不良行为的总和',
      BadActionsOwnHalf: '本方半场所有失误动作总次数',
      AerialsWonOwnBox: '本方禁区内争顶成功次数',
      AerialsWonOppBox: '对方禁区内争顶成功次数',
      AerialsTotalOppBox: '对方禁区内争顶尝试次数',
      AerialsTotalOwnBox: '本方禁区内争顶尝试次数',
      FoulsOwnHalfPct: '本方半场的犯规百分比',
      RecoveriesOppHalf: '比赛中，球员在对方半场内恢复球权次数',
      DuelsPct: '争球成功百分比',
      TacklesUnsuccessful: '当对手成功运球超过球员时球员未能赢得球的次数',
      TacklesWasDribbledFirstThird: '防守一对一成功',
      TacklesWasDribbledSecondThird: '防守一对一成功 ⅔',
      TacklesWasDribbledFinalThird: '防守一对一成功 决赛 ⅓',
      BallProgressionFinalThird: '最后三区的推进球次数',
      DuelsTotal: '钟的拦截、高空球、触球、运球和犯规总数',
      QuickRecoveries: '在失去控球权后5秒内，在距离本方球门40米或更远的地方追回球',
      ShotsPerNPG: '非点球进球的平均射门次数',
      ShotsOutBox: '禁区外射门次数',
      GoalsOutBox: '禁区外进球数',
      ShootingOutBox: '禁区外射正的百分比',
      HandPassing: '手抛传球精准度',
      Catching: '守门员接住球的扑救次数百分比',
      Caught: '保存守门员接球和持球的位置，防止第二次比赛',
      ClaimAccuracy: '衡量守门员接/挡空中球的能力。数字大于1表示守门员接到的空中球比预期多',
      HighTurnovers: '距离本方球门不到40米的失误次数',
      ShotEndingHighTurnovers: '距离本方球门40米以内导致对方射门的失误次数',
      GoalEndingHighTurnovers: '距离本方球门40米以内导致对方进球的失误次数',
      AverageCarriesProgress: '球员每次推进球的平均垂直移动距离(米)',
      ChanceEndingCarries: '至少7米，以传球结束，然后射门的带球次数',
      AssistEndingCarries: '至少7米，以传球结束，然后进球的带球次数',
      ShotEndingCarries: '至少7米，以射门结束的带球次数',
      GoalEndingCarries: '至少7米，以进球结束的带球次数',
      ShotEndingSequence: '球员参与以射门结束的进攻次数',
      GoalEndingSequence: '球员参与以进球结束的进攻次数',
      xGPerNPG: '需要打进一个非点球进球预期进球值',
      AerialWonOffensive: '进攻争顶成功次数',
      AerialWonDefensive: '防守争顶成功次数',
      xGAgainst: '对方预期进球值',
      xGDiffAgainst: '预期失球和实际失球差',
      xGPerNPGAgainst: '每个非点球失球的预期进球数',
      xGSetPieceAgainst: '定位球预期失球',
      xGOpenPlayAgainst: '运动战预期失球',
      xGPerShotAgainst: '每次射门的预期失球数',
      ShotsAgainst: '的失球次数',
      ShotsOnTargetAgainst: '的被射正次数',
      RivalPossession: '对手控球率',
      AerialDefensivePct: '防守头球对抗成功率',
      HighRecoveries: '距离对手球门40米的夺回球权次数',
      HighDefensiveActions: '(抢断，拦截，盖帽，犯规)超过己方底线40米的防守动作百分比',
      HighDefensiveActionPct: '(抢断，拦截，盖帽，犯规)超过己方底线40米的防守动作百分比',
      HighDefensiveDistance: '所有防守动作中离本方球门的平均距离',
      PassesPerPossession: '每次控球的传球次数',
      LengthPerPossession: '每次控球距离',
      xTNet: '净预期威胁值',
      AvgCarriesDistance: '平均带球距离',
      PassesForwardPct: '向前传球占比',
      PassesForwardSuccessful: '成功的前传',
      PassesForwardTotal: '前传球总数',
      TacklesAttempted: '尝试抢断次数',
      DuelsLost: '争球失败次数',
      Carries: '带球次数',
      CarriesPct: '带球占比',
      Aerials: '争顶次数',
      ProgressivePassesReceivedIntoBox: '成功传球进入禁区次数',
      PassesOppHalf: '成功传球进入对手半场次数',
      ShotsOnTarget: '射正数',
      AggressiveActions: '丢球后两秒内尝试抢断次数',
      Crosses: '比赛的传中次数',
      xGBuildup5pass: '球员参与的xG数量，仅最近5次传球(不包括射门和导致射门的传球)',
      DefensiveDistance: '防守争球发生时到本方球门的平均距离',
      SpeedSequence: '一个球队控球时间的平均速度(米数除以时间)',
      Touches: '球员控球次数',
      AerialsTotalOppHalf: '进入对方半场的争顶次数',
      AerialsWonOppHalf: '赛中空中对决成功进入对手半场',
      AerialsWonOppHalfPct: '进入对方半场的争顶成功占比',
      AerialsPctOppBox: '进入对方禁区的争顶成功占比',
      AerialsPctOwnBox: '进入本方禁区的争顶成功占比',
      AerialDefensive: '对方控球时空中对抗总数',
      AerialOffensive: '本队控球时空中对抗总数',
      AerialOffensivePct: '本队控球时赢得空中对抗的百分比',
      IndividualPressureOppHalf: '衡量一名球员在对手半场压迫对手时成功次数(收复的球权)的指标',
      ChancesCreatedOP: '在的运动战中导致射门的传球次数',
      TouchesPerShot: '球员每次射门的触球次数',
      PassesFinalThirdTotalPct: '成功传球到最后三区的百分比',
      xACrosses: '的传中预期助攻数',
      Passes: '比赛的总传球次数',
      PassesSuccessful: '成功传球次数',
      TacklesWasDribbledFouls: '抢断次数占抢断次数和犯规次数总和的百分比',
      OffsidesCaught: '越位次数',
      ProgressivePassesReceivedFinalThird: '进攻三区接直传球次数',
      ProgressivePassesReceived: '接直传球次数',
      Breadth: '边路的抢断、挑战、拦截和犯规总数',
      DuelsDefTotal: '抢断、防守空中争顶和犯规总数',
      DefensiveActions: '当对手试图运球时的防守动作(抢断、上抢和犯规)',
      ProgressivePassesReceivedOppHalf: '对方半场接直传球次数',
      CompletedCrossesOP: '运动战传中到位次数',
      CrossingOP: '运动战完成的传中占所有传中的百分比',
      CrossesOP: '公开赛期间传中总数',
      PassingContribution: '考虑到接球者的位置，衡量传球威胁的百分比',
      BallProgressionOppHalfInTeam: '球队在对方半场推进球占比',
      PassesOPIntoBoxInTeam: '球队运动战传球进入禁区次数占比',
      TouchesOppBoxInTeam: '球员在对方禁区内触球次数占比',
      xGOPInTeam: '球队运动战占比',
      DeepPasses: '在对方球门半径20米范围外的传球，最终在该区域内完成次数',
      DeepPassesTotal: '从对方球门 20 米半径外尝试传球并最终进入该区域的总数',
      DefensiveDuelsPct: '防守争球成功百分比',
      QuickRecoveriesPct: '快速尝试抢断和拦截的百分比',
      DiffDefensiveDistanceTeam: '\'\'球员的防守距离和球队的防守距离之差',
      xTPassing: '仅来自传球的预期威胁值',
      xTPassing100Passes: '每100次传球仅来自传球的预期威胁值',
      ProgressivePassesAccurate: '在x轴上完成10米或以上的传球次数',
      PassAbility: '成功传球数与预期传球数的比率',
      OPPassesIntoOppBoxPct: '运动战成功传球进入对方禁区和尝试传球进入对方禁区次数的百分比',
      EntriesOppBox: '传球和带球进入对方禁区的次数',
      Crosses6yardBox: '传中到小禁区的总次数',
      Cutbacks: '从后场传球到对手禁区内的次数',
      xTDribbling: '仅通过过人产生的预期威胁值',
      AvgShotDistance: '射门平均距离',
      xGOnTarget: '射正的预期进球值。用射门的终点位置测量射门得分概率',
      FinishingxGOT: '射门命中率高于平均水平。这个指标衡量的是前锋的射门质量增加了多少价值',
      DribblesWonOwnHalf: '本方半场成功过人次数',
      DribblesOwnHalf: '本方半场尝试过人次数',
      DribblesOwnHalfPct: '本方半场成功过人次数与尝试过人次数百分比',
      DribblesWonOppHalf: '对方半场成功过人次数',
      DribblesOppHalf: '对方半场尝试过人次数',
      DribblesOppHalfPct: '对方半场成功过人次数与尝试过人次数百分比',
      DribblesWonFinalThird: '进攻三区成功过人次数',
      DribblesFinalThird: '进攻三区尝试过人次数',
      DribblesFinalThirdPct: '进攻三区成功过人次数与尝试过人次数百分比',
      ShotEndingHighRecoveries: '高位抢断后射门（在距离对方球门40米以内抢断并以射门结束）',
      PassingFinalThirdAgainst: '对手传入进攻三区的成功传球次数',
      OpenPlayPassesIntoOpponentBoxAgainst: '对手在运动战中尝试传入我方禁区的总次数',
      EntriesOppBoxAgainst: '对手传球或带球进入我方禁区的次数',
      DeepProgressionAgainst: '对手带球进入最后五分之一区域的次数，加上在我方前五分之一区域的控球次数',
      TouchesInOpponentBoxAgainst: '对手在我方禁区内控球的次数',
      Score: '基于不同衡量指标的球员表现',
      PDScore: '物理分数',
      OrlegiScore: '基于不同衡量指标的球员表现',
      SirScore: '基于不同衡量指标的球员表现',
      ExcScore: '基于不同衡量指标的球员表现',
      xTOPInTeam: '球队的运动战产生的预期威胁',
      YellowCards: '得黄牌数',
      RedCards: '得红牌数',
      xTOpenPlayAgainst: '运动战对手期望威胁值',
      xTSetPieceAgainst: '定位球对手期望威胁值',
      NPGOpenPlayAgainst: '运动战失球数（不包括点球）',
      NPGSetPieceAgainst: '定位球失球数（不包括点球）',
      PassesOppHalfPerPossession: '每次控球在对方半场传球次数',
      AverageTimeRecovery: '平均夺回球权时间',
      ExpectedPassing: '预期通过率',
      NumPossession10Passes: '传球 10 次',
      PassesReceived: '收到的传球数',
      PassesReceivedFinalThird: '最终通过 ⅓',
      ProgressivePassesTotalPct: '递进传球百分比',
      ShortPassesPct: '%短传',
      TouchesOppBoxOppTeam: '球员在场时对手在本方禁区内完成的动作次数',
      ShotsOnTargetOppTeam: '球员在场时本方被射正次数',
      NPGOppTeam: '球员在场时丢失的非点球进球数',
      xGSetPiecePerxG: '每产生一个预期进球所需的定位球预期进球数',
      ShotsOpenPlay: '由运动战产生的射门次数',
      ShotsOpenPlayAgainst: '由运动战被对手射门的次数',
      ShotsFromDribble: '在过掉对手后完成的射门',
      GoalsFromDribble: '在过掉对手后打进的进球',
      PassesIntoFinalThird: '从最后三分之一发起的成功传球',
      PassesIntoFinalThirdTotal: 'Total passes attempted that start outside and end inside the final third',
      PassesInsideFinalThird: '在最后三分之一区域内完成的成功传球（开始和结束都在该区域）',
      PassesInsideFinalThirdTotal: '最后三分之一内尝试传球的总数（最后三分之一内开始和结束）',
      PassesFinalThirdNoArea: '通过最后三分之一（不带盒子）',
      PassesIntoOppBox: '终点在对方禁区内的成功传球',
      CarriesFinalThird: '终点在最后三分之一的至少7米带球',
      CarriesInsideFinalThird: '在最后三分之一区域内完成的至少7米带球',
      CarriesFinalThirdNoBox: '进行最后三分之一（不带盒子）',
      CarriesIntoOppBox: '终点在对方禁区的至少7米带球',
      TimePossessionAgainst: '对方球队的控球时间',
      TimePossessionTotal: '两队总的控球时间',
      PassesInBox: '己方禁区内的成功传球',
      LongThrowInSuccessful: '从边线掷出的成功长距离界外球（超过20米）',
      LongThrowInTotal: '从边线掷出的总长距离界外球（超过20米）',
      LongThrowInPct: '成功的长距离界外球（超过20米）百分比',
      Games: '玩过的游戏',
      PointsPerGame: '每场比赛得分',
      ExpectedPointsDiff: '预期积分差',
      PassesTotalOwnHalf: '本方半场传球总数',
      PassesOwnHalf: '本方半场成功传球次数',
      PassesTotalOppHalf: '对手半场传球总数',
      ProgressivePassesTotal: 'X 轴 10 米或以上的总通过次数',
      DuelsWon: '成功的决斗（铲断、空中抢断、触球、运球和犯规）',
      NonPenaltySaves: '扑救不包括点球',
      BadActionsOppHalf: '对方半场所有不良行为的总和（传球不成功、接球不成功、断球、越位传球、触球不成功）',
      CarriesSuccessful: '成功完成至少 7 米的跑动次数',
      ShotsOnTargetOutBox: '从禁区外射门命中目标',
      TotalDistance: '球员在比赛中行走的总距离',
      WalkingDistance: '球员在比赛中以不超过2米/秒（7.2公里/小时）的速度行走的总距离',
      JoggingDistance: '球员在比赛中以2米/秒（7.2公里/小时）至4米/秒（14.4公里/小时）速度慢跑的总距离',
      RunningDistance: '球员在比赛中以4米/秒（14.4公里/小时）至5.5米/秒（19.8公里/小时）速度跑步的总距离',
      ExtremeAccelerations: '球员加速超过3米/秒²的次数',
      NumberOfRuns: '球员在比赛中以4米/秒（14.4公里/小时）至5.5米/秒（19.8公里/小时）速度完成的跑步次数',
      DistanceTIP: '球员在比赛中持球时行走的距离',
      DistanceOTIP: '球员在比赛中未持球时行走的距离',
      HsrNumber: '球员在比赛中以不少于5.5米/秒（19.8公里/小时）但少于7米/秒（25.2公里/小时）的速度移动至少1秒钟的次数',
      HsrDistance: '球员在比赛中以不少于5.5米/秒（19.8公里/小时）但少于7米/秒（25.2公里/小时）的速度跑步的总距离',
      HsrDistancePct: '高速跑步（HSR）距离占总距离的百分比',
      SprintsNumber: '球员在比赛中以不少于7米/秒（25.2公里/小时）的速度移动至少1秒钟的次数',
      SprintsDistance: '球员在比赛中以不少于7米/秒（25.2公里/小时）的速度冲刺的总距离',
      SprintNumberDeclinePct: '与比赛下半场相比冲刺次数的减少百分比',
      SprintDistanceDeclinePct: '与比赛下半场相比冲刺距离的减少百分比',
      SprintNumberDecline: '与比赛下半场相比冲刺次数的减少百分比',
      SprintDistanceDecline: '与比赛下半场相比冲刺距离的减少百分比',
      SprintDistancePct: '冲刺距离占总距离的百分比',
      Accelerations: '球员加速在1.5米/秒²至3米/秒²之间的次数',
      ExplosiveDistance: '爆发力距离',
      MaxSpeed: '球员达到的最高速度',
      AvgMaxSpeed: '球员平均最高速度',
      MaxAccelerations: '球员达到的最大加速度（米/秒²）',
      BypassedPlayersByPasses: '触球事件开始时球员在持球球员球门侧的数量减去触球事件结束时球门侧的球员数量',
      BypassedDefendersByPasses: '触球事件开始时防守球员在持球球员球门侧的数量减去触球事件结束时球门侧的防守球员数量',
      PassesBypassingPlayers: '绕过球员的传球数量',
      PassesBypassingDefenders: '绕过防守球员的传球数量',
      BypassedPlayersPerPass: '每次传球绕过的球员总数',
      BypassedDefendersPerPass: '每次传球绕过的防守球员总数',
      LineBreakingPasses: '完成的传球使球至少前进10%接近对方球门，并穿过一对靠近的防守球员或传到防线后方',
      LineBreakingPassesMD: '成功穿越中场线和防线的传球',
      LineBreakingPassesM: '成功穿越中场线的传球',
      LineBreakingThroughBalls: '成功穿越防线的传球',
      LineBreakingPassesPerPass: '每次传球突破的防线数量',
      TotalPassesUnderStrongPressure: '在强压下完成的传球总数（距离最近对手0-1.5米范围内）',
      TotalPassesUnderLightPressure: '在轻压下完成的传球总数（距离最近对手1.5-3米范围内）',
      SuccessfulPassesUnderStrongPressure: '在强压下成功的传球数量（距离最近对手0-1.5米范围内）',
      SuccessfulPassesUnderLightPressure: '在轻压下成功的传球数量（距离最近对手1.5-3米范围内）',
      PassingUnderStrongPressure: '在强压下成功传球的百分比（距离最近对手0-1.5米范围内）',
      PassingUnderLightPressure: '在轻压下成功传球的百分比（距离最近对手1.5-3米范围内）',
      PassReceiptsInSpaceCompleted: '接球球员在进攻半场且在球门方向5米范围内无防守球员的情况下完成的传球',
      PassReceiptsInSpace: '在进攻半场接到的传球，且球门方向5米范围内无防守球员',
      PassReceiptsInSpaceCompletedFirstThird: '接球者在第一三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedSecondThird: '接球者在第二三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedFinalThird: '接球者在最后三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfRight: '接球者在对方半场右侧，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfCenter: '接球者在对方半场中路，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfLeft: '接球者在对方半场左侧，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceFirstThird: '在第一三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceSecondThird: '在第二三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceFinalThird: '在最后三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfRight: '在对方半场右侧接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfCenter: '在对方半场中路接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfLeft: '在对方半场左侧接到的，且进攻方向5米范围内无防守者的传球',
      TotalStrongOnBallPressures: '对持球者施加的强压次数（距离持球者0-1.5米）',
      TotalLightOnBallPressures: '对持球者施加的轻压次数（距离持球者1.5-3米）',
      SuccessfulStrongOnBallPressures: '成功的强压次数（距离持球者0-1.5米）',
      SuccessfulLightOnBallPressures: '成功的轻压次数（距离持球者1.5-3米）',
      StrongOnBallPressuresPct: '成功的强压占比（距离持球者0-1.5米范围内）',
      LightOnBallPressuresPct: '成功的轻压占比（距离持球者1.5-3米范围内）',
      TimesBypassedByPasses: '被传球突破的总次数',
      TimesBypassedByCarries: '被带球突破的总次数',
      TimesBypassedByActions: '被传球和带球合计突破的总次数',
      BypassedPlayersByCarries: '通过带球突破的对手总数（包括中场和后卫）',
      BypassedDefendersByCarries: '通过带球突破的对手总数（仅限后卫）',
      BypassedPlayersByActions: '通过传球和带球合计突破的对手总数（中场和后卫）',
      BypassedDefendersByActions: '通过传球和带球合计突破的对手总数（仅限后卫）',
      CarriesBypassingPlayers: '带球突破球员的次数',
      CarriesBypassingDefenders: '带球突破后卫的次数',
      BypassedPlayersPerCarry: '每次带球平均突破的对手数',
      BypassedDefendersPerCarry: '每次带球平均突破的后卫数',
      LineBreakingCarries: '成功突破一条或多条防线的带球次数',
      LineBreakingCarriesMD: '成功突破中场线和后卫线的带球次数',
      LineBreakingCarriesM: '成功突破中场线的带球次数',
      LineBreakingCarriesD: '成功突破后卫线的带球次数',
      LineBreakingCarriesPerCarry: '每次带球的突破比例',
      LineBreakingActions: '成功突破一条或多条防线的传球和带球总次数',
      LineBreakingActionsMD: '成功突破中场线和后卫线的传球和带球总次数',
      LineBreakingActionsM: '成功突破中场线的传球和带球总次数',
      LineBreakingActionsD: '成功突破后卫线的传球和带球总次数',
      PassesPerLineBreakingPass: '每次突破性传球对应的总传球比例',
      CarriesPerLineBreakingCarry: '每次突破性带球对应的总带球比例',
      LinesBrokenByPasses: '通过传球突破的防线总数',
      LinesBrokenByCarries: '通过带球突破的防线总数',
      LinesBrokenByActions: '通过传球和带球突破的防线总数',
      LinesBrokenPerPass: '每次传球平均突破的防线数量',
      LinesBrokenPerCarry: '每次带球平均突破的防线数量',
      AvgLastDefenderDistanceIP: '控球时，最后一名防守球员（最接近本方球门者）与球门线之间的距离',
      AvgLastDefenderDistanceOOP: '无球时，最后一名防守球员（最接近本方球门者）与球门线之间的距离',
      AvgDefensiveLineDistanceIP: '控球时，最深防线与本方球门之间的距离',
      AvgDefensiveLineDistanceOOP: '无球时，最深防线与本方球门之间的距离',
      AvgRBDistanceIP: '控球时，右后卫与本方球门之间的距离',
      AvgRBDistanceOOP: '无球时，右后卫与本方球门之间的距离',
      AvgLBDistanceIP: '控球时，左后卫与本方球门之间的距离',
      AvgLBDistanceOOP: '无球时，左后卫与本方球门之间的距离',
      AvgBlockDistanceIP: '控球时，最深与最前场球员之间的距离',
      AvgBlockDistanceOOP: '无球时，最深与最前场球员之间的距离',
      AvgBlockAreaIP: '控球时，包围所有场上球员的边界框面积（衡量球队占据空间）',
      AvgBlockAreaOOP: '无球时，包围所有场上球员的边界框面积（衡量球队占据空间）',
      AvgDefensiveLineWidthOOP: '无球时，最靠后的球员线的宽度（远离自家球门）',
      AvgOffensiveLineLastThirdWidthIP: '控球时，进攻线在进攻三区的水平宽度',
      AvgLByIP: '控球时，左后卫的位置',
      AvgRByIP: '控球时，右后卫的位置',
      AvgOffensiveLineDistanceIP: '控球时，本方球门与进攻线之间的距离',
      AvgOffensiveLineLastThirdDistanceIP: '控球时，本方球门与进攻三区进攻线之间的距离',
      AvgOffensiveLineWidthIP: '控球时，进攻线的水平宽度',
      OffBallRuns: '为支持进攻阶段而进行的有意图的无球跑动',
      OffBallRunsOverlap: '当队友持球时，球员从其外侧（靠近边线）绕过的跑动',
      OffBallRunsUnderlap: '球员从队友内侧（更靠近中路）穿插跑动',
      OffBallRunsRunAhead: '超越持球队员但仍停留在最后一名防守球员前方的前插跑动',
      OffBallRunsRunBehind: '突破防线进入最后一线，跑入后卫与守门员之间的跑动',
      OffBallRunsCrossReceiver: '球员跑入禁区，准备接应队友的传中',
      OffBallRunsSupport: '球员跑动与持球人保持一线，提供近距离的传球选项',
      OffBallRunsComingShort: '球员朝持球人方向跑动，提供近距离支援或回传选项',
      AerialsOppHalf: '进入对方半场的争顶成功次数',
      xP: '预期传球值(xP)衡量成功完成传球的质量',
      CarriesIntoFinalThird: '从最后三分之一区外到内至少有 7 米的管道',
      SpeedScore: '基于不同速度指标的球员身体表现',
      EnduranceScore: '基于不同指标的球员耐力身体表现',
      SwitchPlaySuccessful: '球的横向位移大于其朝向对方球门的位移的、超过 32 米的完成传球次数',
      SwitchPlayTotal: '当球的横向位移大于其朝向对方球门的位移时，尝试传球超过 32 米的总数',
      PassesInsideOppHalf: '在对方半场开始和结束的传球总数',
      PassesInsideOppHalfSuccessful: '在对方半场开始和结束时完成的传球次数',
      TacklesAttemptedFirstThird: '球场前三分之一尝试铲断总数',
      TacklesAttemptedSecondThird: '球场第二个三分之一的尝试铲断总数',
      TacklesFirstThird: '球场前三分之一的成功铲断次数',
      TacklesSecondThird: '球场第二个三分之一的成功铲断次数',
      FoulsOwnHalf: '球员本方半场犯规次数',
      TouchesOppHalf: '对方半场触球次数',
      TacklesAttemptedNotAdjusted: '尝试铲断总数，无控球权调整',
      TacklesSuccessfulNotAdjusted: '成功抢断总数，不考虑控球权调整',
      AvgTop5MaxSpeed: '玩家五个最高速度的平均值',
      LBPReceived: '收到的突破线传球数。这些是完成的传球，使球距离对方球门至少 10%，并与两名近距离的后卫相交或越过防线',
      LBPMReceived: '突破对方中场线的传球次数',
      LBPMDReceived: '突破对方中场和防线的传球次数',
      ThroughBallReceived: '突破对方最后防线的传球次数',
      HsrDistanceIP: '冲刺距离 >21 公里/小时',
      HsrDistanceOOP: '失控冲刺距离 >21 公里/小时',
      JoggingDistanceIP: '控球慢跑距离',
      JoggingDistanceOOP: '控球后慢跑距离',
      RunningDistanceIP: '控球跑动距离',
      RunningDistanceOOP: '控球后跑动距离',
      SprintsDistanceIP: '控球冲刺距离>24公里/小时',
      SprintsDistanceOOP: '失控冲刺距离 >24 km/h',
      WalkingDistanceIP: '控球步行距离',
      WalkingDistanceOOP: '控球后步行距离'
    },
    subtitles: {
      Possession: '球队控球占比',
      TimePossession: '球队控球时间',
      PassesPerShots: '每次射门的平均传球次数',
      PPDA: '当球队控球时对对方球员压迫次数',
      Directness: '向前传球比侧身传球多',
      ExpectedPoints: ',根据预期进球数计算出的该队期望得分',
      PassesPerLongBall: '每次长传前的传球次数',
      CrossingPerXG: '每个的传中百分比',
      PenaltySavedPenaltyFaced: '扑出的点球占扑出的所有点球的百分比',
      Goals: '每分钟比赛的进球数',
      PenaltyShots: '点球总射门数',
      PenaltyGoals: '点球总进球数',
      NonPenaltyGoals: '进球数不包括点球',
      AerialWins: '分钟争顶成功次数',
      AerialEfficiency: '将争顶成功与每分钟的尝试争顶总数相结合的度量',
      AerialWinsPct: '争顶成功占比',
      Assists: '每分钟助攻数',
      Catching: '守门员接住球的扑救百分比',
      Caught: '保存守门员接球和持球的位置，防止第二次比赛',
      ChancesCreated: '形成射门的传球次数',
      ClaimAccuracy: '高于平均值的出击击球数',
      CompletedCrosses: '成功完成传中次数',
      Crossing: '传中成功率',
      Dispossessed: '的丢失球权数',
      Finishing: '射门得分的百分比',
      xGEfficiency: '一名球员进球所需的预期进球值',
      Fouls: '犯规次数',
      DeepProgression: '持球到达球场最后五分之一的次数，加上控球权在最后五分之一的次数',
      DeepProgressionFinalThird: '球员在进攻三区持球次数',
      FoulsTaken: '被犯规次数',
      IndividualPressure: '的成功夺回球权次数',
      Interceptions: '的拦截次数',
      LongBallPct: '长传(>32米)占传球总数的百分比',
      LongBallTotal: '32米以上总传球次数',
      LongBallSuccessful: '完成传球至少米的次数',
      NPGOpenPlay: '的运动战进球不包括点球',
      NPGSetPiece: '的定位球进球不包括点球',
      OpenPlayKeyPasses: '在运动战中以射门结束的传球不包括助攻',
      OpenPlayKeyPassesInTeam: '球员在队内公开比赛中完成传球的百分比',
      PassingFinalThird: '每分钟在最后三区成功传球',
      PassesFinalThirdTotal: '最后三分之一的传球尝试总数，不包括传中、定位球、角球和界外球',
      PassingFinalThirdPct: '最后三区成功传球百分比',
      PassingOppHalfPct: '成功传球进入对方半场百分比',
      PassingOwnHalfPct: '成功传球进入本方半场百分比',
      PassingPct: '成功传球百分比',
      Recoveries: '夺回球权次数通过抢断或拦截',
      SavesInBoxPct: '禁区内射门扑救的百分比',
      SavesOutOfBoxPct: '禁区外射门的扑救百分比',
      SavesPct: '扑救百分比',
      ScoringContribution: '比赛的助攻数和进球数',
      xAssistsOpenPlay: '预期助攻数',
      xAssistsSetPiece: '定位球预期助攻数',
      xAssistsOpenPlayInTeam: '在每团队分钟的公开比赛中预期助攻数',
      xAssistsSetPieceInTeam: '每团队分钟定位赛中预期助攻数',
      xGChainFinalThird: '球员参与进入进攻三区的数',
      xGBuildupFinalThird: '球员参与进入进攻三区的xG数（不包括射门和关键传球）',
      BallProgressionPassing: '球员通过传球将球推进米或以上的次数',
      BallProgressionDribbling: '球员带球前进米或米以上的次数',
      Shooting: '射门命中率(不包括点球)',
      Shots: '每分钟的射门次数',
      ShotsPerGoal: '得分的平均射门次数',
      SuccessfulDribbles: '过人成功率',
      TacklesSuccessful: '的抢断次数',
      TacklesWasDribbled: '通过抢断赢得的争球百分比',
      ThroughBalls: '突破防线的传球次数',
      TouchesInOpponentBox: '在对方禁区内控球次数',
      xAssists: '预期助攻数',
      xG: '产生的预期进球',
      xGDiff: '与进球数差',
      xGOpenPlay: '运动战期望进球值',
      xGSetPiece: '定位球期望进球值',
      xGBuildup: '每分钟参与组织进攻值',
      xGBuildupInTeam: '进攻组织值 in Team',
      BallProgression: '球员通过传球、带球前进10米以上的次数()',
      xGChain: '球员参与的数量',
      xGPerNPG: '需要打进一个非点球进球预期进球值',
      xGPerShot: '平均射门值',
      xGSavedPerShot: '平均被射门值',
      xGSavedPerXGFacedOnTarget: '平均扑救射正值',
      xGFacedOnTargetPerGoalReceived: '面对该门将进球所需值',
      xGFacedOnTargetEfficiency: '被门将扑出的非点球射门数',
      xGFacedOnTarget: '门将面对射门的总',
      HighTurnovers: '距离本方球门不到米的丢失球权次数',
      OpenPlayPassesIntoOpponentBox: '球员运动战将球成功传入对手禁区次数',
      OpenPlayPassesIntoOpponentBoxSuccessful: '球员运动战将球成功传入对手禁区次数',
      ChancesCreatedOP: '中导致射门的传球次数',
      PenaltiesTaken: '内球员在对方禁区内被犯规次数',
      BlockedCrosses: '被球员拦截的传中次数',
      BlockedShots: '比赛中被球员阻挡的射门次数',
      NonPenaltyGoalsAgainst: '非点球失球数',
      Headers: '头球射门次数',
      AveragePassDistance: '平均传球距离',
      ProgressiveRuns: '成功的带球使控球距离对手球门更近次数',
      xT: '将球转移到危险区域所产生的威胁',
      xTOpenPlay: '在运动战产生的预期威胁',
      xTSetPiece: '定位球产生的预期威胁',
      xGOT: '射正期望进球值',
      BadActions: '所有不良行为的总和',
      BadActionsOwnHalf: '本方半场的糟糕处理次数',
      AerialsWonOwnBox: '本方禁区内争顶成功',
      AerialsWonOppBox: '对方禁区内争顶成功',
      AerialsTotalOppBox: '对方禁区内总争顶次数',
      AerialsTotalOwnBox: '本方禁区内总争顶次数',
      FoulsOwnHalfPct: '本方半场犯规占比',
      RecoveriesOppHalf: '内一名球员在对方半场内抢回的球数',
      DuelsPct: '成功争球次数百分比',
      TacklesUnsuccessful: '当对手成功运球超过球员时球员未能赢得球的次数',
      TacklesWasDribbledFirstThird: '防守一对一成功',
      TacklesWasDribbledSecondThird: '防守一对一成功 ⅔',
      TacklesWasDribbledFinalThird: '防守一对一成功 决赛 ⅓',
      BallProgressionFinalThird: '一名球员在进攻三区中推进米或以上的次数',
      DuelsTotal: '钟的拦截、高空球、触球、运球和犯规总数',
      QuickRecoveries: '在失去控球权后秒内从米或更远的地方抢回球',
      ShotsPerNPG: '非点球进球的平均射门次数',
      ShotsOutBox: '禁区外射门次数',
      GoalsOutBox: '禁区外进球数',
      ShootingOutBox: '禁区外射正的百分比',
      HandPassing: '手传精准度',
      ShotEndingHighTurnovers: '高位（距离本方球门40米内）丢失球权导致被射门数',
      GoalEndingHighTurnovers: '高位（距离本方球门40米内）丢失球权导致失球数',
      AverageCarriesProgress: '球员每次带球的平均垂直移动距离(米)',
      ChanceEndingCarries: '至少7米，以传球结束，然后射门的带球',
      AssistEndingCarries: '至少7米，以传球结束，然后进球的带球',
      ShotEndingCarries: '至少7米，以射门结束的带球',
      GoalEndingCarries: '至少7米，以射门结束的进球',
      ShotEndingSequence: '球员参与以射门结束的进攻次数',
      GoalEndingSequence: '球员参与以进球结束的进攻次数',
      AerialWonOffensive: '进攻争顶成功次数',
      AerialWonDefensive: '防守争顶成功次数',
      xGAgainst: '预期失球',
      xGDiffAgainst: '预期失球和实际失球差',
      xGPerNPGAgainst: '每个非点球失球的预期进球数',
      xGOpenPlayAgainst: '运动战预期失球',
      xGSetPieceAgainst: '定位球预期失球',
      xGPerShotAgainst: '每次射门的预期失球数',
      ShotsAgainst: '每分钟的失球次数',
      ShotsOnTargetAgainst: '的被射正次数',
      RivalPossession: '对手控球率',
      AerialDefensivePct: '防守头球对抗成功率',
      HighRecoveries: '距离对手球门米的夺回球权次数',
      HighDefensiveActions: '(抢断，拦截，盖帽，犯规)超过己方底线40米的防守动作百分比',
      HighDefensiveActionPct: '(抢断，拦截，盖帽，犯规)超过己方底线40米的防守动作百分比',
      HighDefensiveDistance: '所有防守动作中离本方球门的平均距离',
      PassesPerPossession: '每次控球的传球次数',
      LengthPerPossession: '每次控球距离',
      xTNet: '净预期威胁值',
      AvgCarriesDistance: '平均带球距离',
      PassesForwardPct: '向前传球占比',
      PassesForwardSuccessful: '成功的前传',
      PassesForwardTotal: '前传球总数',
      TacklesAttempted: '尝试抢断次数',
      DuelsLost: '争球失败次数',
      Carries: '带球次数',
      CarriesPct: '带球占比',
      Aerials: '争顶次数',
      ProgressivePassesReceivedIntoBox: '成功传球进入禁区次数',
      PassesOppHalf: '成功传球进入对手半场次数',
      LongBallReceived: '接长传(>32米)次数',
      ShotsOnTarget: '射正数',
      AggressiveActions: '丢球后两秒内尝试抢断次数',
      Crosses: '比赛的传中次数',
      xGBuildup5pass: '球员参与的xG数量，仅最近5次传球(不包括射门和导致射门的传球)',
      DefensiveDistance: '防守争球发生时到本方球门的平均距离',
      SpeedSequence: '一个球队控球时间的平均速度(米数除以时间)',
      Touches: '球员控球次数',
      AerialsTotalOppHalf: '进入对方半场的争顶次数',
      AerialsWonOppHalf: '赛中空中对决成功进入对手半场',
      AerialsWonOppHalfPct: '进入对方半场的争顶成功占比',
      AerialsPctOppBox: '进入对方禁区的争顶成功占比',
      AerialsPctOwnBox: '进入本方禁区的争顶成功占比',
      AerialDefensive: '对方控球时空中对抗总数',
      AerialOffensive: '本队控球时空中对抗总数',
      AerialOffensivePct: '本队控球时赢得空中对抗的百分比',
      IndividualPressureOppHalf: '一名球员在对方半场压迫对手时收回的球权',
      TouchesPerShot: '球员每次射门的触球次数',
      PassesFinalThirdTotalPct: '成功传球到最后三区的百分比',
      xACrosses: '的传中预期助攻数',
      Passes: '比赛的总传球次数',
      PassesSuccessful: '成功传球次数',
      TacklesWasDribbledFouls: '抢断次数占抢断次数和犯规次数总和的百分比',
      OffsidesCaught: '越位次数',
      ProgressivePassesReceivedFinalThird: '进攻三区接直传球次数',
      ProgressivePassesReceived: '接直传球次数',
      Breadth: '边路的抢断、挑战、拦截和犯规总数',
      DuelsDefTotal: '抢断、防守空中争顶和犯规总数',
      DefensiveActions: '当对手试图运球时的防守动作(抢断、上抢和犯规)',
      ProgressivePassesReceivedOppHalf: '对方半场接直传球次数',
      CompletedCrossesOP: '运动战传中到位次数',
      CrossingOP: '运动战完成的传中占所有传中的百分比',
      CrossesOP: '公开赛期间传中总数',
      PassingContribution: '考虑到接球者的位置，衡量传球威胁的百分比',
      BallProgressionOppHalfInTeam: '球队在对方半场推进球占比',
      PassesOPIntoBoxInTeam: '球队运动战传球进入禁区次数占比',
      TouchesOppBoxInTeam: '球员在对方禁区内触球次数占比',
      xGOPInTeam: '球队运动战占比',
      DeepPasses: '在对方球门半径20米范围外的传球，最终在该区域内完成次数',
      DeepPassesTotal: '从对方球门 20 米半径外尝试传球并最终进入该区域的总数',
      DefensiveDuelsPct: '防守争球成功百分比',
      QuickRecoveriesPct: '快速尝试抢断和拦截的百分比',
      DiffDefensiveDistanceTeam: '\'\'球员的防守距离和球队的防守距离之差',
      xTPassing: '仅来自传球的预期威胁值',
      xTPassing100Passes: '每次传球仅来自传球的预期威胁值',
      ProgressivePassesAccurate: '在轴上完成米或以上的传球次数',
      PassAbility: '成功传球数与预期传球数的比率',
      OPPassesIntoOppBoxPct: '运动战成功传球进入对方禁区和尝试传球进入对方禁区次数的百分比',
      EntriesOppBox: '传球和带球进入对方禁区的次数',
      Crosses6yardBox: '传中到小禁区的总次数',
      Cutbacks: '从后场传球到对手禁区内的次数',
      xTDribbling: '仅通过过人产生的预期威胁值',
      AvgShotDistance: '射门平均距离',
      xGOnTarget: '射正的预期进球值',
      FinishingxGOT: '射门命中率高于平均水平',
      DribblesWonOwnHalf: '本方半场成功过人次数',
      DribblesOwnHalf: '本方半场尝试过人次数',
      DribblesOwnHalfPct: '本方半场成功过人次数与尝试过人次数百分比',
      DribblesWonOppHalf: '对方半场成功过人次数',
      DribblesOppHalf: '对方半场尝试过人次数',
      DribblesOppHalfPct: '对方半场成功过人次数与尝试过人次数百分比',
      DribblesWonFinalThird: '进攻三区成功过人次数',
      DribblesFinalThird: '进攻三区尝试过人次数',
      DribblesFinalThirdPct: '进攻三区成功过人次数与尝试过人次数百分比',
      ShotEndingHighRecoveries: '高位抢断后射门（在距离对方球门40米以内抢断并以射门结束）',
      PassingFinalThirdAgainst: '对手传入进攻三区的成功传球次数',
      OpenPlayPassesIntoOpponentBoxAgainst: '对手在运动战中尝试传入我方禁区的总次数',
      EntriesOppBoxAgainst: '对手传球或带球进入我方禁区的次数',
      DeepProgressionAgainst: '对手带球进入最后五分之一区域的次数，加上在我方前五分之一区域的控球次数',
      TouchesInOpponentBoxAgainst: '对手在我方禁区内控球的次数',
      Score: '基于不同衡量指标的球员表现',
      PDScore: '物理分数',
      OrlegiScore: '基于不同衡量指标的球员表现',
      SirScore: '基于不同衡量指标的球员表现',
      ExcScore: '基于不同衡量指标的球员表现',
      xTOPInTeam: '球队的运动战产生的预期威胁',
      YellowCards: '收到黄牌数',
      RedCards: '收到红牌数',
      xTOpenPlayAgainst: '对手运动战预期威胁值',
      xTSetPieceAgainst: '对手定位球预期威胁值',
      NPGOpenPlayAgainst: '运动战非点球失球数',
      NPGSetPieceAgainst: '定位球非点球失球数',
      PassesOppHalfPerPossession: '每控球点在对方半场的传球次数',
      AverageTimeRecovery: '平均夺回球权时间',
      ExpectedPassing: '预期通过率',
      NumPossession10Passes: '传球 10 次',
      PassesReceived: '收到的传球数',
      PassesReceivedFinalThird: '最终通过 ⅓',
      ProgressivePassesTotalPct: '递进传球百分比',
      ShortPassesPct: '%短传',
      TouchesOppBoxOppTeam: '球员在场时对手在本方禁区内完成的动作次数',
      ShotsOnTargetOppTeam: '球员在场时本方被射正次数',
      NPGOppTeam: '球员在场时丢失的非点球进球数',
      xGSetPiecePerxG: '每产生一个预期进球所需的定位球预期进球数',
      ShotsOpenPlay: '由运动战产生的射门次数',
      ShotsOpenPlayAgainst: '由运动战被对手射门的次数',
      ShotsFromDribble: '在过掉对手后完成的射门',
      GoalsFromDribble: '在过掉对手后打进的进球',
      PassesIntoFinalThird: '从最后三分之一发起的成功传球',
      PassesIntoFinalThirdTotal: '从外线开始到最后三分之一内结束的传球尝试总数',
      PassesInsideFinalThird: '在最后三分之一区域内完成的成功传球（开始和结束都在该区域）',
      PassesInsideFinalThirdTotal: '最后三分之一内尝试传球的总数（最后三分之一内开始和结束）',
      PassesFinalThirdNoArea: '通过最后三分之一（不带盒子）',
      PassesIntoOppBox: '终点在对方禁区内的成功传球',
      CarriesFinalThird: '终点在最后三分之一的至少7米带球',
      CarriesInsideFinalThird: '在最后三分之一区域内完成的至少7米带球',
      CarriesFinalThirdNoBox: '进行最后三分之一（不带盒子）',
      CarriesIntoOppBox: '终点在对方禁区的至少7米带球',
      TimePossessionAgainst: '对方球队的控球时间',
      TimePossessionTotal: '两队总的控球时间',
      PassesInBox: '己方禁区内的成功传球',
      LongThrowInSuccessful: '从边线掷出的成功长距离界外球（超过20米）',
      LongThrowInTotal: '从边线掷出的总长距离界外球（超过20米）',
      LongThrowInPct: '成功的长距离界外球（超过20米）百分比',
      Games: '玩过的游戏',
      PointsPerGame: '每场比赛得分',
      ExpectedPointsDiff: '预期积分差',
      PassesTotalOwnHalf: '本方半场传球总数',
      PassesOwnHalf: '本方半场成功传球次数',
      PassesTotalOppHalf: '对手半场传球总数',
      ProgressivePassesTotal: 'X 轴 10 米或以上的总通过次数',
      DuelsWon: '成功的决斗（铲断、空中抢断、触球、运球和犯规）',
      NonPenaltySaves: '扑救不包括点球',
      BadActionsOppHalf: '对方半场所有不良行为的总和',
      CarriesSuccessful: '成功完成至少 7 米的跑动次数',
      ShotsOnTargetOutBox: '从禁区外射门命中目标',
      TotalDistance: '总跑动距离',
      WalkingDistance: '比赛期间球员以低于 2 m/s (7.2 km/h) 的速度行驶的总距离',
      JoggingDistance: '比赛期间球员以 2 m/s (7.2 km/h) 至 4 m/s (14.4 km/h) 之间的速度行驶的总距离',
      RunningDistance: '球员在一场比赛中以 4 m/s (14.4 km/h) 至 5.5 m/s (19.8 km/h) 之间的速度行驶的总距离',
      ExtremeAccelerations: '玩家加速超过 3 m/s<sup>2</sup> 的次数',
      NumberOfRuns: '以 14.4 公里/小时至 19.8 公里/小时的速度完成的跑步次数',
      HsrDistance: '大于19.8km/h的冲刺距离',
      HsrNumber: '大于19.8km/h的冲刺次数',
      HsrDistancePct: '高速跑动距离占比',
      SprintsNumber: '大于25.2km/h的冲刺次数',
      SprintsDistance: '大于25.2km/h的冲刺距离',
      SprintNumberDeclinePct: '竭力冲刺次数占比',
      SprintDistanceDeclinePct: '竭力冲刺距离占比',
      SprintNumberDecline: '与比赛下半场相比冲刺次数的减少百分比',
      SprintDistanceDecline: '与比赛下半场相比冲刺距离的减少百分比',
      SprintDistancePct: '冲刺距离占比',
      Accelerations: '加速次数',
      MaxSpeed: '最高速度',
      AvgMaxSpeed: '球员平均最高速度',
      MaxAccelerations: '球员达到的最大加速度（米/秒²）',
      BypassedPlayersByPasses: '触球事件开始时球员在持球球员球门侧的数量减去触球事件结束时球门侧的球员数量',
      BypassedDefendersByPasses: '触球事件开始时防守球员在持球球员球门侧的数量减去触球事件结束时球门侧的防守球员数量',
      PassesBypassingPlayers: '绕过球员的传球数量',
      PassesBypassingDefenders: '绕过防守球员的传球数量',
      BypassedPlayersPerPass: '每次传球绕过的球员总数',
      BypassedDefendersPerPass: '每次传球绕过的防守球员总数',
      LineBreakingPasses: '完成的传球使球至少前进10%接近对方球门，并穿过一对靠近的防守球员或传到防线后方',
      LineBreakingPassesMD: '成功穿越中场线和防线的传球',
      LineBreakingPassesM: '成功穿越中场线的传球',
      LineBreakingThroughBalls: '成功穿越防线的传球',
      LineBreakingPassesPerPass: '每次传球突破的防线数量',
      TotalPassesUnderStrongPressure: '在强压下完成的传球总数（距离最近对手0-1.5米范围内）',
      TotalPassesUnderLightPressure: '在轻压下完成的传球总数（距离最近对手1.5-3米范围内）',
      SuccessfulPassesUnderStrongPressure: '在强压下成功的传球数量（距离最近对手0-1.5米范围内）',
      SuccessfulPassesUnderLightPressure: '在轻压下成功的传球数量（距离最近对手1.5-3米范围内）',
      PassingUnderStrongPressure: '在强压下成功传球的百分比（距离最近对手0-1.5米范围内）',
      PassingUnderLightPressure: '在轻压下成功传球的百分比（距离最近对手1.5-3米范围内）',
      PassReceiptsInSpaceCompleted: '接球球员在进攻半场且在球门方向5米范围内无防守球员的情况下完成的传球',
      PassReceiptsInSpace: '在进攻半场接到的传球，且球门方向5米范围内无防守球员',
      PassReceiptsInSpaceCompletedFirstThird: '接球者在第一三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedSecondThird: '接球者在第二三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedFinalThird: '接球者在最后三分之一内，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfRight: '接球者在对方半场右侧，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfCenter: '接球者在对方半场中路，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceCompletedOppHalfLeft: '接球者在对方半场左侧，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceFirstThird: '在第一三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceSecondThird: '在第二三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceFinalThird: '在最后三分之一接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfRight: '在对方半场右侧接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfCenter: '在对方半场中路接到的，且进攻方向5米范围内无防守者的传球',
      PassReceiptsInSpaceOppHalfLeft: '在对方半场左侧接到的，且进攻方向5米范围内无防守者的传球',
      TotalStrongOnBallPressures: '对持球者施加的强压次数（距离持球者0-1.5米）',
      TotalLightOnBallPressures: '对持球者施加的轻压次数（距离持球者1.5-3米）',
      SuccessfulStrongOnBallPressures: '成功的强压次数（距离持球者0-1.5米）',
      SuccessfulLightOnBallPressures: '成功的轻压次数（距离持球者1.5-3米）',
      StrongOnBallPressuresPct: '成功的强压占比（距离持球者0-1.5米范围内）',
      LightOnBallPressuresPct: '成功的轻压占比（距离持球者1.5-3米范围内）',
      TimesBypassedByPasses: '被传球突破的总次数',
      TimesBypassedByCarries: '被带球突破的总次数',
      TimesBypassedByActions: '被传球和带球合计突破的总次数',
      BypassedPlayersByCarries: '通过带球突破的对手总数（包括中场和后卫）',
      BypassedDefendersByCarries: '通过带球突破的对手总数（仅限后卫）',
      BypassedPlayersByActions: '通过传球和带球合计突破的对手总数（中场和后卫）',
      BypassedDefendersByActions: '通过传球和带球合计突破的对手总数（仅限后卫）',
      CarriesBypassingPlayers: '带球突破球员的次数',
      CarriesBypassingDefenders: '带球突破后卫的次数',
      BypassedPlayersPerCarry: '每次带球平均突破的对手数',
      BypassedDefendersPerCarry: '每次带球平均突破的后卫数',
      LineBreakingCarries: '成功突破一条或多条防线的带球次数',
      LineBreakingCarriesMD: '成功突破中场线和后卫线的带球次数',
      LineBreakingCarriesM: '成功突破中场线的带球次数',
      LineBreakingCarriesD: '成功突破后卫线的带球次数',
      LineBreakingCarriesPerCarry: '每次带球的突破比例',
      LineBreakingActions: '成功突破一条或多条防线的传球和带球总次数',
      LineBreakingActionsMD: '成功突破中场线和后卫线的传球和带球总次数',
      LineBreakingActionsM: '成功突破中场线的传球和带球总次数',
      LineBreakingActionsD: '成功突破后卫线的传球和带球总次数',
      PassesPerLineBreakingPass: '每次突破性传球对应的总传球比例',
      CarriesPerLineBreakingCarry: '每次突破性带球对应的总带球比例',
      LinesBrokenByPasses: '通过传球突破的防线总数',
      LinesBrokenByCarries: '通过带球突破的防线总数',
      LinesBrokenByActions: '通过传球和带球突破的防线总数',
      LinesBrokenPerPass: '每次传球平均突破的防线数量',
      LinesBrokenPerCarry: '每次带球平均突破的防线数量',
      AvgLastDefenderDistanceIP: '控球时，最后一名防守球员（最接近本方球门者）与球门线之间的距离',
      AvgLastDefenderDistanceOOP: '无球时，最后一名防守球员（最接近本方球门者）与球门线之间的距离',
      AvgDefensiveLineDistanceIP: '控球时，最深防线与本方球门之间的距离',
      AvgDefensiveLineDistanceOOP: '无球时，最深防线与本方球门之间的距离',
      AvgRBDistanceIP: '控球时，右后卫与本方球门之间的距离',
      AvgRBDistanceOOP: '无球时，右后卫与本方球门之间的距离',
      AvgLBDistanceIP: '控球时，左后卫与本方球门之间的距离',
      AvgLBDistanceOOP: '无球时，左后卫与本方球门之间的距离',
      AvgBlockDistanceIP: '控球时，最深与最前场球员之间的距离',
      AvgBlockDistanceOOP: '无球时，最深与最前场球员之间的距离',
      AvgBlockAreaIP: '控球时，包围所有场上球员的边界框面积（衡量球队占据空间）',
      AvgBlockAreaOOP: '无球时，包围所有场上球员的边界框面积（衡量球队占据空间）',
      AvgDefensiveLineWidthOOP: '无球时，最靠后的球员线的宽度（远离自家球门）',
      AvgOffensiveLineLastThirdWidthIP: '控球时，进攻线在进攻三区的水平宽度',
      AvgLByIP: '控球时，左后卫的位置',
      AvgRByIP: '控球时，右后卫的位置',
      AvgOffensiveLineDistanceIP: '控球时，本方球门与进攻线之间的距离',
      AvgOffensiveLineLastThirdDistanceIP: '控球时，本方球门与进攻三区进攻线之间的距离',
      AvgOffensiveLineWidthIP: '控球时，进攻线的水平宽度',
      OffBallRuns: '为支持进攻阶段而进行的有意图的无球跑动',
      OffBallRunsOverlap: '当队友持球时，球员从其外侧（靠近边线）绕过的跑动',
      OffBallRunsUnderlap: '球员从队友内侧（更靠近中路）穿插跑动',
      OffBallRunsRunAhead: '超越持球队员但仍停留在最后一名防守球员前方的前插跑动',
      OffBallRunsRunBehind: '突破防线进入最后一线，跑入后卫与守门员之间的跑动',
      OffBallRunsCrossReceiver: '球员跑入禁区，准备接应队友的传中',
      OffBallRunsSupport: '球员跑动与持球人保持一线，提供近距离的传球选项',
      OffBallRunsComingShort: '球员朝持球人方向跑动，提供近距离支援或回传选项',
      AerialsOppHalf: '进入对方半场的争顶成功次数',
      xP: '预期传球值(xP)衡量成功完成传球的质量',
      CarriesIntoFinalThird: '从最后三分之一区外到内至少有 7 米的管道',
      DribblesAttempted: '尝试运球次数',
      SpeedScore: '基于不同速度指标的球员身体表现',
      EnduranceScore: '基于不同指标的球员耐力身体表现',
      GoalsConceded: '失球数',
      HeadedGoals: '头球进球数',
      SavesInBox: '禁区内射门扑救次数',
      SavesOutBox: '禁区外射门扑救次数',
      ShotsOnTargetInBoxAgainst: '禁区内射门失球数',
      ShotsOnTargetOutBoxAgainst: '禁区外射正次数',
      SwitchPlaySuccessful: '球的横向位移大于其朝向对方球门的位移的、超过 32 米的完成传球次数',
      SwitchPlayTotal: '当球的横向位移大于其朝向对方球门的位移时，尝试传球超过 32 米的总数',
      PassesInsideOppHalf: '在对方半场开始和结束的传球总数',
      PassesInsideOppHalfSuccessful: '在对方半场开始和结束时完成的传球次数',
      TacklesAttemptedFirstThird: '球场前三分之一尝试铲断总数',
      TacklesAttemptedSecondThird: '球场第二个三分之一的尝试铲断总数',
      TacklesFirstThird: '球场前三分之一的成功铲断次数',
      TacklesSecondThird: '球场第二个三分之一的成功铲断次数',
      FoulsOwnHalf: '球员本方半场犯规次数',
      TouchesOppHalf: '对方半场触球次数',
      TacklesAttemptedNotAdjusted: '尝试铲断总数，无控球权调整',
      TacklesSuccessfulNotAdjusted: '成功抢断总数，不考虑控球权调整',
      AvgTop5MaxSpeed: '玩家五个最高速度的平均值',
      LBPReceived: 'Number of line-breaking passes received',
      LBPMReceived: '突破对方中场线的传球次数',
      LBPMDReceived: '突破对方中场和防线的传球次数',
      ThroughBallReceived: '突破对方最后防线的传球次数',
      ShortPassesSuccessful: '完成短传次数（12米以下）',
      PassingSuccessForwardPct: '向前传球成功率',
      PassingSuccessBackwardPct: '向后传球成功率',
      PassingForwardBackwardPct: '向前传球与向后传球的比率',
      LongBallPerPassesPct: '长传球占传球总数的百分比',
      LongBallReceivedOppHalf: '对方场上接到的长球数量',
      OffensiveActions: '进攻性动作',
      SuccessfulDribblesPct: '成功运球次数/总运球尝试次数',
      OffensiveTouchesOutBoxPct: '禁区外进攻性触球百分比',
      HsrDistanceIP: '冲刺距离 >21 公里/小时',
      HsrDistanceOOP: '失控冲刺距离 >21 公里/小时',
      JoggingDistanceIP: '控球慢跑距离',
      JoggingDistanceOOP: '控球后慢跑距离',
      RunningDistanceIP: '控球跑动距离',
      RunningDistanceOOP: '控球后跑动距离',
      SprintsDistanceIP: '控球冲刺距离>24公里/小时',
      SprintsDistanceOOP: '失控冲刺距离 >24 km/h',
      WalkingDistanceIP: '控球步行距离',
      WalkingDistanceOOP: '控球后步行距离'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: '中国农业大学',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: '波赫',
      PassesTotalOppHalf: '前列腺增生症',
      ProgressivePassesTotal: '跨太平洋伙伴关系协定',
      DuelsWon: '数据仓库',
      NonPenaltySaves: '核动力源',
      BadActionsOppHalf: '巴奥菲',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: '索托布',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: '气相色谱',
      SavesInBox: 'SIB',
      SavesOutBox: '哭泣',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRMS',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      HeadedXG: '头球xG',
      HeadedSetPieceTooltip: '仅显示定位球头球破门的球员',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR'
    },
    AerialsOppHalf: '对方半场争顶次数',
    xP: '期望传球值',
    CarriesIntoFinalThird: '开到最后⅓',
    scoreDifference: '得分差异：显示本场比赛的表现是高于还是低于赛季平均水平',
    SpeedScore: '速度力量得分',
    EnduranceScore: '耐力分数',
    SwitchPlaySuccessful: '切换播放成功',
    SwitchPlayTotal: '切换播放总数',
    PassesInsideOppHalf: '在奥普半场内传球',
    PassesInsideOppHalfSuccessful: '奥普半场内传球成功',
    TacklesAttemptedFirstThird: '首先尝试铲球 ⅓',
    TacklesAttemptedSecondThird: '第二次尝试铲断 ⅓',
    TacklesFirstThird: '首先铲球成功 ⅓',
    TacklesSecondThird: '成功擒抱第二⅓',
    FoulsOwnHalf: '本方半场犯规',
    TouchesOppHalf: '触及奥普半场',
    TacklesAttemptedNotAdjusted: '尝试铲球未调整',
    TacklesSuccessfulNotAdjusted: '铲断成功未调整',
    AvgTop5MaxSpeed: '平均 Top5 最大速度',
    LBPReceived: '收到的突破线通行证',
    LBPMReceived: '收到断线通行证（M线）',
    LBPMDReceived: '收到断线通行证（MD 线）',
    ThroughBallReceived: '接到直塞球',
    recoveriesRate: '采收率',
    turnoversRate: '损耗率',
    HeadedShots: '头球',
    HeadedXG: '头球xG',
    HeadedSetPieceTooltip: '仅显示定位球头球破门的球员',
    HsrDistanceIP: '高铁远程IP',
    HsrDistanceOOP: '高铁距离 OOP',
    JoggingDistanceIP: '慢跑距离IP',
    JoggingDistanceOOP: '慢跑距离OOP',
    RunningDistanceIP: '跑步距离IP',
    RunningDistanceOOP: '跑步距离OOP',
    SprintsDistanceIP: '冲刺距离IP',
    SprintsDistanceOOP: '冲刺距离 OOP',
    WalkingDistanceIP: '步行距离IP',
    WalkingDistanceOOP: '步行距离OOP'
  },
  team: {
    title: '球队表',
    subtitle: '深入了解团队特点和统计数据',
    averageAge: '平均年龄',
    transferBalance: '转会预算',
    roster: '名单',
    stadium: '体育场',
    coach: '教练',
    transfers: '转会',
    trends: '趋势',
    loans: '租借',
    loanFrom: '租借自',
    loanTo: '租借到',
    latestGames: '近{0}场比赛',
    latestXGames: '近场比赛',
    playingFor: '效力于',
    overview: '总览',
    visualization: '可视化',
    location: '地理位置',
    outcome: '结果',
    beeswarm: '排名',
    parentTeam: '一线队',
    childTeam: '青年队',
    preferredFormation: '习惯阵型',
    mostFrecuentFormations: '最常见的队形',
    viewType: '查看类型',
    overviewTab: {
      axisXTotal: '总',
      axisXper90: '\'每90分钟',
      dataPerGameText: '每场比赛数据',
      season: '赛季',
      last: '上一个',
      current: '当前',
      TeamStyle: '风格',
      TeamDefensive: '防守',
      TeamOffensive: '进攻',
      TeamCustom1: '自定义1',
      TeamCustom2: '自定义2',
      TeamCustom3: '自定义3',
      TeamCustom4: '自定义4',
      coach: '教练',
      groups: {
        Goals: {
          name: '进球数',
          desc: '展示点球进球数和非点球进球数（运动战和定位球）。'
        },
        Assists: {
          name: '助攻数',
          desc: '本赛季助攻更多的球员（运动战和定位球）。'
        },
        xG: {
          name: '预期进球数',
          desc: '运动战和定位球预期进球数'
        },
        xA: {
          name: '预期助攻数',
          desc: '运动战和定位球预期助攻数'
        },
        Finishing: {
          name: '终结',
          desc: '射门得分百分比'
        },
        ScoringContribution: {
          name: '进球分布',
          desc: '球队的助攻数和进球数'
        },
        xT: {
          name: '预期威胁值',
          desc: '运动战、定位球和负预期威胁值总和'
        }
      },
      stats: {
        openPlay: '运动战',
        setPiece: '定位球',
        negative: '负',
        npg: '非点球进球',
        goalsPenalty: '点球进球',
        npgOpenPlay: '运动战非点球进球',
        npgSetPiece: '定位球非点球进球',
        assists: '助攻数',
        assistsConceded: '失球助攻数',
        assistsOpenPlay: '运动战助攻数',
        assistsSetPiece: '定位球助攻数',
        xGOpenPlay: '运动战预期进球数',
        xGSetPiece: '定位球预期进球数',
        xAOpenPlay: '运动战预期助攻数',
        xASetPiece: '定位球预期助攻数',
        xAConceded: '失球xA数',
        nonPenaltyShots: '非点球射门数',
        penaltyShots: '点球射门数',
        xT: '预期威胁值',
        xTOpenPlay: '运动战预期威胁值',
        xTSetPiece: '定位球预期威胁值',
        xTNeg: '负预期威胁值',
        totalFinishing: '终结数',
        nonPenaltyFinishing: '非点球终结数',
        goalsPenaltyFinishing: '点球终结数',
        goal: '目标',
        notGoal: '不是目标',
        chance: '机会',
        finished: '完成的',
        notFinished: '未完成',
        walkingDistance: '步行',
        joggingDistance: '慢跑',
        runningDistance: '跑步',
        hsrDistance: '高速跑',
        sprintsDistance: '冲刺',
        runningNumber: '跑步次数',
        hsrNumber: '高速跑次数',
        sprintsNumber: '冲刺次数',
        maxSpeed: '最高速度',
        accelerations: '加速度',
        extremeAccelerations: '极端加速',
        maxAcceleration: '最大加速度'
      }
    },
    teamAnalysis: '球队分析',
    agentView: {
      positions: {
        gk: '守门员',
        leftFullback: '左边后卫',
        centralDefender: '中后卫',
        rightFullback: '右边后卫',
        midfielder: '中场',
        attackingMidfielder: '前腰',
        leftWinger: '左边锋',
        rightWinger: '右边锋',
        fw: '前锋'
      },
      groups: {
        contractEnd: '月份数',
        age: '年龄',
        availability: '可出场'
      },
      placer: {
        legend: '基于年龄、合同状态、可出场和表现的强度'
      }
    },
    transfersTab: {
      valueMovements: '转会价值',
      valueTransfers: '转会价值',
      valueLoans: '租借价值',
      avgAgeMovements: '转会平均年龄',
      avgAgeTransfers: '转会平均年龄',
      avgAgeLoans: '租借平均年龄',
      operations: {
        buys: {
          buy: '买入',
          loan: '租入',
          'end of loan': '租借到期',
          'free transfer': '自由转会',
          free: '自由转入',
          'loan transfer': '租借转会',
          other: '其他'
        },
        sells: {
          buy: '卖出',
          loan: '租出',
          'end of loan': '租借到期',
          'free transfer': '自由转会',
          free: '自由转出',
          'loan transfer': '租借转会',
          other: '其他',
          retired: '撤回'
        }
      }
    },
    trendsTab: {
      streaks: '连胜数',
      wins: '胜场',
      cleanSheets: '零封场次',
      goalPeriods: '进球时段',
      concededGoalPeriods: '失球时段',
      comebacks: '逆转数',
      avgTime: '平均时间',
      kindOfGoals: '进球类型',
      percentWinning: '胜场占比',
      percentDrawing: '打平占比',
      percentLosing: '输球占比',
      totalOf: '总值',
      minutes: '出场时间',
      before: '之前',
      after: '之后',
      playedOn: '上场',
      scored: '得分',
      conceded: '丢球',
      ownGoals: '自己的目标',
      phasesOfGame: '比赛阶段',
      intensityLabel: '区域强度',
      intensityByTeam: '按球队 %',
      intensityByLeagueAvg: '按联赛平均 %',
      buildup: '出球',
      midfieldProgression: '中场推进',
      attackOpposition: '进攻对手',
      attackingTransition: '进攻转换',
      highPress: '高位逼抢',
      midBlock: '中场阻截',
      lowBlock: '低位防守',
      defensiveTransition: '防守转换',
      draws: '平局',
      losts: '失利',
      chokes: '失误',
      zoneTooltip: '确定用于每个块的颜色渐变的标准：',
      teamPctTooltip: '基于球队在每个区域的总比赛时间的百分比。',
      leagueAvgPctTooltip: '将每个区域的球队百分比与联盟平均水平进行比较。',
      leagueAvgMinsTooltip: '对联盟应用相同的比较标准，但以分钟而不是百分比来评估总时间。',
      losses: '损失',
      results: '结果',
      kindOfConcededGoals: '失球类型',
      showMinutes: '显示会议纪要'
    },
    onOff: '开关',
    dragUpToXPlayers: '拖动至多名球员{x}',
    selectUpToXPlayers: '选择至多名球员{x}',
    onOffTab: {
      G90: '分钟进球数',
      GA90: '分钟丢球数',
      diffG90: '分钟净进球数',
      XG90: '分钟预期进球数',
      XGA90: '分钟预期丢球数',
      diffXG90: '分钟预期净进球数',
      playersOn: '组合开',
      playersOff: '组合关',
      ground: '地面',
      playersOnThePitch: '球员在场',
      playersOffThePitch: '球员不在场',
      attackTitle: '进攻',
      attackSubTitle: '进攻数据',
      defenseTitle: '防守',
      defenseSubTitle: '防守数据',
      associationTitle: '组织',
      associationSubTitle: '组织数据',
      comboOn: '活动组合',
      comboOff: '任何其他',
      diffGoals90: '90分钟净进球数',
      goals90: '90分钟非点球进球数',
      goalsAgainst90: '90分钟非点球丢球数',
      xgAgainstPer90: '90分钟预期丢球数',
      xgDiffPer90: '90分钟预期净进球数',
      xgPer90: '90分钟预期进球数',
      xt90: '90分钟预期威胁值',
      shotsOnTarget90: '90分钟射正数',
      touchesOppBox90: '90分钟对方禁区内触球次数',
      shotsOnTargetAgainst90: '90分钟被射正数',
      ppda90: '90分钟对对方球员压迫次数',
      xa90: '90分钟预期助攻数',
      directness90: '90分钟直接度',
      possession: '控球率',
      pctPasses: '传球占比',
      pctPassesFinalThird: '传球到进攻三区占比',
      placeholder: '先选择一个队伍',
      subtitle: '通过添加或删除阵容中的球员来优化队伍的指标'
    },
    terms: {
      short: '短期',
      mid: '中期',
      long: '长期'
    },
    report: {
      title: '球队报告',
      selectedPeriod: '选择的时期',
      stackedCharts: '堆叠图表',
      radars: '雷达',
      generalData: '常规数据',
      scoringChances: '得分机会',
      areasReport: '区域报告',
      setPieceReport: '定位球报告',
      corners: '角球',
      cornersAgainst: '被角球',
      indirectFreeKicks: '间接任意球',
      indirectFreeKicksAgainst: '被间接任意球',
      freeKicks: '任意球',
      freeKicksAgainst: '被任意球',
      penaltys: '点球',
      freeKicksContribution: '任意球贡献',
      shotsContribution: '射门贡献',
      topXPlayersByStats: '统计前 {x} 名球员',
      lastShotZone: '最后射门区域',
      throwSide: '界外球边',
      kindOfThrow: '界外球类型',
      scored: '进球',
      against: '被进球',
      perGame: '每场比赛',
      total: '总计',
      efficiency: '效率',
      organizedAttack: '有组织进攻',
      offTransition: '进攻转换',
      chances: '机会',
      chancesScored: '进球机会',
      chancesAgainst: '被进球机会',
      goalsScored: '进球数',
      goalsAgainst: '失球数',
      goalsOrganizedAttack: '有组织进攻进球',
      goalsOffTransition: '进攻转换进球',
      goalsSetPiece: '定位球进球',
      goalsOrganizedAttackScored: '有组织进攻进球数',
      goalsOrganizedAttackAgainst: '有组织进攻失球数',
      goalsOffTransitionScored: '进攻转换进球数',
      goalsOffTransitionAgainst: '进攻转换失球数',
      goalsSetPieceScored: '定位球进球数',
      goalsSetPieceAgainst: '定位球失球数',
      crossSide: '传中边',
      externalShot: '外围射门',
      innerPlay: '内线进攻',
      throwIn: '界外球',
      box: '禁区',
      zone2: '区域2',
      goalsPerPhases: '阶段进球数'
    },
    minutesAlert: '只显示出场时间超过分钟的球员',
    minutesException: '无出场时间超过450分钟球员，显示所有球员',
    analysis: '分析',
    substitutions: '换人',
    attackZones: '进攻区域',
    formations: '阵型',
    shotZones: '射门区域',
    crossings: '传中',
    byTime: '根据时间',
    byPosition: '根据位置',
    byPlayer: '根据球员',
    W: '胜',
    D: '平',
    L: '负',
    substitutionsByGame: '根据比赛的换人',
    substitutionsShort: '换人',
    avgSeasonShort: '赛季平均',
    startingAt: '开始时间',
    endingAt: '结束时间',
    startingAtInfo: '根据第一个事件的位置显示占有率',
    endingAtInfo: '根据最后一个事件的位置显示占有率',
    endingWithShot: '以射门结束',
    endingInBox: '在禁区内结束',
    pfX: '传球到进攻三区{x}',
    bySide: '根据主客场',
    cornerKicks: '角球',
    included: '包含',
    excluded: '不包含',
    onlyCorner: '仅角球',
    sizeByMarketValue: '根据市价度量',
    timeInTeam: '效力年长',
    newSignings: '新签约',
    sizeBy: '根据...度量',
    connections: '连接',
    assistant: '传球者',
    finisher: '得分者',
    playersMinutesAlert: '仅显示在所选赛季有出场时间的球员',
    strategyFilterTooltip: '显示定位球或开场比赛期间发生的事件',
    sideFilterTooltip: '仅显示从所选一侧（左侧或右侧）开始的定位球',
    teamMinutesAlert: '*仅显示比赛时间达到或超过 450 分钟的球队',
    homeCoach: '家庭教练',
    awayCoach: '客场教练'
  },
  leagueTable: {
    subtitle: '查看联赛走势'
  },
  leagueMatchdays: {
    byRound: '按轮次',
    byDate: '按日期',
    byTeam: '按球队'
  },
  teamStats: {
    subtitle: '比较球队表现',
    xGDiffPerGame: '期望进球数与实际进球数差',
    xGDiffPerGameExplicit: '期望进球数与实际进球数差',
    expectedPointsDiff: '期望得分数与实际得分数差',
    expectedPointsDiffExplicit: '期望得分数与实际得分数差',
    games: '比赛',
    gamesExplicit: '出场比赛场次',
    pointsPerGame: '场均得分',
    pointsPerGameExplicit: '场均得分'
  },
  roles: {
    ROLE_USER: '用户',
    ROLE_ADMIN: '管理员',
    ROLE_REPORTS: '报告',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: '物理数据',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: '跟踪',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: '以 JSON 格式轻松提取球员、球队、比赛和联赛信息。',
    ROLE_EVENTING_DATA_description: '根据 +100 性能指标，通过雷达图、球员排名、地图等深入了解统计数据。',
    ROLE_PHYSICAL_DATA_description: '访问体能数据，并根据各种性能指标（距离、速度、冲刺、加速度......）筛选球员。',
    ROLE_VIDEO_description: '提供视频和阵容，并为比赛标记事件和统计数据，以便进行深入分析。',
    ROLE_DRIBLAB_HUB_description: '通过日历、备注、警报和文档共享，有效跟踪和管理侦察任务。',
    ROLE_TRACKING_description: '通过我们的 API 接收比赛中所有球员的位置数据，进行综合分析。',
    ROLE_ARRIGO_description: '将 eventing 和 tracking 数据结合到创新指标中，超越传统，并为每个动作增加价值。',
    ROLE_REPORTS_description: '向我们的分析师团队索取详细的球探报告，寻找最合适的球队或球员。',
    ROLE_RAW_EVENTING: '原始三项赛'
  },
  administration: {
    pageSubtitle: '管理应用程序的运行',
    newClient: '创建客户',
    clientDuplicateName: '已存在使用该名称的客户。请在列表中选择该客户，并使用「新建用户」在该客户下添加用户。',
    newUser: '创建用户',
    editClient: '编辑客户',
    editUser: '编辑用户',
    clientName: '名称',
    permissions: '授权',
    releaseUser: '释放用户',
    connectAsUser: '以用户连接',
    releaseModalTitle: '确认释放用户',
    releaseModalMessage: '用户将收到关于其新账户信息的邮件，确认通知？',
    clientType: {
      Driblab: '',
      Team: '球队',
      Brand: '品牌方',
      Federation: '联盟',
      Media: '媒体',
      Agency: '经纪人',
      Individual: '个体'
    },
    userType: {
      Ownership: '所有权',
      SportingDirector: '体育总监',
      Brand: '品牌方',
      Federation: '联盟',
      Media: '媒体',
      Agency: '经纪人',
      Individual: '个体',
      Scout: '球探',
      Coach: '教练',
      supervision: {
        title: '监管层级',
        subtitle: '监督只能向下流动。不允许同级监管。',
        supervisesLowerLevels: '监督以下所有角色',
        ruleNoSameLevel: '同一级别的角色不能互相监督。',
        ruleOnlyDownwards: '只允许从上级到下级进行监督。',
        ruleLevel3NoSupervision: '最低级别无监管权限。',
        currentUserType: '您当前的用户类型'
      }
    },
    visibleYears: '可见年份',
    areaModalTitle: '确认激活取消联赛',
    areaModalMessage: '确定激活取消选中地区的所有联赛',
    countStats: '计数数据',
    userClientModalTitle: 'User already exists in another client',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: '合同',
    contracts: '合同列表',
    invoiceName: '发票名称',
    contractFee: '合同费用',
    renewal: '续约',
    consultancy: '咨询',
    deleteContract: '删除客户合同',
    deleteContractMessage: '合同将被永久删除。您确定吗？',
    activeVsHired: '在岗 vs 已雇佣',
    requestedVsHired: '已请求 vs 已雇佣',
    activeVsHiredWithPlaceholder: '{0} 活跃 vs {1} 受聘',
    requestedVsHiredWithPlaceholder: '{0} 请求与 {1} 雇用',
    salesRepresentative: '销售代表',
    periodicities: {
      periodicity: '周期',
      annual: '年度',
      biannual: '半年',
      quarterly: '季度',
      monthly: '每月',
      bimonthly: '双月',
      onePayment: '一次付款',
      fourmonthly: '每四个月'
    },
    paymentMethods: {
      payment: '付款',
      method: '方式',
      transfer: '转账',
      mandate: '授权扣款'
    },
    marketingOptions: {
      marketing: '市场营销',
      socialMediaAdd: '社交媒体广告',
      videoWithFeedback: '带有Feedback的视频'
    },
    status: {
      status: '状态',
      pending: '待处理',
      active: '激活',
      expiringSoon: '即将到期',
      expired: '已到期',
      expiringSoonWithDays: '合同即将到期：还剩 {0} 天'
    },
    updates: {
      roleAdded: '<b>{0}</b> 将角色 <b>{1}</b> 添加给了 <b>{2}</b>。',
      roleRemoved: '<b>{0}</b> 从 <b>{2}</b> 移除了角色 <b>{1}</b>。',
      leagueAdded: '<b>{0}</b> 将 <b>{1}</b> 添加到联赛 <b>{2}</b>。',
      leagueRemoved: '<b>{0}</b> 从联赛 <b>{2}</b> 移除了 <b>{1}</b>。',
      seasonAdded: '<b>{0}</b> 将 <b>{1}</b> 添加到赛季 <b>{2}</b>。',
      seasonRemoved: '<b>{0}</b> 从赛季 <b>{2}</b> 移除了 <b>{1}</b>。',
      updateNotesPlaceholder: '请在此添加变更的背景信息或相关备注...',
      updates: '更新',
      products: '产品'
    },
    clients: '客户',
    trials: '试炼',
    activeClients: '活跃客户',
    activeTrials: '积极试验',
    activeTrialUsers: '活跃试用用户',
    activeContracts: '活跃合约',
    expiration: '到期日',
    clientWarnings: {
      activeContractInactiveClient: '具有有效合同但没有启用用户的客户',
      activeContractTrialUsers: '合同有效期间拥有试用用户的客户',
      activeUsersWithoutContract: '拥有活跃非试用用户但没有有效合同的客户',
      upcomingExpirations: '即将到期',
      renewedContracts: '续签合同的客户',
      clientsWithWarnings: '需要关注的客户',
      enabledUsersWithoutContract: '“启用没有有效合同的非试用用户”',
      trialUsersWithContract: '尽管合同有效，但仍处于试用模式的用户',
      activeContractInactiveUsers: '客户拥有有效合同，而所有用户均处于非活动状态',
      activeContract: '该客户有有效合同',
      noEnabledUsers: '该客户端没有启用的用户',
      ongoingTrialInactiveUsers: '正在进行试用但没有启用用户的客户',
      neverLoggedIn: '从未登录过的客户'
    },
    daysLeft: '剩余天数',
    expiringSoon: '即将到期',
    loggedThisWeek: '本周登录',
    withWarnings: '有警告',
    ofActiveClients: '活跃客户数',
    endingIn30Days: '30 天后结束',
    neverLogged: '从未登录过',
    ofActiveTrials: '积极试验',
    activeClientsWithoutTrial: '活跃客户（不包括试用）',
    renewals: '续约',
    ofActiveContracts: '有效合同数'
  },
  dashboards: {
    lastGame: '上场比赛分析',
    lastGameSimple: '上场比赛',
    seeAllGameInfo: '查看所有比赛信息',
    nextGame: '下场比赛前瞻',
    myTeam: '我的球队',
    lastMatchdayGames: '上一比赛日',
    lastAdded: '上一添加',
    myFavorites: '我的收藏',
    seeAllFavorites: '查看所有收藏',
    placeholderFavorites: '您可以从球员详情中添加收藏',
    placeholderTeamFavorites: '您可以从球队详情中添加收藏',
    placeholderLeagueFavorites: '您可以从联赛详情中添加收藏',
    myCollections: '我的收藏夹',
    placeholderCollections: '您当前还未创建收藏夹',
    lastCreated: '上一创建',
    seeAllCollections: '查看所有收藏夹',
    seeRival: '查看对手',
    seeMyTeam: '查看我的球队',
    title: '看板总览',
    subtitle: '欢迎回来',
    recentPlayers: '最近球员',
    lastScouted: '最近探查',
    scout: '探查',
    reportsRequested: '报告',
    lastRequested: '上一请求',
    goInbox: '',
    placeholderLastScouted: '您可以从左边栏或球探工具搜索球员',
    placeholderReports: '您可以请求球员详细报告',
    nationalPlayers: '其他国家最有价值国家队球员',
    lastGames: '过往比赛',
    nationalPlayersShort: '其他国家的国家队球员',
    nextMatchdayGames: '下一比赛日',
    injuredPlayers: '受伤球员',
    atPresent: '当前',
    seeAllPlayers: '查看所有球员',
    suspendedPlayers: '受伤球员',
    placeholderInjured: '无受伤球员',
    teamValueImpacted: '球队价值受影响',
    placeholderSuspended: '无禁赛球员',
    placeholderNextGame: '无可用比赛',
    placeholderNoGames: '当前无可用比赛',
    placeholderLastMatchDayNotFound: '上一比赛日不可用',
    placeholderNextMatchDayNotFound: '下一比赛日不可用',
    usersMostSearch: '最多搜索用户',
    lastTwoDays: '过去两日',
    searchesHistory: '搜索历史',
    dayByDay: '每日',
    activeUsersTitle: '活跃用户',
    activeUsersSubtitle: '在过去一月记录至少一个',
    onlineUsersTitle: '在线用户',
    onlineUsersSubtitle: '搜索过去一小时',
    searchesPerformed: '已搜索记录',
    onlyClients: '仅客户',
    activeClientsTitle: '活跃客户',
    activeClientsSubtitle: '至少有一名活跃用户',
    last24Hours: '过去小时',
    activityHistory: '活动历史',
    loginHistory: '访问历史',
    failLogins: '访问失败',
    successLogins: '访问成功',
    clientStats: '客户数据',
    playersMostSearch: '最多被搜索球员',
    toolsMoreUsed: '更多工具',
    hotPlayers: '热度球员',
    last_month: '过去一月',
    last_week: '过去一周',
    last_day: '过去一日',
    nClients: '客户数量',
    userDashboard: '用户仪表板',
    userDashboardSubtitle: '账户活动摘要',
    offlineDaysOfClient: '每个客户的离线天数',
    hideNoConnected: '隐藏未连接',
    onlyTrial: '仅试用客户',
    daysWithoutLogin: '未登录天数',
    trialDays: '试用天数'
  },
  faq: {
    subtitle: '了解Driblab PRO',
    categories: {
      playerMetrics: '球员指标',
      teamMetrics: '球队指标',
      positions: '球队排名',
      tools: '工具',
      api: 'API',
      videos: '教程',
      playerPositions: '球员位置',
      userTypes: '用户类型'
    },
    positions: {
      GK: '守门员',
      DR: '右边后卫',
      DC: '中后卫',
      DL: '左边后卫',
      DMR: '右边翼卫',
      DMC: '后腰',
      DML: '左边翼卫',
      MR: '右前卫',
      MC: '中前卫',
      ML: '左前卫',
      AMR: '右边锋',
      AMC: '前腰',
      AML: '左边锋',
      FWR: '右前锋',
      FW: '中锋',
      FWL: '左前锋'
    },
    metrics: {
      categories: {
        Association: '组织',
        Saving: '扑救',
        Shooting: '射门',
        Defending: '防守',
        Passing: '传球',
        BallHandling: '处理球',
        Aerial: '争顶',
        Physical: '身体',
        Predictive: '预判',
        Arrigo: '阿里戈',
        Score: '得分',
        Turnovers: '丢失球权',
        Carries: '带球',
        SequenceInvolvement: '参与进攻',
        Crosses: '传中',
        Distance: '距离',
        Sprint: '冲刺',
        Acceleration: '加速',
        MaxAcceleration: '最大加速度',
        Speed: '速度',
        OutPlay: '突破对手',
        LineBreakingPasses: '突破防线的传球',
        LineBreakingCarries: '突破防线的带球',
        LineBreakingActions: '穿越防线的行动',
        PassUnderPressure: '压迫下传球',
        BallReceived: '接球',
        PassesUnderPressure: '在压力下通过',
        OnBallPressureReceived: '持球时所受压迫',
        OnBallPressure: '对球施压',
        BallReceiptsInSpace: '空间中的接球',
        SpatialCoverage: '空间覆盖',
        OffBallPressure: '无球施压',
        OffBallRuns: '无球跑动',
        NoCategory: '其他',
        subcategories: {
          Quality: '质量',
          Quantity: '数量',
          TeamComparison: '球队对比',
          Receptions: '接球',
          LongBalls: '长传球',
          Efficiency: '效率',
          Ratio: '比率',
          Defensive: '防守',
          Offensive: '进攻',
          Foot: '脚',
          Progression: '推进',
          TopValue: '最高值',
          Predictive: '预判',
          Distance: '距离',
          Aerial: '争顶',
          Crosses: '传中',
          NoCategory: '其他'
        },
        desc: {
          Association: '组织',
          Saving: '扑救',
          Shooting: '射门',
          Defending: '防守',
          Passing: '传球',
          BallHandling: '处理球',
          Aerial: '争顶',
          Physical: '身体',
          Predictive: '预判',
          Arrigo: '阿里戈',
          Score: '得分',
          Turnovers: '丢失球权',
          Carries: '带球',
          SequenceInvolvement: '参与进攻',
          Crosses: '传中',
          Distance: '不同速度下的覆盖距离',
          Sprint: '不同速度下的跑动',
          Acceleration: '加速',
          Speed: '速度',
          OutPlay: '突破对手',
          LineBreakingPasses: '突破防线的传球',
          LineBreakingCarries: '突破防线的带球',
          LineBreakingActions: '穿越防线的行动',
          PassUnderPressure: '压迫下传球',
          BallReceived: '接球',
          OnBallPressureReceived: '持球时所受压迫',
          OnBallPressure: '对球施压',
          BallReceiptsInSpace: '空间中的接球',
          SpatialCoverage: '空间覆盖',
          OffBallPressure: '无球施压',
          OffBallRuns: '无球跑动'
        },
        abbr: {
          Association: '组织',
          Saving: '扑救',
          Shooting: '射门',
          Defending: '防守',
          Passing: '传球',
          BallHandling: '处理球',
          Aerial: '争顶',
          Physical: '身体',
          Predictive: '预判',
          Arrigo: '阿里戈',
          Score: '得分',
          Turnovers: '营业额',
          Carries: '带球',
          SequenceInvolvement: '参与进攻',
          Crosses: '传中',
          Distance: '距离',
          Sprint: '跑动',
          Acceleration: '加速',
          MaxAcceleration: '最大加速度',
          Speed: '速度',
          OutPlay: '突破对手',
          LineBreakingPasses: '突破防线的传球',
          LineBreakingCarries: '突破防线的带球',
          LineBreakingActions: '穿越防线的行动',
          PassUnderPressure: '压迫下传球',
          BallReceived: '接球',
          OnBallPressureReceived: '持球时所受压迫',
          OnBallPressure: '对球施压',
          BallReceiptsInSpace: '空间中的接球',
          SpatialCoverage: '空间覆盖',
          OffBallPressure: '无球施压',
          OffBallRuns: '无球跑动'
        }
      },
      types: {
        1: '每分钟',
        2: '百分比',
        3: '比率',
        4: '效率',
        5: '均值',
        6: '每场比赛',
        7: '差值',
        8: '最大值'
      },
      moreInfo: '您可以在此处阅读更多内容'
    },
    api: {
      subtitle: '从不同请求获取数据',
      resourcesTitle: '资源',
      authentication: '身份验证',
      authText: 'In order to call the API you have to include in every request the header `Authorization` with value `Bearer {API_TOKEN}`',
      generate: '生成',
      tokenPlaceholder: 'If you do not have a token or it has expired, click on \'Generate\'',
      pathParameters: '路径参数',
      queryParameters: '查询参数',
      responseModel: '响应模型',
      tokenWarning: '生成令牌以使用',
      pathParamsWarning: '有未填写路径参数',
      genericDescription: 'API (应用程序编程接口) 允许开发者访问数据或功能并将其集成到自己的应用程序中。我们的足球统计API提供了对国家、赛事、球队、球员、比赛等各种数据的全面访问。通过使用此API, 您可以构建利用我们丰富足球数据的应用程序，用于分析、可视化或其他创新解决方案。',
      methods: {
        getAllCountries: '此方法获取 API 中可用的所有国家的完整列表，并提供每个国家的唯一标识符和名称等关键细节。此端点非常适合需要地理足球数据的应用程序，可实现国家选择、过滤和分析等功能。它也是与依赖 `countryId` 参数的其他端点交互的基础资源，确保与 API 数据集的顺畅集成和导航。',
        getCountryDetail: '此方法提供有关 API 中可用的特定国家的详细信息。通过此端点，您可以检索国家名称、代码及其相关的元数据等数据。此方法对于需要特定国家详细信息以增强用户体验的应用程序特别有用，例如显示上下文信息或基于地理数据创建定制洞察。它补充了其他端点，允许更深入地探索选定的国家。',
        getCountryCompetitions: '此方法获取特定国家内所有可用赛事的列表。这是构建允许用户按区域探索赛事功能的重要资源，为国家数据与相关赛事之间的无缝连接提供了方式。此端点对于专注于本地化足球内容或区域分析的应用程序至关重要。',
        getAllCompetitionTypes: '此方法返回 API 中可用的所有赛事类型的列表，例如联赛、杯赛和国际锦标赛。此端点非常适合对赛事进行分类，并为用户提供涵盖不同类型活动的有组织视图。它在构建如基于赛事性质探索足球数据的筛选器或下拉菜单等功能时特别有用。',
        getAllCompetitions: '此方法获取 API 中所有赛事的综合列表，无论类型或地点如何。此端点对于需要显示或分析广泛足球赛事的应用程序非常有用，允许用户探索并选择感兴趣的活动。',
        getCompetitionAvailable: '此方法获取当前在 API 中标记为可用的赛事列表。这确保了返回的数据是最新的并可供应用程序使用。对于开发依赖于活跃或可访问赛事的功能的开发者来说，此功能尤为有用，使用户能够探索相关活动，而无需面对过时或不完整的数据。',
        getCompetitionDetail: '此方法提供有关 API 中可用的特定赛事的详细信息。此功能对需要深入赛事信息的应用程序特别有用，可实现详细视图、上下文洞察或基于赛事特征的筛选选项。',
        getCompetitionSeasons: '此方法获取与特定赛事相关的所有赛季的列表。此端点对于旨在全面覆盖赛事历史或当前状态的应用程序至关重要，使用户能够按赛季探索数据。',
        getSeasonAvailable: '此方法提供API中当前标记为可用的赛季列表。对于专注于实时或正在进行的足球赛事的应用程序非常有用，允许用户与相关且最新的赛季数据进行交互。',
        getSeasonDetail: '此方法检索特定赛季的详细信息，包括时间线、相关赛事和关键元数据。对于需要深入了解特定赛季的应用程序来说，此端点至关重要，支持功能如赛季概览、按赛事过滤或展示用户交互的详细时间线。',
        getSeasonTeams: '此方法提供特定赛季中参赛所有球队的列表。非常适合构建诸如阵容管理、球队表现分析或为用户创建赛季特定过滤器的功能。',
        getSeasonPlayer: '此方法检索特定赛季中注册的所有球员列表。非常适合构建功能，例如球员名单、表现跟踪或基于所选赛季的球员筛选。',
        getSeasonPlayerStats: '此方法提供特定赛季中所有球员的详细统计数据。对于专注于数据分析、球员对比或动态可视化赛季表现的应用程序来说非常有用。',
        getSeasonArrigoMetrics: '此方法提供特定赛季所有球员的综合统计数据。它对于专注于分析、球员比较或创建球员赛季成就动态可视化的应用程序尤其有用。',
        getSeasonTeamStats: '此方法提供特定赛季中所有参赛球队的综合统计数据。对于专注于球队分析、赛季总结或比较赛季中各队表现的应用程序非常有用。',
        getSeasonCoaches: '此方法检索特定赛季中管理球队的所有教练的列表。对于专注于赛季洞察、教练分析或跟踪赛季期间球队管理变化的应用程序特别有用。',
        getSeasonGames: '此方法提供特定赛季中所有比赛的列表。非常适合需要显示完整赛季赛程、分析比赛结果或为用户提供全面赛季比赛数据访问的应用程序。',
        getSeasonGamesMatchday: '此方法检索特定赛季中某比赛日的所有比赛。非常适合用于显示比赛日赛程、分析特定轮次或为赛季中的特定比赛组提供详细分析的应用程序。',
        getSeasonLeagueTable: '此方法提供特定赛季的联赛排名表，包括排名、积分、胜场、平局、失利以及每支球队的其他相关统计数据。对于专注于跟踪球队排名、分析联赛进程或向用户呈现赛季最新排名的应用程序来说，此端点至关重要。',
        getTeamDetail: '此方法提供有关特定球队的详细信息，包括球队名称、成立年份、主场以及其他元数据。此端点非常适合需要深入了解球队的应用程序，可实现详细的球队档案、历史背景或通过丰富的球队相关数据提升用户体验的功能。',
        getTeamLoans: '此方法检索涉及特定球队的租借交易信息。对于专注于转会分析、球队阵容管理或赛季期间球员动态追踪的应用程序，这一端点特别有用。',
        getTeamRoster: '此方法提供特定球队阵容中的所有球员的完整列表。非常适合需要显示球队阵容、分析球员角色或管理球队阵容相关功能的应用程序。',
        getTeamGames: '此方法检索特定球队所参加的所有比赛的列表。对于专注于球队表现、赛程追踪或向用户提供球队完整比赛历史的应用程序，这一端点特别有用。',
        getTeamGameStats: '此方法提供特定球队在某场比赛中的详细统计数据。非常适合专注于比赛分析、表现评估或深入解析球队单场比赛表现的应用程序。',
        getTeamTransfers: '此方法检索涉及特定球队的转会交易信息。对于关注转会市场分析、球队阵容变动或长期球员动态追踪的应用程序，这一端点特别有用。',
        getGameStatus: '此方法提供API中所有可能的比赛状态列表，例如已安排、进行中、已完成、已延期或已取消。此端点对于需要实时比赛跟踪、按状态筛选比赛或向用户提供比赛进度或状态清晰更新的应用程序特别有用。',
        getPlayerPositions: '此方法返回所有可能的球员位置列表，例如守门员、后卫、中场和前锋。此端点特别适用于分类球员、分析位置数据或允许用户根据球员场上角色筛选球员的应用程序。',
        getGameDetail: '此方法提供有关特定比赛的全面信息，包括参赛球队、日期和时间、比赛场地、比分以及其他关键元数据的详细信息。此端点非常适合需要深入比赛洞察的应用程序，支持功能如详细的赛前预览、比赛报告或数据分析。',
        getGameStats: '此方法提供特定比赛的详细统计数据，包括进球、射门、控球率、传球和防守动作等指标。此端点特别适用于专注于比赛分析、赛后报告或可视化比赛中球队表现的应用程序。',
        getGamePlayerStats: '此方法检索特定比赛中所有参赛球员的详细表现统计数据。此端点特别适用于分析个人球员表现、生成比赛报告或在单场比赛中比较球员的应用程序。',
        getGamePlayerPhysicalStats: '此方法提供特定比赛中球员的详细体能表现指标。此端点非常适合专注于球员体能分析、体能表现跟踪或生成单个球员比赛详细洞察的应用程序。',
        getGameTeamPhysicalStats: '此方法提供特定比赛中球队的详细身体性能指标。这包括总跑动距离、冲刺次数、高强度跑动以及其他身体属性的数据。此端点特别适用于专注于球队体能分析、比较球队之间的身体努力或评估比赛整体表现的应用程序。',
        getGamePlayerArrigoMetrics: '此方法为特定比赛中的玩家提供详细的arrigo指标。它对于专注于分析并深入了解比赛中的玩家的应用程序特别有用。',
        getGameTeamArrigoMetrics: '此方法提供特定比赛中队伍 Arrigo 的详细指标。其中包括被击败的球员和其他属性等数据。这对于专注于分析评估整体比赛表现的应用程序尤其有用。',
        getGameLineup: '此方法检索特定比赛的阵容，包括首发球员、替补球员及其对应位置。此端点特别适用于显示赛前信息、分析球队阵型或提供关于球队战术决策的洞察的应用程序。',
        getGameTimeline: '此方法提供特定比赛中发生事件的时间轴列表。此端点特别适用于提供实时比赛更新、赛后总结或详细分析比赛事件的应用程序。',
        getGameTracking: '此方法提供特定比赛的跟踪数据文件下载链接。该文件包含比赛中球员和球的详细运动和位置数据。此端点特别适用于专注于高级分析、战术分析或生成比赛中球员和球运动可视化的应用程序。',
        getTrackingStatus: '此方法返回跟踪中可用的所有状态的完整列表，提供关键详细信息，例如每个状态的唯一标识符和名称。该端点非常适合需要匹配跟踪的应用程序，支持状态选择、过滤和分析等功能。它还充当与依赖“statusId”参数的其他端点进行交互的关键资源，确保无缝导航以及与 API 更广泛的数据集集成。',
        getPlayerTransfersTypes: '此方法返回可能的球员转会类型列表，例如永久转会、租借转会、自由转会或交换转会。此端点特别适用于分析转会市场趋势、分类球员流动或为用户提供与球员交易类型相关的详细信息的应用程序。',
        getPlayerDetail: '此方法提供有关特定球员的详细信息，包括个人信息、职业统计数据以及当前所属球队。此端点非常适合提供球员档案、历史分析或个人球员表现和职业轨迹分析的应用程序。',
        getPlayerGames: '此方法检索特定球员参与的所有比赛的列表。此端点特别适用于专注于球员表现跟踪、比赛历史分析或为用户提供个人球员完整比赛记录的应用程序。',
        getPlayerInjuries: '此方法提供特定球员所经历的伤病详细记录。此端点特别适用于专注于球员健康分析、职业生涯影响评估或跟踪恢复时间表的应用程序。',
        getPlayerNationalTeam: '此方法检索球员参与国家队比赛的详细信息。此端点特别适用于分析球员在国家队的表现、跟踪国际职业生涯或提供球员在锦标赛和友谊赛中的贡献的应用程序。',
        getPlayerSeasons: '此方法提供特定球员参与的所有赛季的列表。此端点特别适用于跟踪球员职业进展、分析跨赛季表现或为其成就提供历史背景的应用程序。',
        getPlayerTransfers: '此方法检索涉及特定球员的转会交易的详细历史记录。此端点特别适用于专注于球员职业生涯分析、转会市场洞察或跟踪球员在球队之间流动的应用程序。',
        getPlayerSeasonTeamStats: '此方法提供特定球员在特定赛季中与球队相关的详细表现统计数据。此端点特别适用于专注于赛季球员表现分析、跨球队或赛季的比较，以及跟踪个人对球队成功贡献的应用程序。',
        getPlayerSeasonPhysicalStats: '此方法提供特定球员在整个赛季中的详细身体表现指标。此端点特别适用于跟踪球员健康状况、分析身体表现或评估球员在赛季中的工作量的应用程序。',
        getPlayerSeasonGamePhysicalStats: '此方法按比赛提供特定球员在赛季中的身体表现指标。此端点特别适用于专注于比赛级别的健康分析、跟踪球员工作量或比较不同比赛中的身体表现的应用程序。',
        getPlayerSeasonGameStats: '此方法检索特定球员在赛季中每场比赛的详细表现统计数据。此端点特别适用于专注于比赛级别的球员分析、表现趋势跟踪或赛季内比赛间的详细比较的应用程序。',
        getCoachDetail: '此方法提供有关特定教练的详细信息，包括姓名、职业生涯、执教的球队和显著成就。此端点特别适用于突出教练档案、跟踪教练职业生涯或分析教练对球队表现的影响的应用程序。',
        getCoachHistory: '此方法检索特定教练的完整职业历史，包括执教的球队、参与的比赛以及任期时长。此端点特别适用于分析教练职业生涯、跟踪管理层变动或提供教练职业旅程和成就的洞察的应用程序。',
        getGameEventing: '该方法提供了所有事件',
        getLinkStream: '该方法检索观看游戏视频的链接',
        getLinkDownload: '此方法检索下载游戏视频的链接',
        getGameTs: '此方法提供特定匹配中的最后一个时间戳',
        getGameFileTypes: '该方法提供了匹配的文件类型',
        deletePlayer: 'This method delete a player'
      },
      responseCodes: '响应码',
      furtherInformation: '请阅读API文档以获取更多信息',
      clipboard: '已复制到剪贴板！',
      limit50: '只显示前 50 条结果'
    }
  },
  globalSearch: {
    subtitle: '深层筛选'
  },
  global: {
    teamElos: {
      title: '球队ELO值',
      subtitle: '全球球队排名与洞察',
      team: '球队',
      teams: '球队',
      dates: '枣子',
      excludeInternational: '排除国家队',
      elo: 'ELO',
      selectButton: '选择顶部',
      selectTeamFromTable: '从表格中选择球队以显示ELO趋势。',
      showingTeamAveragesLastSeason: '显示上赛季各队平均值',
      showingTeamStatsLastSeason: '仅显示各队上一个活跃赛季的数据',
      searchToolTip: '提示：按 Ctrl + B 可直接访问搜索栏',
      selectTopTooltip: '在图表中显示其他团队以进行比较',
      loadingPage: '准备数据...'
    },
    leagueElos: {
      title: '联赛ELO值',
      subtitle: '全球联赛排名和洞察',
      rankings: '排名',
      insights: '洞察',
      filters: '过滤器',
      leagues: '联赛',
      from: '起始',
      to: '结束',
      elo: 'ELO',
      change: '变化',
      league: '联赛',
      excludeContinental: '排除国际赛事',
      eloTrend: 'ELO趋势',
      eloRanking: 'ELO排名',
      currentELOLabel: '（当前 ELO）',
      allTime: '全部时间',
      average: '平均值',
      noChartData: '所选过滤条件下暂无图表数据。',
      selectLeagueFromTable: '从表格中选择联赛以显示ELO趋势。',
      noInsightsData: '所选联赛暂无洞察数据，请确保这些联赛有可用赛季及球队洞察数据。',
      showingLeagueAveragesLastSeason: '仅显示各联赛最后一个活跃赛季的平均值',
      selectTopTooltip: '在图表中显示其他联赛以进行比较',
      confederations: {
        world: '世界',
        top5: '前五',
        uefa: '欧洲足球协会（UEFA）',
        conmebol: '南美足联（CONMEBOL）',
        concacaf: '中北美及加勒比足联（CONCACAF）',
        caf: '非洲足协（CAF）',
        afc: '亚足联（AFC）'
      },
      numberOfLeagues: '联赛数量',
      minimumElo: '最低 ELO'
    },
    players: {
      title: '玩家的 GPI',
      subtitle: '全球玩家排名和见解',
      gpiRanking: 'GPI排名',
      rankTooltip: '鼠标悬停显示全球排名',
      globalRanking: '全球排名',
      player: '玩家',
      players: '玩家',
      gpiTrend: 'GPI趋势',
      currentGPILabel: '（当前 GPI）',
      nationality: '出生国家',
      position: '位置',
      marketValue: '市场价值',
      apply: '申请',
      marketValueAndAgeTooltip: '输入范围并单击应用或按 Enter 键。',
      searchPlaceholder: '搜索玩家...',
      selectTopTooltip: '在图表中显示其他球员以进行比较',
      gpi: 'GPI',
      numberOfPlayers: '玩家人数',
      showingPlayerStatsLastSeason: '仅显示球员上一个活跃赛季的平均统计数据',
      date: '日期',
      showChartLabels: '显示标签',
      marketValueTooltip: '输入范围并单击应用或按 Enter 键。',
      freeAgents: '自由球员',
      selectPlayerFromTable: '从表中选择一名球员即可查看 GPI 趋势。'
    }
  },
  iso: {
    AF: '阿富汗',
    DZ: '阿尔及利亚',
    AO: '安哥拉',
    AR: '阿根廷',
    AU: '澳大利亚',
    AZ: '阿塞拜疆',
    BH: '巴林',
    BB: '巴巴多斯',
    BE: '比利时',
    BJ: '贝宁',
    BO: '玻利维亚',
    BW: '博茨瓦纳',
    BN: '文莱',
    BF: '布基纳法索',
    KH: '柬埔寨',
    CA: '加拿大',
    CF: '中非',
    CL: '智利',
    CO: '哥伦比亚',
    CD: '刚果金',
    CG: '刚果布',
    CI: '\'科特迪瓦',
    CU: '古巴',
    CZ: '捷克',
    DJ: '吉布提',
    DO: '多米尼克',
    EC: '厄瓜多尔',
    SV: '萨尔瓦多',
    ER: '厄立特里亚',
    ET: '埃塞俄比亚',
    FI: '芬兰',
    PF: '法属波利尼西亚',
    GM: '冈比亚',
    DE: '德国',
    GI: '直布罗陀',
    GL: '格陵兰岛',
    GP: '瓜德罗普岛',
    GN: '几内亚',
    GY: '圭亚那',
    HN: '洪都拉斯',
    HU: '匈牙利',
    IN: '印度',
    IR: '伊朗',
    IE: '爱尔兰',
    IT: '意大利',
    JP: '日本',
    KZ: '哈萨克斯坦',
    KI: '基里巴斯',
    KR: ',朝鲜',
    KG: '吉尔吉斯斯坦',
    LV: '拉脱维亚',
    LS: '莱索托',
    LY: '利比亚',
    LT: '立陶宛',
    MO: '中国澳门',
    MG: '马达加斯加',
    MY: '马来西亚',
    ML: '马里',
    MH: '马绍尔群岛',
    MR: '毛利塔尼亚',
    MX: '墨西哥',
    MD: '摩尔多瓦',
    MN: '蒙古',
    MA: '摩洛哥',
    MM: '缅甸',
    NR: '瑙鲁',
    NL: '荷兰',
    NZ: '新西兰',
    NE: '尼日尔',
    MP: '北马里亚纳群岛',
    OM: '阿曼',
    PW: '帕劳',
    PA: '巴拿马',
    PY: '巴拉圭',
    PH: '菲律宾',
    PT: '葡萄牙',
    QA: '卡塔尔',
    RO: '罗马尼亚',
    RW: '卢旺达',
    LC: '圣卢西亚',
    SM: '圣马力诺',
    SA: '沙特',
    RS: '塞尔维亚',
    SL: '塞拉利昂',
    SK: '斯洛伐克',
    SB: '所罗门群岛',
    ZA: '南非',
    LK: '斯里兰卡',
    SD: '苏丹',
    SZ: '斯威士兰',
    CH: '瑞士',
    TW: '中国台湾',
    TZ: '坦桑尼亚',
    TG: '多哥',
    TT: '特立尼达多巴哥',
    TR: '土耳其',
    TV: '图瓦卢',
    UA: '乌克兰',
    GB: '英国',
    UY: '乌拉圭',
    VU: '瓦努阿图',
    VE: '委内瑞拉',
    VG: ',英属维京群岛',
    EH: '西撒哈拉',
    ZM: '赞比亚',
    AL: '阿尔巴尼亚',
    AD: '安多拉',
    AG: '安提瓜和巴布达',
    AM: '亚美尼亚',
    AT: '奥地利',
    BS: '巴哈马',
    BD: '孟加拉国',
    BY: '白俄罗斯',
    BZ: '伯利兹',
    BT: '不丹',
    BA: '波黑',
    BR: '巴西',
    BG: '保加利亚',
    BI: '布隆迪',
    CM: '喀麦隆',
    CV: '佛得角',
    TD: '乍得',
    CN: '中国',
    KM: '科摩罗',
    CR: '哥斯达黎加',
    HR: '克罗地亚',
    CY: '塞浦路斯',
    DK: '丹麦',
    DM: '多米尼加',
    TL: '东帝汶',
    EG: '埃及',
    GQ: '赤道几内亚',
    EE: '爱沙尼亚',
    FJ: '斐济',
    FR: '法国',
    GA: '加蓬',
    GE: '格鲁吉亚',
    GH: '加纳',
    GR: '希腊',
    GD: '格林纳达',
    GT: '危地马拉',
    GW: '几内亚比绍',
    HT: '海地',
    HK: '中国香港',
    IS: '冰岛',
    ID: '印度尼西亚',
    IQ: '伊拉克',
    IL: '以色列',
    JM: '牙买加',
    JO: '约旦',
    KE: '肯尼亚',
    KP: ',韩国',
    KW: '科威特',
    LA: '老挝',
    LB: '黎巴嫩',
    LR: '利比里亚',
    LI: '列支敦士登',
    LU: '卢森堡',
    MK: '马其顿',
    MW: '马拉维',
    MV: '马尔代夫',
    MT: '马耳他',
    MQ: '马提尼克',
    MU: '毛里求斯',
    FM: '密克罗尼西亚',
    MC: '摩纳哥',
    ME: '黑山',
    MZ: '莫桑比克',
    NA: '纳米比亚',
    NP: '尼泊尔',
    NC: '新喀里多尼亚',
    NI: '尼加拉瓜',
    NG: '尼日利亚',
    NO: '挪威',
    PK: '巴基斯坦',
    PS: '巴勒斯坦地区',
    PG: '巴布亚新几内亚',
    PE: '秘鲁',
    PL: '波兰',
    PR: '波多黎各',
    RE: '留尼汪',
    RU: '俄罗斯',
    KN: '圣基茨和尼维斯联邦',
    WS: '萨摩亚',
    ST: '圣多美和普林西比',
    SN: '塞内加尔',
    SC: '塞舌尔',
    SG: '新加坡',
    SI: '斯洛文尼亚',
    SO: '索马里',
    ES: '西班牙',
    VC: '圣文森特',
    SR: '苏里南',
    SE: '瑞典',
    SY: '叙利亚',
    TJ: '塔吉克斯坦',
    TH: '泰国',
    TO: '汤加',
    TN: '突尼斯',
    TM: '土库曼斯坦',
    UG: '乌干达',
    AE: '阿联酋',
    US: '美国',
    UZ: '乌兹别克斯坦',
    VA: '梵蒂冈',
    VN: '越南',
    VI: ',美属维京群岛',
    YE: '也门',
    ZW: '津巴布韦',
    EU: '欧洲',
    INT: '国际',
    CW: '库拉索',
    AFC: '亚足联',
    CONCACAF: '中北美洲及加勒比足联',
    'GB-ENG': '英格兰',
    'GB-WLS': '威尔士',
    'GB-SCT': '苏格兰',
    LATAM: '南美',
    CAF: '非足联',
    XK: '科索沃',
    AI: '安圭拉',
    AN: '荷属安的列斯群岛',
    AS: '美属萨摩亚',
    AW: '阿鲁巴',
    BM: '百慕大',
    BQ: '博内尔岛、SE和萨巴岛',
    CK: '库克群岛',
    FO: '法罗群岛',
    GF: '圭亚那',
    GG: '格恩西岛辖区',
    GU: '关岛的领土',
    IM: '马恩岛',
    JE: '泽西辖区',
    KY: '开曼群岛',
    MF: '圣马丁集体',
    MS: '蒙特塞拉特',
    NU: '纽埃',
    OC: '大洋洲',
    RI: '印度尼西亚',
    SS: '南苏丹共和国',
    TC: '特克斯和凯科斯群岛',
    YT: '马约特省',
    SX: '荷屬聖馬丁'
  },
  loadingMessages: {
    players: '准备球员中',
    teams: '排序球队中',
    games: '获取比赛中',
    stats: '计算指标中',
    graphs: '绘图中',
    gettingReady: '热身',
    placeholder: '准备'
  },
  requestReport: {
    subtitle: '得到一份你所需要的深度报告',
    categories: {
      scouting: {
        title: 'Scouting 侦察',
        subtitle: '谁是某个联盟中最好的球员?几个联赛加起来呢?要求一份带有任何你想要的过滤器(年龄，身高，合同结束等)的量身定制的报告，找出最适合的球员'
      },
      coaches: {
        title: '教练',
        subtitle: '教练如何融入你的团队体系?获得详细的信息，或者给定一个特定的筛选，了解哪个教练最适合'
      },
      'team analysis': {
        title: '球队',
        subtitle: '指定一支球队，并获得赛季总结，其中包括对球队风格、防守和进攻表现、弱点、最佳球员等有价值的见解。'
      },
      'game analysis': {
        title: '比赛分析',
        subtitle: 'Given a match, get a deep pre-game and post-game analysis with detailed information Given a match, get a deep pre-game and post-game analysis with detailed information'
      },
      'special projects': {
        title: '特别项目',
        subtitle: '一名球员在客场比赛中的表现如何?球员在不同的联赛中是如何变化的?哪些球员可以被租借?问任何你能想到的问题'
      },
      conversation: {
        title: '对话',
        subtitle: '与我们的团队开始对话'
      }
    },
    notesPlaceholder: '让我们知道你想了解更多的联赛、个人资料、数据、教练、球队或比赛',
    chooseType: '选择报告类型',
    requestSummary: '请求汇总',
    reportType: '报告类型',
    reportLanguage: '报告语言',
    detailTitle: '报告后续行动',
    detailSubtitle: '您所要求的报告的所有信息'
  },
  bugReport: {
    modalSubtitle: '帮助我们进步',
    about: '关于',
    sendSuccess: '通知成功，在收件箱查看更新',
    bugs: '错误'
  },
  gbe: {
    autopass: '自动过滤',
    bandX: '组别{0}',
    bandXCont: '组别{0}洲际赛事',
    points: '积分',
    titleWinner: '联赛冠军',
    qualifiedGroupsBandX: '',
    qualifiedQualifiersBandX: '',
    midTable: '联赛中游',
    relegation: '降级',
    promotion: '升级',
    final: '决赛',
    semifinal: '半决赛',
    quarterfinal: '1/4决赛',
    round16: '1/8决赛',
    round32: '1/16决赛',
    groupstage: '小组赛',
    firstRound: '第一轮',
    secondRound: '第二轮',
    thirdRound: '第三轮',
    fourthRound: '第四轮',
    preliminaryRound: '预选赛',
    other: '其他',
    score: '得分',
    totalSummary: '汇总',
    currentlyPlayingInUK: '球员是英国或爱尔兰公民，或英国永久居民',
    bandsAlert: '有在超过一个组别的出场时间，总值为最大值',
    bandsAlertMax: '有在超过一个组别的出场时间，总值为最大值',
    bandsAlertAvg: '有在超过一个组别的出场时间，总值为平均值',
    generate: '应用表单',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: '\'球员国际赛事表现',
      title1: '球员国家累计世界排名',
      title2: '\'球员国际赛事表现'
    },
    table2: {
      name: '球员国内赛事出场时间',
      title1: '球员国内赛事出场时间'
    },
    table3: {
      name: '球员洲际赛事出场时间',
      title1: '球员洲际赛事出场时间'
    },
    table4: {
      name: '球员上一俱乐部最终联赛排名',
      title1: '上一俱乐部最终联赛排名'
    },
    table5: {
      name: '球员上一俱乐部洲际赛事表现',
      title1: '洲际赛事表现'
    },
    table6: {
      name: '球员当前俱乐部联赛质量',
      title1: '球员当前俱乐部级别'
    },
    table7: {
      name: '青年队首秀',
      title1: '级别'
    },
    table8: {
      name: '青年队最终联赛排名',
      title1: '上一俱乐部最终联赛排名'
    },
    table9: {
      name: '青年队洲际赛事表现',
      title1: '洲际赛事表现'
    },
    table10: {
      name: '青年队球员当前联赛质量',
      title1: '球员当前俱乐部组别'
    },
    table11: {
      name: '青年队球员当前联赛质量',
      title1: '球员当前俱乐部组别'
    },
    table12: {
      name: '青年队国际赛事表现',
      title1: '\'球员国际赛事表现'
    }
  },
  mediaMode: {
    borderColor: '边框颜色',
    fillColor: '填充颜色',
    bgColor: '背景颜色',
    upperText: '上方文字',
    lowerText: '下方文字',
    socialMedia: '社交媒体',
    textColor: '文本颜色',
    axisColor: '坐标轴颜色',
    logo: '图标',
    comparisonBorderColor: '比较边框颜色',
    comparisonFillColor: '比较填充颜色',
    comparisonUpperText: '比较上方文字',
    comparisonLowerText: '比较下方文字',
    homeFillColor: '主队填充颜色',
    homeBorderColor: '主队边框颜色',
    awayFillColor: '客队填充颜色',
    awayBorderColor: '客队边框颜色',
    face: '面',
    nationalTeam: '国家队',
    comparisonFace: '比较面',
    upperTextX: '上方文字{0}',
    lowerTextX: '下方文字{0}',
    borderColorX: '边框颜色{0}',
    fillColorX: '填充颜色{0}',
    homeFillColorX: '填充颜色(主场){0}',
    homeBorderColorX: '边框颜色(主场){0}',
    awayFillColorX: '填充颜色(客场){0}',
    awayBorderColorX: '边框颜色(客场){0}',
    faceX: '面{0}',
    selectField: '选择一项',
    orientationX: '方向{0}',
    searchBarPlaceholder: '搜素球员和/或比赛',
    title: '媒体看板',
    pageSubtitle: '浏览和下载地图和图形',
    chooseChart: '选择表格...',
    headerTextX: '头栏文字{0}',
    avatarLineLength: '头像行长度',
    avatarLineWeight: '头像行粗细',
    avatarSize: '头像大小',
    chartX: '表格{0}',
    chartHeaderFontSize: '表头字体大小',
    chartHeaderFontWeight: '表头字体粗细',
    upperTextFontSize: '上方文字字体大小',
    upperTextFontWeight: '上方文字字体粗细',
    lowerTextFontSize: '下方文字字体大小',
    lowerTextFontWeight: '下方文字字体粗细',
    socialMediaFontSize: '社交媒体字体大小',
    socialMediaFontWeight: '社交媒体字体粗细',
    subtitle: '子标题',
    subtitleFontSize: '子标题字体大小',
    subtitleFontWeight: '子标题字体粗细',
    subtitleX: '子标题{0}',
    subtitleFontSizeX: '子标题{0}字体大小',
    subtitleFontWeightX: '子标题{0}字体粗细',
    titleX: '标题{0}',
    titleFontSize: '标题字体大小',
    titleFontWeight: '标题字体粗细',
    sponsor: '赞助商',
    fontFamily: 'Font family'
  },
  documents: {
    types: {
      SCOUTING_REPORT: '球探报告',
      GAME_REPORT: '比赛报告',
      MEDICAL_REPORT: '医学报告',
      PHYSICAL_REPORT: '身体报告',
      PSYCHOLOGICAL_REPORT: '心理报告',
      OTHER: '其他',
      QUICK_NOTES: '快速笔记',
      PLAYER_REPORT: '球员报告',
      GENERAL_COMMENTS: '一般评论',
      PLAYER_ANALYSIS: '球员分析'
    },
    uploadDocument: '上传文件',
    notesPlaceholder: '键入与文档相关的描述性注释或注释',
    notesPlaceholderAlt: '输入与玩家相关的描述性注释或评论',
    uploadedBy: '上传者',
    updatedBy: '更新者',
    seeNotes: '查看笔记',
    addNote: '添加笔记',
    rating: '评级',
    position: '最佳位置',
    physical: '身体状况',
    onBall: '攻球时',
    offBall: '球外',
    mental: '精神方面',
    potential: '潜力',
    conclusion: '总结',
    recommendation: {
      1: '签约',
      2: '监控',
      3: '放弃',
      4: '有趣',
      label: '推荐'
    },
    match: '比赛',
    deleteQuickNote: '删除便签',
    deleteQuickNoteMessage: '便签将被永久删除。您确定吗？',
    noQuickNotes: '没有数据。开始添加一些笔记吧！',
    deleteDocument: '删除文件',
    deleteDocumentMessage: '文件将被永久删除。您确定吗？',
    noDocuments: '没有数据。开始添加一些文件吧！'
  },
  notifications: {
    newReportMessage: '报告中有新消息'
  },
  blog: {
    subtitle: '最新文章、更新和新闻',
    newEntry: '新建项',
    title: '标题',
    text: '文本',
    link: '链接',
    image: '图像',
    author: '作者',
    date: '释出日期',
    deleteEntry: '删除',
    deleteEntryMessage: '确定删除该项',
    readMore: '阅读更多'
  },
  positionsOrlegi: {
    GK: '守门员',
    DC: '后卫',
    DR: '边后卫',
    MC: '中场',
    AMC: '前腰',
    FW: '前锋',
    FWR: '边锋'
  },
  library: {
    subtitle: '查看和共享更新上传的文件',
    mediaSubtitle: '查看和共享导出的图表',
    charts: '表格',
    goToLibrary: '去图书馆'
  },
  scatterPlot: {
    bubbleSize: '散点大小',
    byMinutes: '按照出场时间',
    byAge: '按照年龄',
    byMarketValue: '按照身价'
  },
  eventChart: {
    successfulEvent: '成功的',
    unsuccessfulEvent: '不成功',
    possessionLost: '成功未恢复',
    successfulPass: '成功传球',
    unsuccessfulPass: '失败传球',
    successfulCarry: '成功带球',
    unsuccessfulCarry: '失败带球',
    carryAndKeyPass: '带球且关键传球',
    carryAndAssist: '带球且助攻',
    carryAndShot: '带球且射门',
    ballProgressionAndPass: '推进且传球',
    ballProgression: '推进',
    ballProgressionAndKeyPass: '推进且关键传球',
    ballProgressionAndAssist: '推进且助攻',
    ballProgressionAndShot: '推进且射门',
    ballProgressionAndGoal: '推进且进球',
    pass: '传球',
    carryAndPass: '带球且传球',
    carryAndGoal: '带球且进球',
    totalTouches: '总触球',
    totalPasses: '总传球',
    successful: '成功',
    unsuccessful: '失败',
    tacklePossessionLost: '成功 - 控球权丢失',
    gamesSelected: '{count} 场比赛已选',
    allGamesOfSeason: '赛季全部比赛',
    allGamesOfSeasons: '各赛季全部比赛',
    allEvents: '所有事件',
    eventTypesCount: '{count} 种事件类型',
    totalEvents: '活动总数'
  },
  event: {
    Pass: '传球',
    TakeOn: '一对一',
    Takeon: '运球',
    Foul: '失败',
    Error: '錯誤',
    Tackle: '抢断',
    Interception: '拦截',
    Clearance: '解围',
    MissedShot: '射偏',
    ShotOnPost: '中柱',
    SavedShot: '被扑救',
    Goal: '进球',
    Aerial: '争顶',
    BallRecovery: '夺回球权',
    Dispossessed: '丢失球权',
    ChanceMissed: '错失机会',
    BallTouch: '触球',
    BlockedPass: '传球被阻挡',
    Challenge: '上抢',
    lossPossession: '丢失球权',
    OffsidePass: '越位传球',
    groundDuelsLost: '地面对抗失败',
    'Ball touch': '触球',
    Smother: '封堵',
    'Keeper pickup': '将球抱起',
    'Good skill': '盘带成功',
    Punch: '击球',
    'Saved shot': '被扑救',
    'Shot on post': '中柱',
    'Missed shot': '射偏',
    Save: '扑救',
    'Take on': '1对1',
    'Offside pass': '传球越位',
    Claim: '出击',
    'Blocked pass': '阻挡传球',
    KeeperPickup: '守护者皮卡',
    'Ball recovery': '夺回球权',
    'Ball Recovery': '夺回球权',
    'Chance missed': '错失机会',
    'Loss possession': '丢失球权',
    Carries: '带球',
    BallProgression: '推进',
    MissedChance: '错失良机',
    Event: '事件',
    Shot: '射门',
    Assist: '助攻',
    KeyPass: '关键传球',
    'Foul taken': '收到犯规'
  },
  leagueTab: {
    leagueTable: '联赛积分榜',
    matchdays: '比赛日',
    playerInsights: '球员分析',
    onlyLocalPlayers: '仅限本地玩家',
    teamInsights: '球队分析',
    head2head: '交锋历史',
    addNewChart: '添加新图表',
    rounds: {
      16: '1/8决赛',
      32: '1/16决赛',
      W: '胜者',
      F: '决赛',
      SF: '半决赛',
      QF: '1/4决赛',
      GR: '小组赛',
      '4R': '第四轮',
      '3R': '第三轮',
      '2R': '第二轮',
      '1R': '第一轮',
      PR: '预选赛',
      QPO1: '32进入强',
      QPO2: '16强资格赛',
      QPO3: '预选赛 32 强'
    },
    positions: '位置',
    prediction: '预测',
    predicted: '预测',
    groups: '小组',
    ranking: '排名',
    numberOfTeams: '球队数量',
    statsWithMinimum: {
      message: '仅显示在所选赛季中超过 {0} 次{1}的球员',
      dribblesTotal90: '每90分钟过人次数',
      crosses90: '每90分钟传中次数',
      tacklesAttempted90: '每90分钟抢断尝试次数',
      aerialsTotal90: '每90分钟争顶次数'
    },
    numberOfLeagues: '联赛数量',
    position: {
      titleWinner: '冠军得主',
      championsLeague: '冠军联赛',
      qualifierChampionsLeague: '冠军联赛预选赛',
      europeLeague: '欧洲联赛',
      qualifierEuropeLeague: '欧洲联赛预选赛',
      conferenceLeague: '会议联盟',
      qualifierConferenceLeague: '预选赛 联赛',
      midTable: '中游',
      relegation: '降级',
      promotion: '晋升',
      relegationPlayoff: '保级附加赛',
      promotionPlayoff: '晋级附加赛',
      championshipGroup: '冠军组',
      relegationGroup: '保级组',
      championshipPlayoffs: '冠军季后赛',
      preChampionshipPlayoffs2: '冠军赛前季后赛 2',
      preChampionshipPlayoffs3: '冠军赛前季后赛 3',
      playoffsQualifierBand3: '季后赛预选赛第 3 组',
      continentalGroup: '大陆集团'
    },
    group: {
      1: '一个',
      2: '乙',
      3: 'C',
      4: 'D',
      5: '乙',
      6: 'F',
      7: 'G',
      8: 'H',
      9: '我',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: '寻找相似球员',
    searchBarPlaceholder: '搜索并选中一名待寻找相似的球员',
    radarFilters: '雷达筛选',
    similarityFilters: '相似度筛选',
    playersFilters: '球员筛选',
    similarPlayers: '相似球员',
    seasonWarning: 'Similarity 工具中只显示出场时间超过 450 分钟的可用赛季'
  },
  squadBuilder: {
    subtitle: '选出你的11人',
    playerSelector: '球员选择器',
    loadSquad: '加载阵容',
    yearsOld: '年龄',
    playersPerPosition: '通过位置筛选球员',
    custom: '自定义',
    removeSquad: '删除战队',
    removeSquadMessage: '您确定要删除小队吗?',
    deleteSquadSuccess: '小队已成功删除',
    playerDetails: '详情可见性',
    ageFormat: '年龄格式',
    mainPlayer: '主要球员',
    showDetails: '显示详情',
    all: '全部',
    squadPosition: '阵容位置',
    noData: '没有数据。请先在场上添加一些球员！'
  },
  tours: {
    buttons: {
      dontShowAgain: '不要再出现',
      skipTour: '跳过导游',
      previous: '上一页',
      next: '下一页',
      finish: '完成'
    },
    playerRadar: {
      step1: {
        title: '个人档案',
        message: '检查球员基本数据：年龄、身高或签约日期'
      },
      step2: {
        title: 'GBE 过滤器',
        message: '了解球员是否有足够的 GBE 积分在英国比赛的功能'
      },
      step3: {
        title: '可用性',
        message: '可用分钟数百分比和出场分钟数百分比'
      },
      step4: {
        title: '职位',
        message: '了解球员踢过哪些位置以及每个位置的上场时间'
      },
      step5: {
        title: '显示格式',
        message: '使用雷达、极地、棒棒糖和文本 4 种不同的可视化方式衡量表现，与同位置的球员进行比较'
      },
      step6: {
        title: '性能雷达',
        message: '在这里，性能可以直观地反映出来。面板是交互式的，您可以将鼠标悬停在每个指标上，了解其定义'
      },
      step7: {
        title: '赛季选择',
        message: '选择或添加季节以衡量您的绩效'
      },
      step8: {
        title: '自定义模板选择',
        message: '使用您创建的自定义模板，用不同于标准雷达的指标来测量播放器'
      },
      step9: {
        title: '职位选择',
        message: '选中或取消选中不同的位置，以您想要的位置测量他'
      },
      step10: {
        title: '选择最小值和最大值',
        message: '根据球员本赛季、五大联赛或用户账户自身赛季和默认赛季的高低来衡量球员的表现'
      },
      step11: {
        title: '比较',
        message: '将球员与其之前的表现进行比较，与同位置的其他球员进行比较，与该位置的平均水平进行比较'
      },
      step12: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      }
    },
    playerRanking: {
      step1: {
        title: '赛季、阵容和位置',
        message: '选择与球员进行比较的赛季、阵容和位置'
      },
      step2: {
        title: '基本过滤器',
        message: '按年龄、出场时间或身高筛选球员'
      },
      step3: {
        title: '突出和排除',
        message: '高亮显示你想要的球员，并在显示中排除球队'
      },
      step4: {
        title: '按类别筛选',
        message: '按类别筛选统计数据: 结盟、防守、传球、控球等'
      },
      step5: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      }
    },
    playerFinishing: {
      step1: {
        title: '选择显示屏',
        message: '您可以在主视图、目标视图和分布表中查看整理图'
      },
      step2: {
        title: '选择季节',
        message: '添加季节来衡量您的投篮效率'
      },
      step3: {
        title: '拍摄地点',
        message: '选择查看射门准确位置（圆圈）的可能性，或按禁区和球场区域（区域）查看的可能性'
      },
      step4: {
        title: 'xG 在目标上',
        message: '选中 xG to Goal(xG 进球）和 xG Completion(xG 完成）复选框，查看球员射门后的附加值'
      },
      step5: {
        title: '射击类型',
        message: '根据拍摄类型、策略、区域或身体部位进行筛选'
      },
      step6: {
        title: '过滤分钟',
        message: '分钟栏可选择特定比赛时段的射门次数和进球数'
      },
      step7: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step8: {
        title: '射击地图',
        message: '地图是互动的。用鼠标选中每个圆圈，查看每次击球的 xG'
      }
    },
    playerKeyPass: {
      step1: {
        title: '赛季选择',
        message: '添加季节来衡量您的投篮效率'
      },
      step2: {
        title: '钥匙通行位置',
        message: '选择查看关键通道确切位置（圆圈）或按区域和领域（领域）查看的可能性'
      },
      step3: {
        title: '关键工序后的加工类型',
        message: '根据关键传球后的射门类型、策略、区域或身体部位进行筛选'
      },
      step4: {
        title: '过滤分钟',
        message: '分钟栏可选择特定比赛时段的射门次数和进球数'
      },
      step5: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step6: {
        title: '关键通道图',
        message: '地图是交互式的。用鼠标查看每个圆圈，了解每个通道的 xA'
      }
    },
    playerThreat: {
      step1: {
        title: '赛季选择',
        message: '添加季节来衡量您的投篮效率'
      },
      step2: {
        title: '威胁位置',
        message: '选择查看关键通道确切位置（圆圈）或按区域和实地区域（区域）查看的可能性'
      },
      step3: {
        title: '行动和完成',
        message: '根据要在地图上显示的操作和完成类型，选中或取消选中'
      },
      step4: {
        title: '分钟和威胁',
        message: '按时间、分钟和行动威胁值进行筛选'
      },
      step5: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step6: {
        title: '威胁地图',
        message: '地图是互动的。用鼠标点击每个圆圈，即可了解每次传球的每次 xT 打法所产生的威胁'
      }
    },
    playerTouches: {
      step1: {
        title: '游戏和活动选择',
        message: '选择要在地图上显示的游戏和事件'
      },
      step2: {
        title: '活动类型',
        message: '根据球员在整场比赛中的防守或进攻性质进行选中或取消选中'
      },
      step3: {
        title: '显示滤波器',
        message: '通过基本操作、热图、圆圈或方框筛选地图'
      },
      step4: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step5: {
        title: '触摸地图',
        message: '地图是互动的。您可以通过点击每个事件来查看每个事件'
      }
    },
    playerAllGames: {
      step1: {
        title: '可用性',
        message: '逐场检查可用性和出场时间'
      },
      step2: {
        title: '职位',
        message: '查看他在每场比赛中的位置'
      }
    },
    playerInjuries: {
      step1: {
        title: '历史与逝去的日子',
        message: '根据受伤持续时间（天数）咨询去年或整个历史上的受伤情况和受伤范围'
      },
      step2: {
        title: '俱乐部受伤情况',
        message: '按赛季和/或俱乐部查看他的受伤轨迹'
      }
    },
    playerInfo: {
      step1: {
        title: '职业和转学',
        message: '您可以查看球员在俱乐部、国家队的出场时间、位置或出场情况，以及球员在整个职业生涯中的转会情况'
      }
    },
    teamOverview: {
      step1: {
        title: '团队表',
        message: '查询球队的基本数据: 平均年龄、基本阵型、ELO 或转会余额'
      },
      step2: {
        title: '基本统计',
        message: '咨询控球率、xG、射门次数、PPDA 或垂直度'
      },
      step3: {
        title: '雷达和季节',
        message: '选择雷达、赛季、主场或客场比赛来衡量球队的表现'
      },
      step4: {
        title: '按教练和比赛筛选',
        message: '为每辆教练车按阶段选择性能'
      },
      step5: {
        title: '性能雷达',
        message: '面板是交互式的，您可以将鼠标悬停在每个指标上，了解其定义'
      },
      step6: {
        title: '图像下载格式',
        message: '提供两种下载格式: png 和 svg'
      },
      step7: {
        title: '日历',
        message: '查看球队赛程'
      },
      step8: {
        title: '最佳球员',
        message: '在该面板中，您可以选择不同的指标，查看哪些球员最重要'
      },
      step9: {
        title: '下一场比赛和伤病情况',
        message: '查看下一个对手以及球队伤停球员情况'
      },
      step10: {
        title: '图表和趋势',
        message: '查看最近 10 或 20 场比赛的不同图表'
      }
    },
    teamRoster: {
      step1: {
        title: '视图类型',
        message: '从 6 个不同类别查看阵容：按位置、合同期满、年龄、可用性、年龄概况和球场'
      }
    },
    teamLoans: {
      step1: {
        title: '贷款参与者',
        message: '咨询租借到其他球队的球员及其所踢的位置'
      }
    },
    teamBeeswarm: {
      step1: {
        title: '赛季和阵容',
        message: '按赛季、雷达阵容筛选，并与您选择的联赛进行比较'
      },
      step2: {
        title: '指标绩效',
        message: '查看球队在各项指标上与之前所选联赛中所有球队的比较情况'
      },
      step3: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: '赛季选择',
        message: '增加测量投篮效率的季节'
      },
      step2: {
        title: '自己或对手的整理',
        message: '选择查看本队还是所有对手的完成图'
      },
      step3: {
        title: '射击位置',
        message: '选择查看球队射门的方式，按圆圈或按区域（方框）查看'
      },
      step4: {
        title: '射击类型',
        message: '根据拍摄类型、策略、区域或身体部位进行筛选'
      },
      step5: {
        title: '过滤分钟',
        message: '分钟栏可选择特定比赛时段的射门次数和进球数'
      },
      step6: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step7: {
        title: '射击地图',
        message: '地图是互动的。用鼠标选中每个圆圈，查看每次击球的 xG'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: '赛季选择',
        message: '增加测量投篮效率的季节'
      },
      step2: {
        title: '自己或对手的关键通行证',
        message: '选择要查看球队的关键传球图还是所有对手的传球图'
      },
      step3: {
        title: '钥匙通行位置',
        message: '选择要查看密钥传递的确切位置（圆圈）还是按区域和字段（方框）查看'
      },
      step4: {
        title: '通过后的饰面类型',
        message: '根据关键传球后的射门类型、策略、区域或身体部位进行筛选'
      },
      step5: {
        title: '过滤分钟',
        message: '分钟栏可选择特定比赛时段的射门次数和进球数'
      },
      step6: {
        title: '图像下载格式',
        message: '提供三种下载格式: png、svg 和 embed'
      },
      step7: {
        title: '射击地图',
        message: '地图是互动的。用鼠标查看每个圆圈，了解每次通过的 xA'
      }
    },
    teamLatestGames: {
      step1: {
        title: '最新游戏',
        message: '查询球队所有比赛的成绩、控球率、xG 和胜率'
      }
    },
    teamTransfers: {
      step1: {
        title: '到着',
        message: '暦年の全入荷（購入＋移籍）について相談する'
      },
      step2: {
        title: '出発',
        message: 'すべての出国者（販売＋移籍）を暦年で参照する'
      }
    },
    teamAnalysis: {
      step1: {
        title: '趋势',
        message: '通过连胜、获胜、净胜球、逆转、进球时段或进球类型查询球队状态'
      },
      step2: {
        title: '定位球',
        message: '比較球隊在定位球比賽和公開比賽中的表現，並獲得定位球的詳細概述'
      },
      step3: {
        title: '替代品',
        message: '查看球队何时换人以及哪些球员被换下的次数最多'
      },
      step4: {
        title: '连接',
        message: '查询球员之间最常见的联系。按赛季和比赛类型筛选'
      },
      step5: {
        title: '攻击区',
        message: '发现球队的进攻区域，并按赛季或进攻类型进行筛选'
      },
      step6: {
        title: '培训',
        message: '查看最常用的阵型及其胜率、平局率和负率'
      },
      step7: {
        title: '射击区',
        message: '按赛季、球队或对手、地图可视化方式、射门类型或分钟数进行筛选'
      },
      step8: {
        title: '十字路口',
        message: '按赛季、展示类型、成功或失败、开始和结束位置或包括角球进行查询和筛选'
      },
      step9: {
        title: '球员',
        message: '按赛季、展示类型、成功或失败、开始和结束位置或包括角球进行筛选'
      }
    },
    teamOnOff: {
      step1: {
        title: '赛季和比赛',
        message: '按赛季、比赛或主客场筛选'
      },
      step2: {
        title: '球员',
        message: '通过无数指标查看队内所有球员的表现'
      }
    }
  },
  alerts: {
    numPlayers: '球员数',
    newPlayersLastWeek: '上周新球员',
    subtitle: '提示有新球员符合搜索',
    generalSubtitle: '根据您的标准接收新球员的提醒以及您最喜爱球员的新闻',
    subtitlePlayer: '当我们有您最喜欢的球员的新闻时获取提醒',
    subtitleSearch: '当新球员符合您的搜索标准时获取提醒',
    favorite: '最爱',
    newEventCalendar: '新活动',
    updatedEventCalendar: '更新活动',
    newShareFrom: '新分享来自',
    injuryAlert: '伤病提醒',
    contractAlert: '合同提醒',
    teamAlert: '签约提醒',
    marketValueAlert: '市场价值提醒',
    gameAlert: '比赛提醒'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Full game',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Search player, game or team...',
    subtitle: 'Analyze events through video',
    successful: 'Success',
    unsuccessful: 'Fail',
    playing: 'Playing',
    games: 'Games',
    moreFilters: 'More filters...',
    startArea: 'Start area',
    endArea: 'End area',
    select: 'Select',
    selectLastXGames: 'Select last {0} games',
    advancedFilters: 'Advanced Filters',
    freeKicks: 'Free Kicks',
    cornerKicks: 'Corner Kicks',
    allShots: 'All Shots',
    generateZip: 'Generate ZIP',
    zippedModalMessage: 'ZIP process has been started, could take some minutes. You would receive an email when is finished',
    clickToSeeVideo: 'Click to see video'
  },
  videoUpload: {
    subtitle: 'Upload video and create new game',
    uploadVideo: 'Upload video',
    selectPeriod: 'Select period',
    gameData: 'Game Data',
    venue: 'Venue',
    matchType: 'Match type',
    matchGroup: 'Match group',
    roundType: 'Round type',
    roundNumber: 'Round number',
    offsetFh: 'Offset First Half',
    offsetSh: 'Offset Second Half',
    offsetFhOT: 'Offset Overtime First Half',
    offsetShOT: 'Offset Overtime Second Half',
    homeLineup: 'Home Lineup',
    awayLineup: 'Away Lineup',
    existingPlayer: 'Existing player',
    newPlayer: 'New player',
    startingTeam: 'Starting',
    saveAndUpload: 'Save and upload',
    existingGame: 'Game exists already',
    sendToKora: 'Send',
    invalidForm: 'Invalid form',
    warningModalTitle: 'Anomalies have been detected',
    noScoreSheetWarning: 'No scoresheet attached',
    onlyOnePartUploadedWarning: 'Only one half time attached',
    continueQuestion: 'continue?',
    slaLimit: '您已使用 {1} 上传了 {0} 个游戏。您的限制是 {2}',
    requestedGames: '请求的比赛',
    limitClose: '仅剩 {0} 场比赛可请求',
    limitReached: '您已达到视频上传限制。上传额外比赛可能会产生额外费用。',
    seasonFinishedWarning: '这将在一个已经结束的赛季中创建一场比赛。请检查这是否正确。',
    teamCountryWarning: '该球队来自与所选联赛不同的国家。请检查这是否正确。',
    uploading: '上传中',
    doNotNavigateAway: '上传过程中请勿关闭此选项卡、刷新页面或离开。',
    severalMinutes: '此过程可能需要几分钟。'
  },
  videoPlaylists: {
    subtitle: 'Collections of video highlights filters',
    savePlaylist: 'Save Playlist',
    seeAllPlaylists: '查看所有列表'
  },
  videoHighlights: {
    recap: '回顾',
    homeCondensed: '家庭浓缩游戏',
    awayCondensed: '客场压缩比赛',
    selectedActions: '已选择的动作',
    noActions: '没有符合指定筛选条件的动作',
    noGames: '尚未上传比赛',
    attackingActions: '进攻动作',
    defensiveActions: '防守动作',
    groundDuels: '地面对抗',
    penaltiesProvoked: '诱发的点球',
    goalkeeperActions: '守门员动作',
    addSomeGames: '开始添加一些比赛！',
    goToVideoUploadTool: '前往上传视频',
    ballInPlay: '比赛中',
    filterSeasons: '筛选赛季',
    streaming: '直播',
    clips: '剪辑',
    qualifiers: {
      Pass: '传球',
      Save: '扑救',
      'Saved Shot': '被扑出的射门',
      Shot: '射门',
      Goal: '进球',
      'Missed Shot': '射门偏出',
      'Shot on Post': '射中门柱',
      Error: '失误',
      Clearance: '解围',
      Aerial: '空中对抗',
      Challenge: '对抗失败',
      Dispossessed: '丢失球权',
      Foul: '犯规',
      Card: '牌',
      'Offside Pass': '越位传球',
      Claim: '摘球',
      'Keeper Pickup': '门将接球',
      'Ball Touch': '触球',
      Dribble: '盘带',
      Interception: '拦截',
      Tackle: '铲球',
      'Ball Recovery': '球权恢复',
      Takeon: '盘带'
    },
    qualifierIds: {
      1: '长传',
      2: '传中',
      5: '直接任意球',
      6: '角球',
      9: '点球',
      15: '头球',
      20: '右脚',
      21: '身体其他部位',
      22: '开放性进攻',
      23: '反击',
      24: '定位球',
      25: '来自角球',
      26: '任意球',
      28: '乌龙球',
      29: '助攻',
      31: '黄牌',
      32: '第二张黄牌',
      33: '红牌',
      72: '左脚',
      73: '左边',
      82: '被扑出的射门（无门将）',
      94: '防守封堵',
      123: '守门员抛球',
      124: '球门球',
      160: '界外球',
      170: '导致进球',
      173: '安全解围',
      174: '危险解围',
      177: '接球',
      178: '站立',
      179: '扑倒',
      182: '手部',
      183: '脚部',
      185: '封堵传中',
      210: '助攻',
      215: '个人表现',
      279: '开球',
      285: '防守',
      286: '进攻'
    },
    areas: {
      goalArea: '小禁区',
      boxLeft: '禁区左侧',
      boxCenter: '禁区中央',
      boxRight: '禁区右侧',
      outBoxDeepLeft: '禁区外左侧深处',
      outBoxDeepRight: '禁区外右侧深处',
      outBoxLeft: '禁区外左侧',
      outBoxCentreLeft: '禁区外中左侧',
      outBoxCentre: '禁区外中央',
      outBoxCentreRight: '禁区外中右侧',
      outBoxRight: '禁区外右侧',
      midfieldLeft35: '中场左侧',
      midfieldCentreLeft35: '中场中左侧',
      midfieldCentre35: '中场中央',
      midfieldCentreRight35: '中场中右侧',
      midfieldRight35: '中场右侧',
      ownGoalArea: '本方小禁区',
      ownBoxLeft: '本方禁区左侧',
      ownBoxCenter: '本方禁区中央',
      ownBoxRight: '本方禁区右侧',
      ownFieldOutOfBoxDeepLeft: '本方场地禁区外左侧深处',
      ownFieldOutOfBoxDeepRight: '本方场地禁区外右侧深处',
      ownFieldOutOfBoxLeft: '本方场地禁区外左侧',
      ownFieldOutOfBoxCentreLeft: '本方场地禁区外中左侧',
      ownFieldOutOfBoxCentre: '本方场地禁区外中央',
      ownFieldOutOfBoxCentreRight: '本方场地禁区外中右侧',
      ownFieldOutOfBoxRight: '本方场地禁区外右侧',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: '成功',
      fail: '失败',
      possessionWon: '赢得球权',
      possessionNotWon: '未赢得球权',
      received: '接收',
      provoked: '造成'
    },
    homePlayerHighlights: '主队球员亮点',
    awayPlayerHighlights: '客场球员亮点'
  },
  share: {
    shareTo: 'Send to',
    viaApp: 'App (Driblab Message)',
    viaEmail: 'Email',
    description: 'Description',
    titleTab: 'Shares',
    toMe: '已收到',
    fromMe: '已发送',
    typeInternal: 'Internal',
    typeExternal: 'External',
    title: '共享的',
    subtitle: '您分享列表中的项目概览',
    selectUser: '选择用户',
    expired: '过期',
    limitReached: '链接已达到使用限制'
  },
  homeStats: {
    data: '现有数据',
    players: '球员',
    totalPlayers: '球员总数',
    teams: '设备',
    totalTeams: '球队总数',
    leagues: 'l联赛',
    totalLeagues: '联赛总数',
    seasons: '季节',
    totalSeasons: '总赛季数',
    games: '游戏',
    totalGames: '总场次'
  },
  scoutingCalendar: {
    subtitle: '创建并组织您的球探任务',
    myCalendars: '私人日历',
    publicCalendars: '公共日历',
    otherCalendars: '其他日历',
    calendarSettings: '日历设置',
    moreInfo: '更多信息',
    individualScouting: '个人侦察',
    matchScouting: '比赛侦察',
    calendarView: {
      type: '日历类型',
      month: '月',
      week: '周',
      day: '天'
    },
    weekView: {
      type: '周类型',
      monSun: '周一 - 周日',
      sunSat: '周日 - 周六',
      monFri: '周一 - 周五'
    },
    tasks: {
      addNew: '添加新任务',
      myTasks: '我的任务',
      filterTasks: '筛选任务',
      sharedWithMe: '与我共享',
      createTask: '创建任务',
      newTask: '新任务',
      taskName: '任务名称',
      allDay: '全天',
      startDate: '开始日期',
      endDate: '结束日期',
      startHour: '开始时间',
      endHour: '结束时间',
      assignedTo: '分配给',
      assignedToMe: '分配给我',
      color: '颜色',
      scoutingType: '球探类型',
      taskLocation: '任务地点',
      selectLeague: '选择联赛',
      selectMatch: '选择比赛',
      useMatchdate: '使用比赛日期',
      stadium: '体育场',
      travel: '旅行',
      hotel: '酒店',
      tickets: '门票',
      taskNotes: '输入与任务相关的描述性笔记或评论',
      states: {
        toDo: '待办',
        inProgress: '进行中',
        done: '已完成'
      },
      type: {
        player: '球员评估',
        team: '团队评估',
        other: '其他'
      },
      location: {
        stadium: '在体育场',
        video: '视频'
      },
      accommodation: {
        accommodationDetails: '住宿详情',
        ownArrangement: '自行安排',
        required: '需要的',
        notRequired: '不需要的',
        booked: '已预订'
      },
      assignToMe: '分配给我',
      addOther: '添加其他',
      deleteTask: '删除任务',
      deleteTaskMessage: '任务将被移除，您确定吗？',
      cancelUpdate: '取消更新',
      cancelUpdateMessage: '更改将不会被保存，您确定吗？',
      selectGame: '请选择比赛以添加文件',
      noData: '没有数据。先添加一些任务吧！',
      widgetSubtitle: '查看您的下一个任务',
      scoutingDetails: '球探详情',
      taskDetails: '任务详情',
      playerDocuments: '球员文件',
      teamDocuments: '球队文件',
      gameDocuments: '比赛文件',
      taskDocuments: '任务文件',
      task: '任务'
    },
    nextGames: '下一场比赛'
  },
  scoutingTasksBoard: {
    period: {
      week: '本周',
      month: '本月',
      year: '今年'
    },
    noTasks: '创建新任务或将任务拖到这里！',
    goToBoard: '去 board'
  },
  profile: {
    title: '个人资料',
    subtitle: '自定义您的账户和订阅详情'
  },
  hub: {
    onlyHub: '仅适用于 Driblab Hub',
    blue: '蓝色的',
    purple: '紫色的',
    orange: '橙子',
    grey: '灰色的',
    indigo: '靛青',
    teal: '青色',
    lightBlue: '浅蓝色',
    brown: '棕色的'
  },
  uploadedGames: {
    subtitle: 'All uploaded games',
    timeRequested: 'Time it was requested',
    timeReceived: 'When it was received',
    diffHours: 'Difference in hours',
    collectionCompleted: 'Collection completed',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    goToUploadedGames: '前往上传的比赛',
    sla: '服务水平协议',
    matchDate: '比赛日期',
    rejectedGame: '已拒绝',
    reviewed: '已审核',
    requested: '已请求',
    koraStatus: 'Kora 状态',
    aws: 'AWS',
    fullVideo: '完整视频',
    offset: '偏移',
    updateFullVideo: '是否更新完整视频？'
  },
  gameMap: {
    title: '比赛地图',
    subtitle: '探索未来几天的比赛',
    warning: '时间和地点可能不正确。请确认这些信息。',
    taskAdded: '任务成功创建。请查看Scouting Calendar。'
  },
  leagueRequestAccess: {
    sendSuccess: '成功发送通知',
    notPermissions: '您没有查看的权限',
    notPermissionsLeague: '您没有查看这个联赛的权限',
    notPermissionsGame: '您没有查看这场比赛的权限',
    requestAccessTo: '请求访问',
    sendRequest: '发送请求'
  },
  videoTeams: {
    subtitle: '按团队标记的最新比赛',
    noGamesUploaded: '还没有上传比赛'
  },
  scoutingAnalysis: {
    scoutingAnalysis: '侦察分析',
    scoutingAnalyses: '侦察分析',
    playerScoutingAnalyses: '球员侦察分析',
    gameScoutingAnalyses: '比赛侦察分析',
    analyses: '分析',
    addReport: '添加分析',
    technical: '技术',
    tactical: '战术',
    physical: '体能',
    mental: '心理',
    technicalNotes: '技术备注',
    tacticalNotes: '战术备注',
    physicalNotes: '体能备注',
    mentalNotes: '心理档案备注',
    conclusion: '结论',
    charactersMax: '最多1000个字符',
    globalRating: '全球评级',
    noData: '无数据。开始添加一些侦察分析吧！',
    deleteAnalysis: '删除侦察分析',
    deleteAnalysisMessage: '分析将被永久移除。你确定吗？',
    avgTooltip: '基于你能看到的分析的最终评分的平均值',
    avgOverallScoreTooltip: '平均值基于您可见的球员总体评分',
    scouter: '侦察员',
    lastEdited: '最后编辑',
    analysisFilters: '分析过滤器',
    generalFilters: '常规过滤器',
    widgetSubtitle: '最新添加的分析',
    addPlayerReport: '添加球员球探分析',
    seeReports: '查看报告',
    addGameReport: '添加比赛分析',
    keyPlayers: '关键球员',
    formation: '阵型',
    inPossession: '控球时',
    notesIP: '控球时备注',
    outOfPossession: '无球时',
    notesOP: '无球时备注',
    transitions: '攻守转换',
    notesTransitions: '攻守转换备注',
    notesSP: '定位球备注',
    finalRating: '最终评分',
    gameNotesPlaceholder: '输入与比赛相关的描述性备注或评论',
    analyFilters: '分析过滤器',
    avgPotentialTooltip: '基于您可见的分析潜力的平均值',
    potential: '潜在的',
    tags: '标签',
    tagsPlaceholder: '添加一些标签',
    tagsHint: '输入并按 Enter 添加标签',
    exampleTags: {
      leadership: '领导',
      resilience: '弹力',
      competitiveMindset: '竞争心态',
      calmUnderPressure: '压力下保持冷静',
      focus: '重点',
      discipline: '纪律',
      coachability: '可教练性',
      poorBodyLanguage: '肢体语言不佳',
      lowConfidence: '信心度低',
      easilyFrustrated: '容易沮丧'
    }
  },
  addPlayerForm: {
    noLeague: '在没有联赛的情况下创建球队可能会对其在应用程序内的索引和后续搜索产生负面影响。'
  },
  expenses: {
    expense: '费用',
    expenses: '费用',
    addExpense: '添加费用',
    transportation: '交通',
    accommodation: '住宿',
    dietary: '饮食',
    eventTicket: '活动票',
    expenseType: '费用类型',
    amount: '金额',
    expenseDate: '费用日期',
    expenseFilters: '费用过滤器',
    noData: '没有数据。开始添加一些费用吧！',
    deleteExpense: '删除费用',
    deleteExpenseMessage: '费用将被永久删除。确定吗？'
  },
  disabledTooltips: {
    general: '此功能当前已禁用',
    youth: '必须是青年球员才能设置年龄',
    unit: '统计必须是Runs、HSR或SPR',
    seasonsWithout60MinsGames: '选定赛季中,球员未曾单场比赛出场超过60分钟',
    notEditable: '此项不可编辑',
    noMatchdate: '比赛日期不可用',
    selectGame: '请先选择一场比赛',
    selectPlayer: '请先选择一名球员',
    selectTeam: '请先选择一支球队',
    selectBoxes: '必须选择方块可视化',
    selectYear: '请先选择一个年份',
    pdScoreNotAvailable: '比赛中出场时间未达60分钟的球员无法获得评分',
    pdSeasonNotAvailable: '本赛季暂无身体数据',
    pdGameNotAvailable: '本场比赛暂无身体数据'
  },
  leagueTypes: {
    regular: '常规赛',
    continental: '洲际',
    nationalTeam: '国家队',
    countryCup: '国内杯赛',
    qualifier: '资格赛',
    playOff: '季后赛',
    regionalLeague: '区域联赛',
    friendly: '友谊赛',
    nationalFriendly: '国家友谊赛',
    nationaQualifier: '国家资格赛'
  },
  playerSides: {
    'Left/Right': '左/右',
    'Left/Centre/Right': '左/中/右',
    Right: '右',
    Centre: '中',
    'Centre/Right': '中/右',
    Left: '左',
    'Left/Centre': '左/中'
  },
  areaSelector: {
    selectAreas: '选择区域',
    filterAreas: '筛选区域'
  },
  spatialCoverage: {
    lastDefenderDist: '最后防守者距离',
    defensiveLineDist: '防守线距离',
    fullBackAvgDist: '平均横向距离',
    offensiveLineDist: '进攻线距离',
    distanceToGoal: '距离目标的距离',
    avgLineWidth: '平均线宽',
    leagueAvgDistanceToGoal: '联赛平均球门距离',
    leagueAvgLineWidth: '联赛平均线宽',
    avgShort: '平均',
    meters: '米',
    leagueAvgDist: '平均联赛距离',
    distance: '距离',
    avgPositionYAxis: '场上平均距离 (Y)',
    leagueAvgPositionYAxis: '联赛场上平均距离 (Y)',
    lbRbDistanceSeparation: 'LB–RB 距离',
    leagueAvgLbRbDistanceSeparation: '联赛平均 LB–RB 距离',
    legendTeam: '球队',
    legendLeagueAvg: '联赛平均',
    maxLength: '最大长度',
    maxWidth: '最大宽度',
    avgBlockDistance: '平均。区块距离'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: '智能数据',
    passesUnderPressureSubtitle: '分析防守压力下的传球成功率',
    onBallPressureSubtitle: '分析防守压力事件及其成功率按球场区域',
    ballReceiptsInSpaceSubtitle: '按场区分析太空中收到的传球',
    ballReceipts: '收据',
    totalBallReceipts: '总接球',
    totalBallReceiptsCompleted: '总接球完成',
    completed: '完成',
    lineBreakingPassesSubtitle: '分析打破防线并创造优势的传球',
    bypassed: '绕过',
    oppsBypassed: '对手被彻底击败',
    passer: '传球者',
    passedTo: '传给',
    receivedFrom: '收到来自',
    distanceToNearestDefender: '距离最近防守者的距离',
    lineBreaking: '换行符 {0}',
    keyPass: 'KeyPass',
    receiver: '接收者',
    dynamicTracking: '动态跟踪',
    eventLockTooltip: '部分球员在比赛中不可见',
    bypassedPlayers: '突破了{0}名球员',
    playersCount: '{0}名球员',
    bothTeams: '两队',
    matchesCount: '{0}场比赛',
    lbpType: {
      F: '前锋线',
      M: '中场线',
      B: '后防线',
      MF: '中场线和前锋线',
      BM: '后防线和中场线',
      BF: '后防线和前锋线',
      BMF: '后防线、中场线和前锋线'
    },
    lbpCategory: {
      'G-IN-T': '地面内侧（突破防线）',
      'G-IN-NT': '地面内侧（未突破防线）',
      'G-OUT-T': '地面外侧（突破防线）',
      'G-OUT-NT': '地面外侧（未突破防线）',
      'O-IN-T': '高空内侧（突破防线）',
      'O-IN-NT': '高空内侧（未突破防线）',
      'O-OUT-T': '高空外侧（突破防线）',
      'O-OUT-NT': '高空外侧（未突破防线）',
      ground: '地面传球',
      over: '高空传球',
      inside: '内侧',
      outside: '外侧',
      through: '突破防线',
      notThrough: '未突破防线',
      throughAbbr: '打破防御。线',
      notThroughAbbr: '不打破防御。线'
    },
    lbpCategorySplit: {
      G: '地面传球：传球为地面球',
      O: '空中传球：传球为空中传球',
      OUT: '外侧传球：传球向外侧移动',
      IN: '内侧传球：传球向内侧移动',
      T: '突破防线：传球从内侧直接破坏防线（破线）',
      NT: '未突破防线：传球未从内侧破线；从外侧绕过'
    },
    obrType: {
      OL: '重叠',
      UL: '下搭',
      RA: '跑在前面',
      RB: '跑在后面',
      CR: '接球手交叉',
      SP: '支援',
      CS: '接球手接球距离太短'
    },
    visualization: '可视化',
    points: '圆圈',
    zones: '热力图',
    pressureIntensity: '压力强度',
    pressureOutcome: '压力结果',
    passesOutcome: '通过结果',
    strong: '强',
    light: '轻',
    normal: '正常',
    successful: '成功',
    unsuccessful: '不成功',
    presses: '压力',
    passes: '通行证',
    passUnder: '从下面穿过',
    successRate: '成功率',
    pressureOn: '压力在',
    pressureOf: '的压力',
    pressure: '压力',
    totalLabel: '总共',
    totalPasses: '总通过次数',
    unknown: '未知',
    selectGameToViewMap: '选择一场比赛以查看压力地图',
    noEventsFoundForGame: '没有找到这场比赛的压力事件',
    noEventsFoundForTeamAndSeason: '没有找到这支球队和赛季的压力事件',
    noEventsFoundForPlayerAndSeason: '没有找到这名球员和赛季的压力事件',
    noEventsMatchFilters: '没有找到符合当前过滤器的事件',
    totalEventsAvailable: '总共的事件数量',
    passType: {
      P: '经过',
      A: '协助',
      KP: '钥匙通行证',
      PiOB: '进入奥普。盒子',
      PiFT: '进入最后三区',
      SoPP: '游戏通行证切换'
    },
    minFrom: '分钟从',
    minTo: '敏涛',
    secondFrom: '分段从',
    secondTo: '分段至',
    positionPlayed: '出场位置',
    highlight: '强调',
    passTypeLabel: '通行证类型',
    offBallRunSubtitle: '分析无球跑动',
    insights: '见解',
    insightsSubtitle: '利用高级 Arrigo 分析排名最佳',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: '今天我能为您提供什么帮助？',
    chatSubtext: '询问任何有关足球数据的问题！',
    thinking: '思维...',
    giveFeedback: '提供反馈',
    disclaimer: 'DriblabAI 可能会犯错误。请务必核实信息。',
    recent: '最近的',
    noConversations: '在这里您将看到您最近的对话！',
    rename: '重命名',
    deleteConversation: '删除对话',
    confirmDelete: '您确定要删除此对话吗？',
    feedback: '反馈',
    feedbackQuestion: '此回复有帮助吗？',
    feedbackComments: '附加评论',
    feedbackPlaceholder: '告诉我们什么是有帮助的或什么可以改进......',
    errorMessage: '无法处理该消息。请再试一次。',
    newConversation: '新聊天',
    write: '写留言...'
  },
  periodId: {
    1: '上半场',
    2: '下半场',
    3: '加时赛 - 1°',
    4: '加时赛 - 2°',
    5: '点球大战',
    6: '全职',
    7: '赛前',
    8: '弃',
    9: '居住',
    10: '0-15',
    11: '16-30日',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': '其他'
  }
};



// WEBPACK FOOTER //
// ./src/utils/translations/cn.js